var WattstoneConfigurator = (() => {
    var Fd = Object.create,
        Xr = Object.defineProperty,
        bd = Object.getOwnPropertyDescriptor,
        Bd = Object.getOwnPropertyNames,
        jd = Object.getPrototypeOf,
        Ud = Object.prototype.hasOwnProperty,
        kt = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports),
        Hd = (e, t) => {
            for (var n in t) Xr(e, n, { get: t[n], enumerable: !0 });
        },
        Us = (e, t, n, r) => {
            if ((t && typeof t == "object") || typeof t == "function")
                for (let i of Bd(t))
                    !Ud.call(e, i) &&
                        i !== n &&
                        Xr(e, i, { get: () => t[i], enumerable: !(r = bd(t, i)) || r.enumerable });
            return e;
        },
        nn = (e, t, n) => (
            (n = e != null ? Fd(jd(e)) : {}),
            Us(t || !e || !e.__esModule ? Xr(n, "default", { value: e, enumerable: !0 }) : n, e)
        ),
        qd = (e) => Us(Xr({}, "__esModule", { value: !0 }), e),
        tu = kt((F) => {
            "use strict";
            var nr = Symbol.for("react.element"),
                Kd = Symbol.for("react.portal"),
                Gd = Symbol.for("react.fragment"),
                $d = Symbol.for("react.strict_mode"),
                Qd = Symbol.for("react.profiler"),
                Zd = Symbol.for("react.provider"),
                Xd = Symbol.for("react.context"),
                Yd = Symbol.for("react.forward_ref"),
                Jd = Symbol.for("react.suspense"),
                ef = Symbol.for("react.memo"),
                tf = Symbol.for("react.lazy"),
                Hs = Symbol.iterator;
            function nf(e) {
                return e === null || typeof e != "object"
                    ? null
                    : ((e = (Hs && e[Hs]) || e["@@iterator"]), typeof e == "function" ? e : null);
            }
            var Gs = {
                    isMounted: function () {
                        return !1;
                    },
                    enqueueForceUpdate: function () {},
                    enqueueReplaceState: function () {},
                    enqueueSetState: function () {},
                },
                $s = Object.assign,
                Qs = {};
            function Sn(e, t, n) {
                (this.props = e), (this.context = t), (this.refs = Qs), (this.updater = n || Gs);
            }
            (Sn.prototype.isReactComponent = {}),
                (Sn.prototype.setState = function (e, t) {
                    if (typeof e != "object" && typeof e != "function" && e != null)
                        throw Error(
                            "setState(...): takes an object of state variables to update or a function which returns an object of state variables."
                        );
                    this.updater.enqueueSetState(this, e, t, "setState");
                }),
                (Sn.prototype.forceUpdate = function (e) {
                    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
                });
            function Zs() {}
            Zs.prototype = Sn.prototype;
            function _l(e, t, n) {
                (this.props = e), (this.context = t), (this.refs = Qs), (this.updater = n || Gs);
            }
            var xl = (_l.prototype = new Zs());
            (xl.constructor = _l), $s(xl, Sn.prototype), (xl.isPureReactComponent = !0);
            var qs = Array.isArray,
                Xs = Object.prototype.hasOwnProperty,
                zl = { current: null },
                Ys = { key: !0, ref: !0, __self: !0, __source: !0 };
            function Js(e, t, n) {
                var r,
                    i = {},
                    l = null,
                    o = null;
                if (t != null)
                    for (r in (t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (l = "" + t.key), t))
                        Xs.call(t, r) && !Ys.hasOwnProperty(r) && (i[r] = t[r]);
                var u = arguments.length - 2;
                if (u === 1) i.children = n;
                else if (1 < u) {
                    for (var a = Array(u), c = 0; c < u; c++) a[c] = arguments[c + 2];
                    i.children = a;
                }
                if (e && e.defaultProps) for (r in ((u = e.defaultProps), u)) i[r] === void 0 && (i[r] = u[r]);
                return { $$typeof: nr, type: e, key: l, ref: o, props: i, _owner: zl.current };
            }
            function rf(e, t) {
                return { $$typeof: nr, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
            }
            function El(e) {
                return typeof e == "object" && e !== null && e.$$typeof === nr;
            }
            function lf(e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                    "$" +
                    e.replace(/[=:]/g, function (n) {
                        return t[n];
                    })
                );
            }
            var Ks = /\/+/g;
            function Sl(e, t) {
                return typeof e == "object" && e !== null && e.key != null ? lf("" + e.key) : t.toString(36);
            }
            function Jr(e, t, n, r, i) {
                var l = typeof e;
                (l === "undefined" || l === "boolean") && (e = null);
                var o = !1;
                if (e === null) o = !0;
                else
                    switch (l) {
                        case "string":
                        case "number":
                            o = !0;
                            break;
                        case "object":
                            switch (e.$$typeof) {
                                case nr:
                                case Kd:
                                    o = !0;
                            }
                    }
                if (o)
                    return (
                        (o = e),
                        (i = i(o)),
                        (e = r === "" ? "." + Sl(o, 0) : r),
                        qs(i)
                            ? ((n = ""),
                              e != null && (n = e.replace(Ks, "$&/") + "/"),
                              Jr(i, t, n, "", function (c) {
                                  return c;
                              }))
                            : i != null &&
                              (El(i) &&
                                  (i = rf(
                                      i,
                                      n +
                                          (!i.key || (o && o.key === i.key)
                                              ? ""
                                              : ("" + i.key).replace(Ks, "$&/") + "/") +
                                          e
                                  )),
                              t.push(i)),
                        1
                    );
                if (((o = 0), (r = r === "" ? "." : r + ":"), qs(e)))
                    for (var u = 0; u < e.length; u++) {
                        l = e[u];
                        var a = r + Sl(l, u);
                        o += Jr(l, t, n, a, i);
                    }
                else if (((a = nf(e)), typeof a == "function"))
                    for (e = a.call(e), u = 0; !(l = e.next()).done; )
                        (l = l.value), (a = r + Sl(l, u++)), (o += Jr(l, t, n, a, i));
                else if (l === "object")
                    throw (
                        ((t = String(e)),
                        Error(
                            "Objects are not valid as a React child (found: " +
                                (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) +
                                "). If you meant to render a collection of children, use an array instead."
                        ))
                    );
                return o;
            }
            function Yr(e, t, n) {
                if (e == null) return e;
                var r = [],
                    i = 0;
                return (
                    Jr(e, r, "", "", function (l) {
                        return t.call(n, l, i++);
                    }),
                    r
                );
            }
            function of(e) {
                if (e._status === -1) {
                    var t = e._result;
                    (t = t()),
                        t.then(
                            function (n) {
                                (e._status === 0 || e._status === -1) && ((e._status = 1), (e._result = n));
                            },
                            function (n) {
                                (e._status === 0 || e._status === -1) && ((e._status = 2), (e._result = n));
                            }
                        ),
                        e._status === -1 && ((e._status = 0), (e._result = t));
                }
                if (e._status === 1) return e._result.default;
                throw e._result;
            }
            var Te = { current: null },
                ei = { transition: null },
                sf = { ReactCurrentDispatcher: Te, ReactCurrentBatchConfig: ei, ReactCurrentOwner: zl };
            function eu() {
                throw Error("act(...) is not supported in production builds of React.");
            }
            (F.Children = {
                map: Yr,
                forEach: function (e, t, n) {
                    Yr(
                        e,
                        function () {
                            t.apply(this, arguments);
                        },
                        n
                    );
                },
                count: function (e) {
                    var t = 0;
                    return (
                        Yr(e, function () {
                            t++;
                        }),
                        t
                    );
                },
                toArray: function (e) {
                    return (
                        Yr(e, function (t) {
                            return t;
                        }) || []
                    );
                },
                only: function (e) {
                    if (!El(e)) throw Error("React.Children.only expected to receive a single React element child.");
                    return e;
                },
            }),
                (F.Component = Sn),
                (F.Fragment = Gd),
                (F.Profiler = Qd),
                (F.PureComponent = _l),
                (F.StrictMode = $d),
                (F.Suspense = Jd),
                (F.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sf),
                (F.act = eu),
                (F.cloneElement = function (e, t, n) {
                    if (e == null)
                        throw Error(
                            "React.cloneElement(...): The argument must be a React element, but you passed " + e + "."
                        );
                    var r = $s({}, e.props),
                        i = e.key,
                        l = e.ref,
                        o = e._owner;
                    if (t != null) {
                        if (
                            (t.ref !== void 0 && ((l = t.ref), (o = zl.current)),
                            t.key !== void 0 && (i = "" + t.key),
                            e.type && e.type.defaultProps)
                        )
                            var u = e.type.defaultProps;
                        for (a in t)
                            Xs.call(t, a) &&
                                !Ys.hasOwnProperty(a) &&
                                (r[a] = t[a] === void 0 && u !== void 0 ? u[a] : t[a]);
                    }
                    var a = arguments.length - 2;
                    if (a === 1) r.children = n;
                    else if (1 < a) {
                        u = Array(a);
                        for (var c = 0; c < a; c++) u[c] = arguments[c + 2];
                        r.children = u;
                    }
                    return { $$typeof: nr, type: e.type, key: i, ref: l, props: r, _owner: o };
                }),
                (F.createContext = function (e) {
                    return (
                        (e = {
                            $$typeof: Xd,
                            _currentValue: e,
                            _currentValue2: e,
                            _threadCount: 0,
                            Provider: null,
                            Consumer: null,
                            _defaultValue: null,
                            _globalName: null,
                        }),
                        (e.Provider = { $$typeof: Zd, _context: e }),
                        (e.Consumer = e)
                    );
                }),
                (F.createElement = Js),
                (F.createFactory = function (e) {
                    var t = Js.bind(null, e);
                    return (t.type = e), t;
                }),
                (F.createRef = function () {
                    return { current: null };
                }),
                (F.forwardRef = function (e) {
                    return { $$typeof: Yd, render: e };
                }),
                (F.isValidElement = El),
                (F.lazy = function (e) {
                    return { $$typeof: tf, _payload: { _status: -1, _result: e }, _init: of };
                }),
                (F.memo = function (e, t) {
                    return { $$typeof: ef, type: e, compare: t === void 0 ? null : t };
                }),
                (F.startTransition = function (e) {
                    var t = ei.transition;
                    ei.transition = {};
                    try {
                        e();
                    } finally {
                        ei.transition = t;
                    }
                }),
                (F.unstable_act = eu),
                (F.useCallback = function (e, t) {
                    return Te.current.useCallback(e, t);
                }),
                (F.useContext = function (e) {
                    return Te.current.useContext(e);
                }),
                (F.useDebugValue = function () {}),
                (F.useDeferredValue = function (e) {
                    return Te.current.useDeferredValue(e);
                }),
                (F.useEffect = function (e, t) {
                    return Te.current.useEffect(e, t);
                }),
                (F.useId = function () {
                    return Te.current.useId();
                }),
                (F.useImperativeHandle = function (e, t, n) {
                    return Te.current.useImperativeHandle(e, t, n);
                }),
                (F.useInsertionEffect = function (e, t) {
                    return Te.current.useInsertionEffect(e, t);
                }),
                (F.useLayoutEffect = function (e, t) {
                    return Te.current.useLayoutEffect(e, t);
                }),
                (F.useMemo = function (e, t) {
                    return Te.current.useMemo(e, t);
                }),
                (F.useReducer = function (e, t, n) {
                    return Te.current.useReducer(e, t, n);
                }),
                (F.useRef = function (e) {
                    return Te.current.useRef(e);
                }),
                (F.useState = function (e) {
                    return Te.current.useState(e);
                }),
                (F.useSyncExternalStore = function (e, t, n) {
                    return Te.current.useSyncExternalStore(e, t, n);
                }),
                (F.useTransition = function () {
                    return Te.current.useTransition();
                }),
                (F.version = "18.3.1");
        }),
        rr = kt((Mh, nu) => {
            "use strict";
            nu.exports = tu();
        }),
        fu = kt((q) => {
            "use strict";
            function Tl(e, t) {
                var n = e.length;
                e.push(t);
                e: for (; 0 < n; ) {
                    var r = (n - 1) >>> 1,
                        i = e[r];
                    if (0 < ti(i, t)) (e[r] = t), (e[n] = i), (n = r);
                    else break e;
                }
            }
            function Je(e) {
                return e.length === 0 ? null : e[0];
            }
            function ri(e) {
                if (e.length === 0) return null;
                var t = e[0],
                    n = e.pop();
                if (n !== t) {
                    e[0] = n;
                    e: for (var r = 0, i = e.length, l = i >>> 1; r < l; ) {
                        var o = 2 * (r + 1) - 1,
                            u = e[o],
                            a = o + 1,
                            c = e[a];
                        if (0 > ti(u, n))
                            a < i && 0 > ti(c, u)
                                ? ((e[r] = c), (e[a] = n), (r = a))
                                : ((e[r] = u), (e[o] = n), (r = o));
                        else if (a < i && 0 > ti(c, n)) (e[r] = c), (e[a] = n), (r = a);
                        else break e;
                    }
                }
                return t;
            }
            function ti(e, t) {
                var n = e.sortIndex - t.sortIndex;
                return n !== 0 ? n : e.id - t.id;
            }
            typeof performance == "object" && typeof performance.now == "function"
                ? ((ru = performance),
                  (q.unstable_now = function () {
                      return ru.now();
                  }))
                : ((Pl = Date),
                  (iu = Pl.now()),
                  (q.unstable_now = function () {
                      return Pl.now() - iu;
                  }));
            var ru,
                Pl,
                iu,
                dt = [],
                Lt = [],
                uf = 1,
                Ke = null,
                ze = 3,
                ii = !1,
                rn = !1,
                lr = !1,
                su = typeof setTimeout == "function" ? setTimeout : null,
                uu = typeof clearTimeout == "function" ? clearTimeout : null,
                lu = typeof setImmediate < "u" ? setImmediate : null;
            typeof navigator < "u" &&
                navigator.scheduling !== void 0 &&
                navigator.scheduling.isInputPending !== void 0 &&
                navigator.scheduling.isInputPending.bind(navigator.scheduling);
            function Il(e) {
                for (var t = Je(Lt); t !== null; ) {
                    if (t.callback === null) ri(Lt);
                    else if (t.startTime <= e) ri(Lt), (t.sortIndex = t.expirationTime), Tl(dt, t);
                    else break;
                    t = Je(Lt);
                }
            }
            function Nl(e) {
                if (((lr = !1), Il(e), !rn))
                    if (Je(dt) !== null) (rn = !0), Wl(Ll);
                    else {
                        var t = Je(Lt);
                        t !== null && Vl(Nl, t.startTime - e);
                    }
            }
            function Ll(e, t) {
                (rn = !1), lr && ((lr = !1), uu(or), (or = -1)), (ii = !0);
                var n = ze;
                try {
                    for (Il(t), Ke = Je(dt); Ke !== null && (!(Ke.expirationTime > t) || (e && !du())); ) {
                        var r = Ke.callback;
                        if (typeof r == "function") {
                            (Ke.callback = null), (ze = Ke.priorityLevel);
                            var i = r(Ke.expirationTime <= t);
                            (t = q.unstable_now()),
                                typeof i == "function" ? (Ke.callback = i) : Ke === Je(dt) && ri(dt),
                                Il(t);
                        } else ri(dt);
                        Ke = Je(dt);
                    }
                    if (Ke !== null) var l = !0;
                    else {
                        var o = Je(Lt);
                        o !== null && Vl(Nl, o.startTime - t), (l = !1);
                    }
                    return l;
                } finally {
                    (Ke = null), (ze = n), (ii = !1);
                }
            }
            var li = !1,
                ni = null,
                or = -1,
                au = 5,
                cu = -1;
            function du() {
                return !(q.unstable_now() - cu < au);
            }
            function Cl() {
                if (ni !== null) {
                    var e = q.unstable_now();
                    cu = e;
                    var t = !0;
                    try {
                        t = ni(!0, e);
                    } finally {
                        t ? ir() : ((li = !1), (ni = null));
                    }
                } else li = !1;
            }
            var ir;
            typeof lu == "function"
                ? (ir = function () {
                      lu(Cl);
                  })
                : typeof MessageChannel < "u"
                  ? ((Ml = new MessageChannel()),
                    (ou = Ml.port2),
                    (Ml.port1.onmessage = Cl),
                    (ir = function () {
                        ou.postMessage(null);
                    }))
                  : (ir = function () {
                        su(Cl, 0);
                    });
            var Ml, ou;
            function Wl(e) {
                (ni = e), li || ((li = !0), ir());
            }
            function Vl(e, t) {
                or = su(function () {
                    e(q.unstable_now());
                }, t);
            }
            (q.unstable_IdlePriority = 5),
                (q.unstable_ImmediatePriority = 1),
                (q.unstable_LowPriority = 4),
                (q.unstable_NormalPriority = 3),
                (q.unstable_Profiling = null),
                (q.unstable_UserBlockingPriority = 2),
                (q.unstable_cancelCallback = function (e) {
                    e.callback = null;
                }),
                (q.unstable_continueExecution = function () {
                    rn || ii || ((rn = !0), Wl(Ll));
                }),
                (q.unstable_forceFrameRate = function (e) {
                    0 > e || 125 < e
                        ? console.error(
                              "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                          )
                        : (au = 0 < e ? Math.floor(1e3 / e) : 5);
                }),
                (q.unstable_getCurrentPriorityLevel = function () {
                    return ze;
                }),
                (q.unstable_getFirstCallbackNode = function () {
                    return Je(dt);
                }),
                (q.unstable_next = function (e) {
                    switch (ze) {
                        case 1:
                        case 2:
                        case 3:
                            var t = 3;
                            break;
                        default:
                            t = ze;
                    }
                    var n = ze;
                    ze = t;
                    try {
                        return e();
                    } finally {
                        ze = n;
                    }
                }),
                (q.unstable_pauseExecution = function () {}),
                (q.unstable_requestPaint = function () {}),
                (q.unstable_runWithPriority = function (e, t) {
                    switch (e) {
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        default:
                            e = 3;
                    }
                    var n = ze;
                    ze = e;
                    try {
                        return t();
                    } finally {
                        ze = n;
                    }
                }),
                (q.unstable_scheduleCallback = function (e, t, n) {
                    var r = q.unstable_now();
                    switch (
                        (typeof n == "object" && n !== null
                            ? ((n = n.delay), (n = typeof n == "number" && 0 < n ? r + n : r))
                            : (n = r),
                        e)
                    ) {
                        case 1:
                            var i = -1;
                            break;
                        case 2:
                            i = 250;
                            break;
                        case 5:
                            i = 1073741823;
                            break;
                        case 4:
                            i = 1e4;
                            break;
                        default:
                            i = 5e3;
                    }
                    return (
                        (i = n + i),
                        (e = {
                            id: uf++,
                            callback: t,
                            priorityLevel: e,
                            startTime: n,
                            expirationTime: i,
                            sortIndex: -1,
                        }),
                        n > r
                            ? ((e.sortIndex = n),
                              Tl(Lt, e),
                              Je(dt) === null && e === Je(Lt) && (lr ? (uu(or), (or = -1)) : (lr = !0), Vl(Nl, n - r)))
                            : ((e.sortIndex = i), Tl(dt, e), rn || ii || ((rn = !0), Wl(Ll))),
                        e
                    );
                }),
                (q.unstable_shouldYield = du),
                (q.unstable_wrapCallback = function (e) {
                    var t = ze;
                    return function () {
                        var n = ze;
                        ze = t;
                        try {
                            return e.apply(this, arguments);
                        } finally {
                            ze = n;
                        }
                    };
                });
        }),
        hu = kt((Ih, pu) => {
            "use strict";
            pu.exports = fu();
        }),
        yd = kt((Ue) => {
            "use strict";
            var af = rr(),
                Be = hu();
            function S(e) {
                for (
                    var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1;
                    n < arguments.length;
                    n++
                )
                    t += "&args[]=" + encodeURIComponent(arguments[n]);
                return (
                    "Minified React error #" +
                    e +
                    "; visit " +
                    t +
                    " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
                );
            }
            var Sa = new Set(),
                Mr = {};
            function vn(e, t) {
                jn(e, t), jn(e + "Capture", t);
            }
            function jn(e, t) {
                for (Mr[e] = t, e = 0; e < t.length; e++) Sa.add(t[e]);
            }
            var Pt = !(
                    typeof window > "u" ||
                    typeof window.document > "u" ||
                    typeof window.document.createElement > "u"
                ),
                ro = Object.prototype.hasOwnProperty,
                cf =
                    /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
                mu = {},
                gu = {};
            function df(e) {
                return ro.call(gu, e) ? !0 : ro.call(mu, e) ? !1 : cf.test(e) ? (gu[e] = !0) : ((mu[e] = !0), !1);
            }
            function ff(e, t, n, r) {
                if (n !== null && n.type === 0) return !1;
                switch (typeof t) {
                    case "function":
                    case "symbol":
                        return !0;
                    case "boolean":
                        return r
                            ? !1
                            : n !== null
                              ? !n.acceptsBooleans
                              : ((e = e.toLowerCase().slice(0, 5)), e !== "data-" && e !== "aria-");
                    default:
                        return !1;
                }
            }
            function pf(e, t, n, r) {
                if (t === null || typeof t > "u" || ff(e, t, n, r)) return !0;
                if (r) return !1;
                if (n !== null)
                    switch (n.type) {
                        case 3:
                            return !t;
                        case 4:
                            return t === !1;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                return !1;
            }
            function Le(e, t, n, r, i, l, o) {
                (this.acceptsBooleans = t === 2 || t === 3 || t === 4),
                    (this.attributeName = r),
                    (this.attributeNamespace = i),
                    (this.mustUseProperty = n),
                    (this.propertyName = e),
                    (this.type = t),
                    (this.sanitizeURL = l),
                    (this.removeEmptyString = o);
            }
            var Se = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
                .split(" ")
                .forEach(function (e) {
                    Se[e] = new Le(e, 0, !1, e, null, !1, !1);
                }),
                [
                    ["acceptCharset", "accept-charset"],
                    ["className", "class"],
                    ["htmlFor", "for"],
                    ["httpEquiv", "http-equiv"],
                ].forEach(function (e) {
                    var t = e[0];
                    Se[t] = new Le(t, 1, !1, e[1], null, !1, !1);
                }),
                ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
                    Se[e] = new Le(e, 2, !1, e.toLowerCase(), null, !1, !1);
                }),
                ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
                    Se[e] = new Le(e, 2, !1, e, null, !1, !1);
                }),
                "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
                    .split(" ")
                    .forEach(function (e) {
                        Se[e] = new Le(e, 3, !1, e.toLowerCase(), null, !1, !1);
                    }),
                ["checked", "multiple", "muted", "selected"].forEach(function (e) {
                    Se[e] = new Le(e, 3, !0, e, null, !1, !1);
                }),
                ["capture", "download"].forEach(function (e) {
                    Se[e] = new Le(e, 4, !1, e, null, !1, !1);
                }),
                ["cols", "rows", "size", "span"].forEach(function (e) {
                    Se[e] = new Le(e, 6, !1, e, null, !1, !1);
                }),
                ["rowSpan", "start"].forEach(function (e) {
                    Se[e] = new Le(e, 5, !1, e.toLowerCase(), null, !1, !1);
                });
            var Zo = /[\-:]([a-z])/g;
            function Xo(e) {
                return e[1].toUpperCase();
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
                .split(" ")
                .forEach(function (e) {
                    var t = e.replace(Zo, Xo);
                    Se[t] = new Le(t, 1, !1, e, null, !1, !1);
                }),
                "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
                    .split(" ")
                    .forEach(function (e) {
                        var t = e.replace(Zo, Xo);
                        Se[t] = new Le(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
                    }),
                ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
                    var t = e.replace(Zo, Xo);
                    Se[t] = new Le(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
                }),
                ["tabIndex", "crossOrigin"].forEach(function (e) {
                    Se[e] = new Le(e, 1, !1, e.toLowerCase(), null, !1, !1);
                }),
                (Se.xlinkHref = new Le("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1)),
                ["src", "href", "action", "formAction"].forEach(function (e) {
                    Se[e] = new Le(e, 1, !1, e.toLowerCase(), null, !0, !0);
                });
            function Yo(e, t, n, r) {
                var i = Se.hasOwnProperty(t) ? Se[t] : null;
                (i !== null
                    ? i.type !== 0
                    : r || !(2 < t.length) || (t[0] !== "o" && t[0] !== "O") || (t[1] !== "n" && t[1] !== "N")) &&
                    (pf(t, n, i, r) && (n = null),
                    r || i === null
                        ? df(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
                        : i.mustUseProperty
                          ? (e[i.propertyName] = n === null ? (i.type === 3 ? !1 : "") : n)
                          : ((t = i.attributeName),
                            (r = i.attributeNamespace),
                            n === null
                                ? e.removeAttribute(t)
                                : ((i = i.type),
                                  (n = i === 3 || (i === 4 && n === !0) ? "" : "" + n),
                                  r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
            }
            var It = af.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
                oi = Symbol.for("react.element"),
                zn = Symbol.for("react.portal"),
                En = Symbol.for("react.fragment"),
                Jo = Symbol.for("react.strict_mode"),
                io = Symbol.for("react.profiler"),
                _a = Symbol.for("react.provider"),
                xa = Symbol.for("react.context"),
                es = Symbol.for("react.forward_ref"),
                lo = Symbol.for("react.suspense"),
                oo = Symbol.for("react.suspense_list"),
                ts = Symbol.for("react.memo"),
                Vt = Symbol.for("react.lazy");
            Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
            var za = Symbol.for("react.offscreen");
            Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
            var vu = Symbol.iterator;
            function sr(e) {
                return e === null || typeof e != "object"
                    ? null
                    : ((e = (vu && e[vu]) || e["@@iterator"]), typeof e == "function" ? e : null);
            }
            var le = Object.assign,
                Rl;
            function mr(e) {
                if (Rl === void 0)
                    try {
                        throw Error();
                    } catch (n) {
                        var t = n.stack.trim().match(/\n( *(at )?)/);
                        Rl = (t && t[1]) || "";
                    }
                return (
                    `
` +
                    Rl +
                    e
                );
            }
            var Dl = !1;
            function Ol(e, t) {
                if (!e || Dl) return "";
                Dl = !0;
                var n = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (t)
                        if (
                            ((t = function () {
                                throw Error();
                            }),
                            Object.defineProperty(t.prototype, "props", {
                                set: function () {
                                    throw Error();
                                },
                            }),
                            typeof Reflect == "object" && Reflect.construct)
                        ) {
                            try {
                                Reflect.construct(t, []);
                            } catch (c) {
                                var r = c;
                            }
                            Reflect.construct(e, [], t);
                        } else {
                            try {
                                t.call();
                            } catch (c) {
                                r = c;
                            }
                            e.call(t.prototype);
                        }
                    else {
                        try {
                            throw Error();
                        } catch (c) {
                            r = c;
                        }
                        e();
                    }
                } catch (c) {
                    if (c && r && typeof c.stack == "string") {
                        for (
                            var i = c.stack.split(`
`),
                                l = r.stack.split(`
`),
                                o = i.length - 1,
                                u = l.length - 1;
                            1 <= o && 0 <= u && i[o] !== l[u];

                        )
                            u--;
                        for (; 1 <= o && 0 <= u; o--, u--)
                            if (i[o] !== l[u]) {
                                if (o !== 1 || u !== 1)
                                    do
                                        if ((o--, u--, 0 > u || i[o] !== l[u])) {
                                            var a =
                                                `
` + i[o].replace(" at new ", " at ");
                                            return (
                                                e.displayName &&
                                                    a.includes("<anonymous>") &&
                                                    (a = a.replace("<anonymous>", e.displayName)),
                                                a
                                            );
                                        }
                                    while (1 <= o && 0 <= u);
                                break;
                            }
                    }
                } finally {
                    (Dl = !1), (Error.prepareStackTrace = n);
                }
                return (e = e ? e.displayName || e.name : "") ? mr(e) : "";
            }
            function hf(e) {
                switch (e.tag) {
                    case 5:
                        return mr(e.type);
                    case 16:
                        return mr("Lazy");
                    case 13:
                        return mr("Suspense");
                    case 19:
                        return mr("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return (e = Ol(e.type, !1)), e;
                    case 11:
                        return (e = Ol(e.type.render, !1)), e;
                    case 1:
                        return (e = Ol(e.type, !0)), e;
                    default:
                        return "";
                }
            }
            function so(e) {
                if (e == null) return null;
                if (typeof e == "function") return e.displayName || e.name || null;
                if (typeof e == "string") return e;
                switch (e) {
                    case En:
                        return "Fragment";
                    case zn:
                        return "Portal";
                    case io:
                        return "Profiler";
                    case Jo:
                        return "StrictMode";
                    case lo:
                        return "Suspense";
                    case oo:
                        return "SuspenseList";
                }
                if (typeof e == "object")
                    switch (e.$$typeof) {
                        case xa:
                            return (e.displayName || "Context") + ".Consumer";
                        case _a:
                            return (e._context.displayName || "Context") + ".Provider";
                        case es:
                            var t = e.render;
                            return (
                                (e = e.displayName),
                                e ||
                                    ((e = t.displayName || t.name || ""),
                                    (e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")),
                                e
                            );
                        case ts:
                            return (t = e.displayName || null), t !== null ? t : so(e.type) || "Memo";
                        case Vt:
                            (t = e._payload), (e = e._init);
                            try {
                                return so(e(t));
                            } catch {}
                    }
                return null;
            }
            function mf(e) {
                var t = e.type;
                switch (e.tag) {
                    case 24:
                        return "Cache";
                    case 9:
                        return (t.displayName || "Context") + ".Consumer";
                    case 10:
                        return (t._context.displayName || "Context") + ".Provider";
                    case 18:
                        return "DehydratedFragment";
                    case 11:
                        return (
                            (e = t.render),
                            (e = e.displayName || e.name || ""),
                            t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")
                        );
                    case 7:
                        return "Fragment";
                    case 5:
                        return t;
                    case 4:
                        return "Portal";
                    case 3:
                        return "Root";
                    case 6:
                        return "Text";
                    case 16:
                        return so(t);
                    case 8:
                        return t === Jo ? "StrictMode" : "Mode";
                    case 22:
                        return "Offscreen";
                    case 12:
                        return "Profiler";
                    case 21:
                        return "Scope";
                    case 13:
                        return "Suspense";
                    case 19:
                        return "SuspenseList";
                    case 25:
                        return "TracingMarker";
                    case 1:
                    case 0:
                    case 17:
                    case 2:
                    case 14:
                    case 15:
                        if (typeof t == "function") return t.displayName || t.name || null;
                        if (typeof t == "string") return t;
                }
                return null;
            }
            function $t(e) {
                switch (typeof e) {
                    case "boolean":
                    case "number":
                    case "string":
                    case "undefined":
                        return e;
                    case "object":
                        return e;
                    default:
                        return "";
                }
            }
            function Ea(e) {
                var t = e.type;
                return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
            }
            function gf(e) {
                var t = Ea(e) ? "checked" : "value",
                    n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                    r = "" + e[t];
                if (
                    !e.hasOwnProperty(t) &&
                    typeof n < "u" &&
                    typeof n.get == "function" &&
                    typeof n.set == "function"
                ) {
                    var i = n.get,
                        l = n.set;
                    return (
                        Object.defineProperty(e, t, {
                            configurable: !0,
                            get: function () {
                                return i.call(this);
                            },
                            set: function (o) {
                                (r = "" + o), l.call(this, o);
                            },
                        }),
                        Object.defineProperty(e, t, { enumerable: n.enumerable }),
                        {
                            getValue: function () {
                                return r;
                            },
                            setValue: function (o) {
                                r = "" + o;
                            },
                            stopTracking: function () {
                                (e._valueTracker = null), delete e[t];
                            },
                        }
                    );
                }
            }
            function si(e) {
                e._valueTracker || (e._valueTracker = gf(e));
            }
            function Pa(e) {
                if (!e) return !1;
                var t = e._valueTracker;
                if (!t) return !0;
                var n = t.getValue(),
                    r = "";
                return (
                    e && (r = Ea(e) ? (e.checked ? "true" : "false") : e.value),
                    (e = r),
                    e !== n ? (t.setValue(e), !0) : !1
                );
            }
            function Ri(e) {
                if (((e = e || (typeof document < "u" ? document : void 0)), typeof e > "u")) return null;
                try {
                    return e.activeElement || e.body;
                } catch {
                    return e.body;
                }
            }
            function uo(e, t) {
                var n = t.checked;
                return le({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: n ?? e._wrapperState.initialChecked,
                });
            }
            function yu(e, t) {
                var n = t.defaultValue == null ? "" : t.defaultValue,
                    r = t.checked != null ? t.checked : t.defaultChecked;
                (n = $t(t.value != null ? t.value : n)),
                    (e._wrapperState = {
                        initialChecked: r,
                        initialValue: n,
                        controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null,
                    });
            }
            function Ca(e, t) {
                (t = t.checked), t != null && Yo(e, "checked", t, !1);
            }
            function ao(e, t) {
                Ca(e, t);
                var n = $t(t.value),
                    r = t.type;
                if (n != null)
                    r === "number"
                        ? ((n === 0 && e.value === "") || e.value != n) && (e.value = "" + n)
                        : e.value !== "" + n && (e.value = "" + n);
                else if (r === "submit" || r === "reset") {
                    e.removeAttribute("value");
                    return;
                }
                t.hasOwnProperty("value")
                    ? co(e, t.type, n)
                    : t.hasOwnProperty("defaultValue") && co(e, t.type, $t(t.defaultValue)),
                    t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
            }
            function wu(e, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var r = t.type;
                    if (!((r !== "submit" && r !== "reset") || (t.value !== void 0 && t.value !== null))) return;
                    (t = "" + e._wrapperState.initialValue), n || t === e.value || (e.value = t), (e.defaultValue = t);
                }
                (n = e.name),
                    n !== "" && (e.name = ""),
                    (e.defaultChecked = !!e._wrapperState.initialChecked),
                    n !== "" && (e.name = n);
            }
            function co(e, t, n) {
                (t !== "number" || Ri(e.ownerDocument) !== e) &&
                    (n == null
                        ? (e.defaultValue = "" + e._wrapperState.initialValue)
                        : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
            }
            var gr = Array.isArray;
            function Dn(e, t, n, r) {
                if (((e = e.options), t)) {
                    t = {};
                    for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
                    for (n = 0; n < e.length; n++)
                        (i = t.hasOwnProperty("$" + e[n].value)),
                            e[n].selected !== i && (e[n].selected = i),
                            i && r && (e[n].defaultSelected = !0);
                } else {
                    for (n = "" + $t(n), t = null, i = 0; i < e.length; i++) {
                        if (e[i].value === n) {
                            (e[i].selected = !0), r && (e[i].defaultSelected = !0);
                            return;
                        }
                        t !== null || e[i].disabled || (t = e[i]);
                    }
                    t !== null && (t.selected = !0);
                }
            }
            function fo(e, t) {
                if (t.dangerouslySetInnerHTML != null) throw Error(S(91));
                return le({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
            }
            function ku(e, t) {
                var n = t.value;
                if (n == null) {
                    if (((n = t.children), (t = t.defaultValue), n != null)) {
                        if (t != null) throw Error(S(92));
                        if (gr(n)) {
                            if (1 < n.length) throw Error(S(93));
                            n = n[0];
                        }
                        t = n;
                    }
                    t == null && (t = ""), (n = t);
                }
                e._wrapperState = { initialValue: $t(n) };
            }
            function Ma(e, t) {
                var n = $t(t.value),
                    r = $t(t.defaultValue);
                n != null &&
                    ((n = "" + n),
                    n !== e.value && (e.value = n),
                    t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)),
                    r != null && (e.defaultValue = "" + r);
            }
            function Su(e) {
                var t = e.textContent;
                t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
            }
            function Ta(e) {
                switch (e) {
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function po(e, t) {
                return e == null || e === "http://www.w3.org/1999/xhtml"
                    ? Ta(t)
                    : e === "http://www.w3.org/2000/svg" && t === "foreignObject"
                      ? "http://www.w3.org/1999/xhtml"
                      : e;
            }
            var ui,
                Ia = (function (e) {
                    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
                        ? function (t, n, r, i) {
                              MSApp.execUnsafeLocalFunction(function () {
                                  return e(t, n, r, i);
                              });
                          }
                        : e;
                })(function (e, t) {
                    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
                    else {
                        for (
                            ui = ui || document.createElement("div"),
                                ui.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>",
                                t = ui.firstChild;
                            e.firstChild;

                        )
                            e.removeChild(e.firstChild);
                        for (; t.firstChild; ) e.appendChild(t.firstChild);
                    }
                });
            function Tr(e, t) {
                if (t) {
                    var n = e.firstChild;
                    if (n && n === e.lastChild && n.nodeType === 3) {
                        n.nodeValue = t;
                        return;
                    }
                }
                e.textContent = t;
            }
            var wr = {
                    animationIterationCount: !0,
                    aspectRatio: !0,
                    borderImageOutset: !0,
                    borderImageSlice: !0,
                    borderImageWidth: !0,
                    boxFlex: !0,
                    boxFlexGroup: !0,
                    boxOrdinalGroup: !0,
                    columnCount: !0,
                    columns: !0,
                    flex: !0,
                    flexGrow: !0,
                    flexPositive: !0,
                    flexShrink: !0,
                    flexNegative: !0,
                    flexOrder: !0,
                    gridArea: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowSpan: !0,
                    gridRowStart: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnSpan: !0,
                    gridColumnStart: !0,
                    fontWeight: !0,
                    lineClamp: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    tabSize: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                    fillOpacity: !0,
                    floodOpacity: !0,
                    stopOpacity: !0,
                    strokeDasharray: !0,
                    strokeDashoffset: !0,
                    strokeMiterlimit: !0,
                    strokeOpacity: !0,
                    strokeWidth: !0,
                },
                vf = ["Webkit", "ms", "Moz", "O"];
            Object.keys(wr).forEach(function (e) {
                vf.forEach(function (t) {
                    (t = t + e.charAt(0).toUpperCase() + e.substring(1)), (wr[t] = wr[e]);
                });
            });
            function Na(e, t, n) {
                return t == null || typeof t == "boolean" || t === ""
                    ? ""
                    : n || typeof t != "number" || t === 0 || (wr.hasOwnProperty(e) && wr[e])
                      ? ("" + t).trim()
                      : t + "px";
            }
            function La(e, t) {
                e = e.style;
                for (var n in t)
                    if (t.hasOwnProperty(n)) {
                        var r = n.indexOf("--") === 0,
                            i = Na(n, t[n], r);
                        n === "float" && (n = "cssFloat"), r ? e.setProperty(n, i) : (e[n] = i);
                    }
            }
            var yf = le(
                { menuitem: !0 },
                {
                    area: !0,
                    base: !0,
                    br: !0,
                    col: !0,
                    embed: !0,
                    hr: !0,
                    img: !0,
                    input: !0,
                    keygen: !0,
                    link: !0,
                    meta: !0,
                    param: !0,
                    source: !0,
                    track: !0,
                    wbr: !0,
                }
            );
            function ho(e, t) {
                if (t) {
                    if (yf[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(S(137, e));
                    if (t.dangerouslySetInnerHTML != null) {
                        if (t.children != null) throw Error(S(60));
                        if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML))
                            throw Error(S(61));
                    }
                    if (t.style != null && typeof t.style != "object") throw Error(S(62));
                }
            }
            function mo(e, t) {
                if (e.indexOf("-") === -1) return typeof t.is == "string";
                switch (e) {
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            var go = null;
            function ns(e) {
                return (
                    (e = e.target || e.srcElement || window),
                    e.correspondingUseElement && (e = e.correspondingUseElement),
                    e.nodeType === 3 ? e.parentNode : e
                );
            }
            var vo = null,
                On = null,
                An = null;
            function _u(e) {
                if ((e = Gr(e))) {
                    if (typeof vo != "function") throw Error(S(280));
                    var t = e.stateNode;
                    t && ((t = al(t)), vo(e.stateNode, e.type, t));
                }
            }
            function Wa(e) {
                On ? (An ? An.push(e) : (An = [e])) : (On = e);
            }
            function Va() {
                if (On) {
                    var e = On,
                        t = An;
                    if (((An = On = null), _u(e), t)) for (e = 0; e < t.length; e++) _u(t[e]);
                }
            }
            function Ra(e, t) {
                return e(t);
            }
            function Da() {}
            var Al = !1;
            function Oa(e, t, n) {
                if (Al) return e(t, n);
                Al = !0;
                try {
                    return Ra(e, t, n);
                } finally {
                    (Al = !1), (On !== null || An !== null) && (Da(), Va());
                }
            }
            function Ir(e, t) {
                var n = e.stateNode;
                if (n === null) return null;
                var r = al(n);
                if (r === null) return null;
                n = r[t];
                e: switch (t) {
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (r = !r.disabled) ||
                            ((e = e.type),
                            (r = !(e === "button" || e === "input" || e === "select" || e === "textarea"))),
                            (e = !r);
                        break e;
                    default:
                        e = !1;
                }
                if (e) return null;
                if (n && typeof n != "function") throw Error(S(231, t, typeof n));
                return n;
            }
            var yo = !1;
            if (Pt)
                try {
                    (_n = {}),
                        Object.defineProperty(_n, "passive", {
                            get: function () {
                                yo = !0;
                            },
                        }),
                        window.addEventListener("test", _n, _n),
                        window.removeEventListener("test", _n, _n);
                } catch {
                    yo = !1;
                }
            var _n;
            function wf(e, t, n, r, i, l, o, u, a) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, c);
                } catch (m) {
                    this.onError(m);
                }
            }
            var kr = !1,
                Di = null,
                Oi = !1,
                wo = null,
                kf = {
                    onError: function (e) {
                        (kr = !0), (Di = e);
                    },
                };
            function Sf(e, t, n, r, i, l, o, u, a) {
                (kr = !1), (Di = null), wf.apply(kf, arguments);
            }
            function _f(e, t, n, r, i, l, o, u, a) {
                if ((Sf.apply(this, arguments), kr)) {
                    if (kr) {
                        var c = Di;
                        (kr = !1), (Di = null);
                    } else throw Error(S(198));
                    Oi || ((Oi = !0), (wo = c));
                }
            }
            function yn(e) {
                var t = e,
                    n = e;
                if (e.alternate) for (; t.return; ) t = t.return;
                else {
                    e = t;
                    do (t = e), (t.flags & 4098) !== 0 && (n = t.return), (e = t.return);
                    while (e);
                }
                return t.tag === 3 ? n : null;
            }
            function Aa(e) {
                if (e.tag === 13) {
                    var t = e.memoizedState;
                    if ((t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)), t !== null))
                        return t.dehydrated;
                }
                return null;
            }
            function xu(e) {
                if (yn(e) !== e) throw Error(S(188));
            }
            function xf(e) {
                var t = e.alternate;
                if (!t) {
                    if (((t = yn(e)), t === null)) throw Error(S(188));
                    return t !== e ? null : e;
                }
                for (var n = e, r = t; ; ) {
                    var i = n.return;
                    if (i === null) break;
                    var l = i.alternate;
                    if (l === null) {
                        if (((r = i.return), r !== null)) {
                            n = r;
                            continue;
                        }
                        break;
                    }
                    if (i.child === l.child) {
                        for (l = i.child; l; ) {
                            if (l === n) return xu(i), e;
                            if (l === r) return xu(i), t;
                            l = l.sibling;
                        }
                        throw Error(S(188));
                    }
                    if (n.return !== r.return) (n = i), (r = l);
                    else {
                        for (var o = !1, u = i.child; u; ) {
                            if (u === n) {
                                (o = !0), (n = i), (r = l);
                                break;
                            }
                            if (u === r) {
                                (o = !0), (r = i), (n = l);
                                break;
                            }
                            u = u.sibling;
                        }
                        if (!o) {
                            for (u = l.child; u; ) {
                                if (u === n) {
                                    (o = !0), (n = l), (r = i);
                                    break;
                                }
                                if (u === r) {
                                    (o = !0), (r = l), (n = i);
                                    break;
                                }
                                u = u.sibling;
                            }
                            if (!o) throw Error(S(189));
                        }
                    }
                    if (n.alternate !== r) throw Error(S(190));
                }
                if (n.tag !== 3) throw Error(S(188));
                return n.stateNode.current === n ? e : t;
            }
            function Fa(e) {
                return (e = xf(e)), e !== null ? ba(e) : null;
            }
            function ba(e) {
                if (e.tag === 5 || e.tag === 6) return e;
                for (e = e.child; e !== null; ) {
                    var t = ba(e);
                    if (t !== null) return t;
                    e = e.sibling;
                }
                return null;
            }
            var Ba = Be.unstable_scheduleCallback,
                zu = Be.unstable_cancelCallback,
                zf = Be.unstable_shouldYield,
                Ef = Be.unstable_requestPaint,
                ae = Be.unstable_now,
                Pf = Be.unstable_getCurrentPriorityLevel,
                rs = Be.unstable_ImmediatePriority,
                ja = Be.unstable_UserBlockingPriority,
                Ai = Be.unstable_NormalPriority,
                Cf = Be.unstable_LowPriority,
                Ua = Be.unstable_IdlePriority,
                ll = null,
                mt = null;
            function Mf(e) {
                if (mt && typeof mt.onCommitFiberRoot == "function")
                    try {
                        mt.onCommitFiberRoot(ll, e, void 0, (e.current.flags & 128) === 128);
                    } catch {}
            }
            var it = Math.clz32 ? Math.clz32 : Nf,
                Tf = Math.log,
                If = Math.LN2;
            function Nf(e) {
                return (e >>>= 0), e === 0 ? 32 : (31 - ((Tf(e) / If) | 0)) | 0;
            }
            var ai = 64,
                ci = 4194304;
            function vr(e) {
                switch (e & -e) {
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    case 4:
                        return 4;
                    case 8:
                        return 8;
                    case 16:
                        return 16;
                    case 32:
                        return 32;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return e & 4194240;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        return e & 130023424;
                    case 134217728:
                        return 134217728;
                    case 268435456:
                        return 268435456;
                    case 536870912:
                        return 536870912;
                    case 1073741824:
                        return 1073741824;
                    default:
                        return e;
                }
            }
            function Fi(e, t) {
                var n = e.pendingLanes;
                if (n === 0) return 0;
                var r = 0,
                    i = e.suspendedLanes,
                    l = e.pingedLanes,
                    o = n & 268435455;
                if (o !== 0) {
                    var u = o & ~i;
                    u !== 0 ? (r = vr(u)) : ((l &= o), l !== 0 && (r = vr(l)));
                } else (o = n & ~i), o !== 0 ? (r = vr(o)) : l !== 0 && (r = vr(l));
                if (r === 0) return 0;
                if (
                    t !== 0 &&
                    t !== r &&
                    (t & i) === 0 &&
                    ((i = r & -r), (l = t & -t), i >= l || (i === 16 && (l & 4194240) !== 0))
                )
                    return t;
                if (((r & 4) !== 0 && (r |= n & 16), (t = e.entangledLanes), t !== 0))
                    for (e = e.entanglements, t &= r; 0 < t; ) (n = 31 - it(t)), (i = 1 << n), (r |= e[n]), (t &= ~i);
                return r;
            }
            function Lf(e, t) {
                switch (e) {
                    case 1:
                    case 2:
                    case 4:
                        return t + 250;
                    case 8:
                    case 16:
                    case 32:
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return t + 5e3;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        return -1;
                    case 134217728:
                    case 268435456:
                    case 536870912:
                    case 1073741824:
                        return -1;
                    default:
                        return -1;
                }
            }
            function Wf(e, t) {
                for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, l = e.pendingLanes; 0 < l; ) {
                    var o = 31 - it(l),
                        u = 1 << o,
                        a = i[o];
                    a === -1 ? ((u & n) === 0 || (u & r) !== 0) && (i[o] = Lf(u, t)) : a <= t && (e.expiredLanes |= u),
                        (l &= ~u);
                }
            }
            function ko(e) {
                return (e = e.pendingLanes & -1073741825), e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
            }
            function Ha() {
                var e = ai;
                return (ai <<= 1), (ai & 4194240) === 0 && (ai = 64), e;
            }
            function Fl(e) {
                for (var t = [], n = 0; 31 > n; n++) t.push(e);
                return t;
            }
            function qr(e, t, n) {
                (e.pendingLanes |= t),
                    t !== 536870912 && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
                    (e = e.eventTimes),
                    (t = 31 - it(t)),
                    (e[t] = n);
            }
            function Vf(e, t) {
                var n = e.pendingLanes & ~t;
                (e.pendingLanes = t),
                    (e.suspendedLanes = 0),
                    (e.pingedLanes = 0),
                    (e.expiredLanes &= t),
                    (e.mutableReadLanes &= t),
                    (e.entangledLanes &= t),
                    (t = e.entanglements);
                var r = e.eventTimes;
                for (e = e.expirationTimes; 0 < n; ) {
                    var i = 31 - it(n),
                        l = 1 << i;
                    (t[i] = 0), (r[i] = -1), (e[i] = -1), (n &= ~l);
                }
            }
            function is(e, t) {
                var n = (e.entangledLanes |= t);
                for (e = e.entanglements; n; ) {
                    var r = 31 - it(n),
                        i = 1 << r;
                    (i & t) | (e[r] & t) && (e[r] |= t), (n &= ~i);
                }
            }
            var H = 0;
            function qa(e) {
                return (e &= -e), 1 < e ? (4 < e ? ((e & 268435455) !== 0 ? 16 : 536870912) : 4) : 1;
            }
            var Ka,
                ls,
                Ga,
                $a,
                Qa,
                So = !1,
                di = [],
                bt = null,
                Bt = null,
                jt = null,
                Nr = new Map(),
                Lr = new Map(),
                Dt = [],
                Rf =
                    "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
                        " "
                    );
            function Eu(e, t) {
                switch (e) {
                    case "focusin":
                    case "focusout":
                        bt = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        Bt = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        jt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        Nr.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        Lr.delete(t.pointerId);
                }
            }
            function ur(e, t, n, r, i, l) {
                return e === null || e.nativeEvent !== l
                    ? ((e = {
                          blockedOn: t,
                          domEventName: n,
                          eventSystemFlags: r,
                          nativeEvent: l,
                          targetContainers: [i],
                      }),
                      t !== null && ((t = Gr(t)), t !== null && ls(t)),
                      e)
                    : ((e.eventSystemFlags |= r),
                      (t = e.targetContainers),
                      i !== null && t.indexOf(i) === -1 && t.push(i),
                      e);
            }
            function Df(e, t, n, r, i) {
                switch (t) {
                    case "focusin":
                        return (bt = ur(bt, e, t, n, r, i)), !0;
                    case "dragenter":
                        return (Bt = ur(Bt, e, t, n, r, i)), !0;
                    case "mouseover":
                        return (jt = ur(jt, e, t, n, r, i)), !0;
                    case "pointerover":
                        var l = i.pointerId;
                        return Nr.set(l, ur(Nr.get(l) || null, e, t, n, r, i)), !0;
                    case "gotpointercapture":
                        return (l = i.pointerId), Lr.set(l, ur(Lr.get(l) || null, e, t, n, r, i)), !0;
                }
                return !1;
            }
            function Za(e) {
                var t = sn(e.target);
                if (t !== null) {
                    var n = yn(t);
                    if (n !== null) {
                        if (((t = n.tag), t === 13)) {
                            if (((t = Aa(n)), t !== null)) {
                                (e.blockedOn = t),
                                    Qa(e.priority, function () {
                                        Ga(n);
                                    });
                                return;
                            }
                        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
                            e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
                            return;
                        }
                    }
                }
                e.blockedOn = null;
            }
            function Ei(e) {
                if (e.blockedOn !== null) return !1;
                for (var t = e.targetContainers; 0 < t.length; ) {
                    var n = _o(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
                    if (n === null) {
                        n = e.nativeEvent;
                        var r = new n.constructor(n.type, n);
                        (go = r), n.target.dispatchEvent(r), (go = null);
                    } else return (t = Gr(n)), t !== null && ls(t), (e.blockedOn = n), !1;
                    t.shift();
                }
                return !0;
            }
            function Pu(e, t, n) {
                Ei(e) && n.delete(t);
            }
            function Of() {
                (So = !1),
                    bt !== null && Ei(bt) && (bt = null),
                    Bt !== null && Ei(Bt) && (Bt = null),
                    jt !== null && Ei(jt) && (jt = null),
                    Nr.forEach(Pu),
                    Lr.forEach(Pu);
            }
            function ar(e, t) {
                e.blockedOn === t &&
                    ((e.blockedOn = null),
                    So || ((So = !0), Be.unstable_scheduleCallback(Be.unstable_NormalPriority, Of)));
            }
            function Wr(e) {
                function t(i) {
                    return ar(i, e);
                }
                if (0 < di.length) {
                    ar(di[0], e);
                    for (var n = 1; n < di.length; n++) {
                        var r = di[n];
                        r.blockedOn === e && (r.blockedOn = null);
                    }
                }
                for (
                    bt !== null && ar(bt, e),
                        Bt !== null && ar(Bt, e),
                        jt !== null && ar(jt, e),
                        Nr.forEach(t),
                        Lr.forEach(t),
                        n = 0;
                    n < Dt.length;
                    n++
                )
                    (r = Dt[n]), r.blockedOn === e && (r.blockedOn = null);
                for (; 0 < Dt.length && ((n = Dt[0]), n.blockedOn === null); )
                    Za(n), n.blockedOn === null && Dt.shift();
            }
            var Fn = It.ReactCurrentBatchConfig,
                bi = !0;
            function Af(e, t, n, r) {
                var i = H,
                    l = Fn.transition;
                Fn.transition = null;
                try {
                    (H = 1), os(e, t, n, r);
                } finally {
                    (H = i), (Fn.transition = l);
                }
            }
            function Ff(e, t, n, r) {
                var i = H,
                    l = Fn.transition;
                Fn.transition = null;
                try {
                    (H = 4), os(e, t, n, r);
                } finally {
                    (H = i), (Fn.transition = l);
                }
            }
            function os(e, t, n, r) {
                if (bi) {
                    var i = _o(e, t, n, r);
                    if (i === null) Kl(e, t, r, Bi, n), Eu(e, r);
                    else if (Df(i, e, t, n, r)) r.stopPropagation();
                    else if ((Eu(e, r), t & 4 && -1 < Rf.indexOf(e))) {
                        for (; i !== null; ) {
                            var l = Gr(i);
                            if ((l !== null && Ka(l), (l = _o(e, t, n, r)), l === null && Kl(e, t, r, Bi, n), l === i))
                                break;
                            i = l;
                        }
                        i !== null && r.stopPropagation();
                    } else Kl(e, t, r, null, n);
                }
            }
            var Bi = null;
            function _o(e, t, n, r) {
                if (((Bi = null), (e = ns(r)), (e = sn(e)), e !== null))
                    if (((t = yn(e)), t === null)) e = null;
                    else if (((n = t.tag), n === 13)) {
                        if (((e = Aa(t)), e !== null)) return e;
                        e = null;
                    } else if (n === 3) {
                        if (t.stateNode.current.memoizedState.isDehydrated)
                            return t.tag === 3 ? t.stateNode.containerInfo : null;
                        e = null;
                    } else t !== e && (e = null);
                return (Bi = e), null;
            }
            function Xa(e) {
                switch (e) {
                    case "cancel":
                    case "click":
                    case "close":
                    case "contextmenu":
                    case "copy":
                    case "cut":
                    case "auxclick":
                    case "dblclick":
                    case "dragend":
                    case "dragstart":
                    case "drop":
                    case "focusin":
                    case "focusout":
                    case "input":
                    case "invalid":
                    case "keydown":
                    case "keypress":
                    case "keyup":
                    case "mousedown":
                    case "mouseup":
                    case "paste":
                    case "pause":
                    case "play":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointerup":
                    case "ratechange":
                    case "reset":
                    case "resize":
                    case "seeked":
                    case "submit":
                    case "touchcancel":
                    case "touchend":
                    case "touchstart":
                    case "volumechange":
                    case "change":
                    case "selectionchange":
                    case "textInput":
                    case "compositionstart":
                    case "compositionend":
                    case "compositionupdate":
                    case "beforeblur":
                    case "afterblur":
                    case "beforeinput":
                    case "blur":
                    case "fullscreenchange":
                    case "focus":
                    case "hashchange":
                    case "popstate":
                    case "select":
                    case "selectstart":
                        return 1;
                    case "drag":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "mousemove":
                    case "mouseout":
                    case "mouseover":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "scroll":
                    case "toggle":
                    case "touchmove":
                    case "wheel":
                    case "mouseenter":
                    case "mouseleave":
                    case "pointerenter":
                    case "pointerleave":
                        return 4;
                    case "message":
                        switch (Pf()) {
                            case rs:
                                return 1;
                            case ja:
                                return 4;
                            case Ai:
                            case Cf:
                                return 16;
                            case Ua:
                                return 536870912;
                            default:
                                return 16;
                        }
                    default:
                        return 16;
                }
            }
            var At = null,
                ss = null,
                Pi = null;
            function Ya() {
                if (Pi) return Pi;
                var e,
                    t = ss,
                    n = t.length,
                    r,
                    i = "value" in At ? At.value : At.textContent,
                    l = i.length;
                for (e = 0; e < n && t[e] === i[e]; e++);
                var o = n - e;
                for (r = 1; r <= o && t[n - r] === i[l - r]; r++);
                return (Pi = i.slice(e, 1 < r ? 1 - r : void 0));
            }
            function Ci(e) {
                var t = e.keyCode;
                return (
                    "charCode" in e ? ((e = e.charCode), e === 0 && t === 13 && (e = 13)) : (e = t),
                    e === 10 && (e = 13),
                    32 <= e || e === 13 ? e : 0
                );
            }
            function fi() {
                return !0;
            }
            function Cu() {
                return !1;
            }
            function je(e) {
                function t(n, r, i, l, o) {
                    (this._reactName = n),
                        (this._targetInst = i),
                        (this.type = r),
                        (this.nativeEvent = l),
                        (this.target = o),
                        (this.currentTarget = null);
                    for (var u in e) e.hasOwnProperty(u) && ((n = e[u]), (this[u] = n ? n(l) : l[u]));
                    return (
                        (this.isDefaultPrevented = (
                            l.defaultPrevented != null ? l.defaultPrevented : l.returnValue === !1
                        )
                            ? fi
                            : Cu),
                        (this.isPropagationStopped = Cu),
                        this
                    );
                }
                return (
                    le(t.prototype, {
                        preventDefault: function () {
                            this.defaultPrevented = !0;
                            var n = this.nativeEvent;
                            n &&
                                (n.preventDefault
                                    ? n.preventDefault()
                                    : typeof n.returnValue != "unknown" && (n.returnValue = !1),
                                (this.isDefaultPrevented = fi));
                        },
                        stopPropagation: function () {
                            var n = this.nativeEvent;
                            n &&
                                (n.stopPropagation
                                    ? n.stopPropagation()
                                    : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0),
                                (this.isPropagationStopped = fi));
                        },
                        persist: function () {},
                        isPersistent: fi,
                    }),
                    t
                );
            }
            var Qn = {
                    eventPhase: 0,
                    bubbles: 0,
                    cancelable: 0,
                    timeStamp: function (e) {
                        return e.timeStamp || Date.now();
                    },
                    defaultPrevented: 0,
                    isTrusted: 0,
                },
                us = je(Qn),
                Kr = le({}, Qn, { view: 0, detail: 0 }),
                bf = je(Kr),
                bl,
                Bl,
                cr,
                ol = le({}, Kr, {
                    screenX: 0,
                    screenY: 0,
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    getModifierState: as,
                    button: 0,
                    buttons: 0,
                    relatedTarget: function (e) {
                        return e.relatedTarget === void 0
                            ? e.fromElement === e.srcElement
                                ? e.toElement
                                : e.fromElement
                            : e.relatedTarget;
                    },
                    movementX: function (e) {
                        return "movementX" in e
                            ? e.movementX
                            : (e !== cr &&
                                  (cr && e.type === "mousemove"
                                      ? ((bl = e.screenX - cr.screenX), (Bl = e.screenY - cr.screenY))
                                      : (Bl = bl = 0),
                                  (cr = e)),
                              bl);
                    },
                    movementY: function (e) {
                        return "movementY" in e ? e.movementY : Bl;
                    },
                }),
                Mu = je(ol),
                Bf = le({}, ol, { dataTransfer: 0 }),
                jf = je(Bf),
                Uf = le({}, Kr, { relatedTarget: 0 }),
                jl = je(Uf),
                Hf = le({}, Qn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
                qf = je(Hf),
                Kf = le({}, Qn, {
                    clipboardData: function (e) {
                        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
                    },
                }),
                Gf = je(Kf),
                $f = le({}, Qn, { data: 0 }),
                Tu = je($f),
                Qf = {
                    Esc: "Escape",
                    Spacebar: " ",
                    Left: "ArrowLeft",
                    Up: "ArrowUp",
                    Right: "ArrowRight",
                    Down: "ArrowDown",
                    Del: "Delete",
                    Win: "OS",
                    Menu: "ContextMenu",
                    Apps: "ContextMenu",
                    Scroll: "ScrollLock",
                    MozPrintableKey: "Unidentified",
                },
                Zf = {
                    8: "Backspace",
                    9: "Tab",
                    12: "Clear",
                    13: "Enter",
                    16: "Shift",
                    17: "Control",
                    18: "Alt",
                    19: "Pause",
                    20: "CapsLock",
                    27: "Escape",
                    32: " ",
                    33: "PageUp",
                    34: "PageDown",
                    35: "End",
                    36: "Home",
                    37: "ArrowLeft",
                    38: "ArrowUp",
                    39: "ArrowRight",
                    40: "ArrowDown",
                    45: "Insert",
                    46: "Delete",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4",
                    116: "F5",
                    117: "F6",
                    118: "F7",
                    119: "F8",
                    120: "F9",
                    121: "F10",
                    122: "F11",
                    123: "F12",
                    144: "NumLock",
                    145: "ScrollLock",
                    224: "Meta",
                },
                Xf = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
            function Yf(e) {
                var t = this.nativeEvent;
                return t.getModifierState ? t.getModifierState(e) : (e = Xf[e]) ? !!t[e] : !1;
            }
            function as() {
                return Yf;
            }
            var Jf = le({}, Kr, {
                    key: function (e) {
                        if (e.key) {
                            var t = Qf[e.key] || e.key;
                            if (t !== "Unidentified") return t;
                        }
                        return e.type === "keypress"
                            ? ((e = Ci(e)), e === 13 ? "Enter" : String.fromCharCode(e))
                            : e.type === "keydown" || e.type === "keyup"
                              ? Zf[e.keyCode] || "Unidentified"
                              : "";
                    },
                    code: 0,
                    location: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    altKey: 0,
                    metaKey: 0,
                    repeat: 0,
                    locale: 0,
                    getModifierState: as,
                    charCode: function (e) {
                        return e.type === "keypress" ? Ci(e) : 0;
                    },
                    keyCode: function (e) {
                        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
                    },
                    which: function (e) {
                        return e.type === "keypress"
                            ? Ci(e)
                            : e.type === "keydown" || e.type === "keyup"
                              ? e.keyCode
                              : 0;
                    },
                }),
                ep = je(Jf),
                tp = le({}, ol, {
                    pointerId: 0,
                    width: 0,
                    height: 0,
                    pressure: 0,
                    tangentialPressure: 0,
                    tiltX: 0,
                    tiltY: 0,
                    twist: 0,
                    pointerType: 0,
                    isPrimary: 0,
                }),
                Iu = je(tp),
                np = le({}, Kr, {
                    touches: 0,
                    targetTouches: 0,
                    changedTouches: 0,
                    altKey: 0,
                    metaKey: 0,
                    ctrlKey: 0,
                    shiftKey: 0,
                    getModifierState: as,
                }),
                rp = je(np),
                ip = le({}, Qn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
                lp = je(ip),
                op = le({}, ol, {
                    deltaX: function (e) {
                        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
                    },
                    deltaY: function (e) {
                        return "deltaY" in e
                            ? e.deltaY
                            : "wheelDeltaY" in e
                              ? -e.wheelDeltaY
                              : "wheelDelta" in e
                                ? -e.wheelDelta
                                : 0;
                    },
                    deltaZ: 0,
                    deltaMode: 0,
                }),
                sp = je(op),
                up = [9, 13, 27, 32],
                cs = Pt && "CompositionEvent" in window,
                Sr = null;
            Pt && "documentMode" in document && (Sr = document.documentMode);
            var ap = Pt && "TextEvent" in window && !Sr,
                Ja = Pt && (!cs || (Sr && 8 < Sr && 11 >= Sr)),
                Nu = " ",
                Lu = !1;
            function ec(e, t) {
                switch (e) {
                    case "keyup":
                        return up.indexOf(t.keyCode) !== -1;
                    case "keydown":
                        return t.keyCode !== 229;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function tc(e) {
                return (e = e.detail), typeof e == "object" && "data" in e ? e.data : null;
            }
            var Pn = !1;
            function cp(e, t) {
                switch (e) {
                    case "compositionend":
                        return tc(t);
                    case "keypress":
                        return t.which !== 32 ? null : ((Lu = !0), Nu);
                    case "textInput":
                        return (e = t.data), e === Nu && Lu ? null : e;
                    default:
                        return null;
                }
            }
            function dp(e, t) {
                if (Pn)
                    return e === "compositionend" || (!cs && ec(e, t))
                        ? ((e = Ya()), (Pi = ss = At = null), (Pn = !1), e)
                        : null;
                switch (e) {
                    case "paste":
                        return null;
                    case "keypress":
                        if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                        }
                        return null;
                    case "compositionend":
                        return Ja && t.locale !== "ko" ? null : t.data;
                    default:
                        return null;
                }
            }
            var fp = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0,
            };
            function Wu(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return t === "input" ? !!fp[e.type] : t === "textarea";
            }
            function nc(e, t, n, r) {
                Wa(r),
                    (t = ji(t, "onChange")),
                    0 < t.length &&
                        ((n = new us("onChange", "change", null, n, r)), e.push({ event: n, listeners: t }));
            }
            var _r = null,
                Vr = null;
            function pp(e) {
                pc(e, 0);
            }
            function sl(e) {
                var t = Tn(e);
                if (Pa(t)) return e;
            }
            function hp(e, t) {
                if (e === "change") return t;
            }
            var rc = !1;
            Pt &&
                (Pt
                    ? ((hi = "oninput" in document),
                      hi ||
                          ((Ul = document.createElement("div")),
                          Ul.setAttribute("oninput", "return;"),
                          (hi = typeof Ul.oninput == "function")),
                      (pi = hi))
                    : (pi = !1),
                (rc = pi && (!document.documentMode || 9 < document.documentMode)));
            var pi, hi, Ul;
            function Vu() {
                _r && (_r.detachEvent("onpropertychange", ic), (Vr = _r = null));
            }
            function ic(e) {
                if (e.propertyName === "value" && sl(Vr)) {
                    var t = [];
                    nc(t, Vr, e, ns(e)), Oa(pp, t);
                }
            }
            function mp(e, t, n) {
                e === "focusin"
                    ? (Vu(), (_r = t), (Vr = n), _r.attachEvent("onpropertychange", ic))
                    : e === "focusout" && Vu();
            }
            function gp(e) {
                if (e === "selectionchange" || e === "keyup" || e === "keydown") return sl(Vr);
            }
            function vp(e, t) {
                if (e === "click") return sl(t);
            }
            function yp(e, t) {
                if (e === "input" || e === "change") return sl(t);
            }
            function wp(e, t) {
                return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
            }
            var ot = typeof Object.is == "function" ? Object.is : wp;
            function Rr(e, t) {
                if (ot(e, t)) return !0;
                if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
                var n = Object.keys(e),
                    r = Object.keys(t);
                if (n.length !== r.length) return !1;
                for (r = 0; r < n.length; r++) {
                    var i = n[r];
                    if (!ro.call(t, i) || !ot(e[i], t[i])) return !1;
                }
                return !0;
            }
            function Ru(e) {
                for (; e && e.firstChild; ) e = e.firstChild;
                return e;
            }
            function Du(e, t) {
                var n = Ru(e);
                e = 0;
                for (var r; n; ) {
                    if (n.nodeType === 3) {
                        if (((r = e + n.textContent.length), e <= t && r >= t)) return { node: n, offset: t - e };
                        e = r;
                    }
                    e: {
                        for (; n; ) {
                            if (n.nextSibling) {
                                n = n.nextSibling;
                                break e;
                            }
                            n = n.parentNode;
                        }
                        n = void 0;
                    }
                    n = Ru(n);
                }
            }
            function lc(e, t) {
                return e && t
                    ? e === t
                        ? !0
                        : e && e.nodeType === 3
                          ? !1
                          : t && t.nodeType === 3
                            ? lc(e, t.parentNode)
                            : "contains" in e
                              ? e.contains(t)
                              : e.compareDocumentPosition
                                ? !!(e.compareDocumentPosition(t) & 16)
                                : !1
                    : !1;
            }
            function oc() {
                for (var e = window, t = Ri(); t instanceof e.HTMLIFrameElement; ) {
                    try {
                        var n = typeof t.contentWindow.location.href == "string";
                    } catch {
                        n = !1;
                    }
                    if (n) e = t.contentWindow;
                    else break;
                    t = Ri(e.document);
                }
                return t;
            }
            function ds(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return (
                    t &&
                    ((t === "input" &&
                        (e.type === "text" ||
                            e.type === "search" ||
                            e.type === "tel" ||
                            e.type === "url" ||
                            e.type === "password")) ||
                        t === "textarea" ||
                        e.contentEditable === "true")
                );
            }
            function kp(e) {
                var t = oc(),
                    n = e.focusedElem,
                    r = e.selectionRange;
                if (t !== n && n && n.ownerDocument && lc(n.ownerDocument.documentElement, n)) {
                    if (r !== null && ds(n)) {
                        if (((t = r.start), (e = r.end), e === void 0 && (e = t), "selectionStart" in n))
                            (n.selectionStart = t), (n.selectionEnd = Math.min(e, n.value.length));
                        else if (
                            ((e = ((t = n.ownerDocument || document) && t.defaultView) || window), e.getSelection)
                        ) {
                            e = e.getSelection();
                            var i = n.textContent.length,
                                l = Math.min(r.start, i);
                            (r = r.end === void 0 ? l : Math.min(r.end, i)),
                                !e.extend && l > r && ((i = r), (r = l), (l = i)),
                                (i = Du(n, l));
                            var o = Du(n, r);
                            i &&
                                o &&
                                (e.rangeCount !== 1 ||
                                    e.anchorNode !== i.node ||
                                    e.anchorOffset !== i.offset ||
                                    e.focusNode !== o.node ||
                                    e.focusOffset !== o.offset) &&
                                ((t = t.createRange()),
                                t.setStart(i.node, i.offset),
                                e.removeAllRanges(),
                                l > r
                                    ? (e.addRange(t), e.extend(o.node, o.offset))
                                    : (t.setEnd(o.node, o.offset), e.addRange(t)));
                        }
                    }
                    for (t = [], e = n; (e = e.parentNode); )
                        e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
                    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++)
                        (e = t[n]), (e.element.scrollLeft = e.left), (e.element.scrollTop = e.top);
                }
            }
            var Sp = Pt && "documentMode" in document && 11 >= document.documentMode,
                Cn = null,
                xo = null,
                xr = null,
                zo = !1;
            function Ou(e, t, n) {
                var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
                zo ||
                    Cn == null ||
                    Cn !== Ri(r) ||
                    ((r = Cn),
                    "selectionStart" in r && ds(r)
                        ? (r = { start: r.selectionStart, end: r.selectionEnd })
                        : ((r = ((r.ownerDocument && r.ownerDocument.defaultView) || window).getSelection()),
                          (r = {
                              anchorNode: r.anchorNode,
                              anchorOffset: r.anchorOffset,
                              focusNode: r.focusNode,
                              focusOffset: r.focusOffset,
                          })),
                    (xr && Rr(xr, r)) ||
                        ((xr = r),
                        (r = ji(xo, "onSelect")),
                        0 < r.length &&
                            ((t = new us("onSelect", "select", null, t, n)),
                            e.push({ event: t, listeners: r }),
                            (t.target = Cn))));
            }
            function mi(e, t) {
                var n = {};
                return (
                    (n[e.toLowerCase()] = t.toLowerCase()),
                    (n["Webkit" + e] = "webkit" + t),
                    (n["Moz" + e] = "moz" + t),
                    n
                );
            }
            var Mn = {
                    animationend: mi("Animation", "AnimationEnd"),
                    animationiteration: mi("Animation", "AnimationIteration"),
                    animationstart: mi("Animation", "AnimationStart"),
                    transitionend: mi("Transition", "TransitionEnd"),
                },
                Hl = {},
                sc = {};
            Pt &&
                ((sc = document.createElement("div").style),
                "AnimationEvent" in window ||
                    (delete Mn.animationend.animation,
                    delete Mn.animationiteration.animation,
                    delete Mn.animationstart.animation),
                "TransitionEvent" in window || delete Mn.transitionend.transition);
            function ul(e) {
                if (Hl[e]) return Hl[e];
                if (!Mn[e]) return e;
                var t = Mn[e],
                    n;
                for (n in t) if (t.hasOwnProperty(n) && n in sc) return (Hl[e] = t[n]);
                return e;
            }
            var uc = ul("animationend"),
                ac = ul("animationiteration"),
                cc = ul("animationstart"),
                dc = ul("transitionend"),
                fc = new Map(),
                Au =
                    "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
                        " "
                    );
            function Zt(e, t) {
                fc.set(e, t), vn(t, [e]);
            }
            for (gi = 0; gi < Au.length; gi++)
                (vi = Au[gi]), (Fu = vi.toLowerCase()), (bu = vi[0].toUpperCase() + vi.slice(1)), Zt(Fu, "on" + bu);
            var vi, Fu, bu, gi;
            Zt(uc, "onAnimationEnd"),
                Zt(ac, "onAnimationIteration"),
                Zt(cc, "onAnimationStart"),
                Zt("dblclick", "onDoubleClick"),
                Zt("focusin", "onFocus"),
                Zt("focusout", "onBlur"),
                Zt(dc, "onTransitionEnd"),
                jn("onMouseEnter", ["mouseout", "mouseover"]),
                jn("onMouseLeave", ["mouseout", "mouseover"]),
                jn("onPointerEnter", ["pointerout", "pointerover"]),
                jn("onPointerLeave", ["pointerout", "pointerover"]),
                vn("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")),
                vn(
                    "onSelect",
                    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")
                ),
                vn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
                vn("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")),
                vn("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")),
                vn("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var yr =
                    "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
                        " "
                    ),
                _p = new Set("cancel close invalid load scroll toggle".split(" ").concat(yr));
            function Bu(e, t, n) {
                var r = e.type || "unknown-event";
                (e.currentTarget = n), _f(r, t, void 0, e), (e.currentTarget = null);
            }
            function pc(e, t) {
                t = (t & 4) !== 0;
                for (var n = 0; n < e.length; n++) {
                    var r = e[n],
                        i = r.event;
                    r = r.listeners;
                    e: {
                        var l = void 0;
                        if (t)
                            for (var o = r.length - 1; 0 <= o; o--) {
                                var u = r[o],
                                    a = u.instance,
                                    c = u.currentTarget;
                                if (((u = u.listener), a !== l && i.isPropagationStopped())) break e;
                                Bu(i, u, c), (l = a);
                            }
                        else
                            for (o = 0; o < r.length; o++) {
                                if (
                                    ((u = r[o]),
                                    (a = u.instance),
                                    (c = u.currentTarget),
                                    (u = u.listener),
                                    a !== l && i.isPropagationStopped())
                                )
                                    break e;
                                Bu(i, u, c), (l = a);
                            }
                    }
                }
                if (Oi) throw ((e = wo), (Oi = !1), (wo = null), e);
            }
            function G(e, t) {
                var n = t[To];
                n === void 0 && (n = t[To] = new Set());
                var r = e + "__bubble";
                n.has(r) || (hc(t, e, 2, !1), n.add(r));
            }
            function ql(e, t, n) {
                var r = 0;
                t && (r |= 4), hc(n, e, r, t);
            }
            var yi = "_reactListening" + Math.random().toString(36).slice(2);
            function Dr(e) {
                if (!e[yi]) {
                    (e[yi] = !0),
                        Sa.forEach(function (n) {
                            n !== "selectionchange" && (_p.has(n) || ql(n, !1, e), ql(n, !0, e));
                        });
                    var t = e.nodeType === 9 ? e : e.ownerDocument;
                    t === null || t[yi] || ((t[yi] = !0), ql("selectionchange", !1, t));
                }
            }
            function hc(e, t, n, r) {
                switch (Xa(t)) {
                    case 1:
                        var i = Af;
                        break;
                    case 4:
                        i = Ff;
                        break;
                    default:
                        i = os;
                }
                (n = i.bind(null, t, n, e)),
                    (i = void 0),
                    !yo || (t !== "touchstart" && t !== "touchmove" && t !== "wheel") || (i = !0),
                    r
                        ? i !== void 0
                            ? e.addEventListener(t, n, { capture: !0, passive: i })
                            : e.addEventListener(t, n, !0)
                        : i !== void 0
                          ? e.addEventListener(t, n, { passive: i })
                          : e.addEventListener(t, n, !1);
            }
            function Kl(e, t, n, r, i) {
                var l = r;
                if ((t & 1) === 0 && (t & 2) === 0 && r !== null)
                    e: for (;;) {
                        if (r === null) return;
                        var o = r.tag;
                        if (o === 3 || o === 4) {
                            var u = r.stateNode.containerInfo;
                            if (u === i || (u.nodeType === 8 && u.parentNode === i)) break;
                            if (o === 4)
                                for (o = r.return; o !== null; ) {
                                    var a = o.tag;
                                    if (
                                        (a === 3 || a === 4) &&
                                        ((a = o.stateNode.containerInfo),
                                        a === i || (a.nodeType === 8 && a.parentNode === i))
                                    )
                                        return;
                                    o = o.return;
                                }
                            for (; u !== null; ) {
                                if (((o = sn(u)), o === null)) return;
                                if (((a = o.tag), a === 5 || a === 6)) {
                                    r = l = o;
                                    continue e;
                                }
                                u = u.parentNode;
                            }
                        }
                        r = r.return;
                    }
                Oa(function () {
                    var c = l,
                        m = ns(n),
                        g = [];
                    e: {
                        var f = fc.get(e);
                        if (f !== void 0) {
                            var v = us,
                                k = e;
                            switch (e) {
                                case "keypress":
                                    if (Ci(n) === 0) break e;
                                case "keydown":
                                case "keyup":
                                    v = ep;
                                    break;
                                case "focusin":
                                    (k = "focus"), (v = jl);
                                    break;
                                case "focusout":
                                    (k = "blur"), (v = jl);
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    v = jl;
                                    break;
                                case "click":
                                    if (n.button === 2) break e;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    v = Mu;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    v = jf;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    v = rp;
                                    break;
                                case uc:
                                case ac:
                                case cc:
                                    v = qf;
                                    break;
                                case dc:
                                    v = lp;
                                    break;
                                case "scroll":
                                    v = bf;
                                    break;
                                case "wheel":
                                    v = sp;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    v = Gf;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    v = Iu;
                            }
                            var x = (t & 4) !== 0,
                                R = !x && e === "scroll",
                                h = x ? (f !== null ? f + "Capture" : null) : f;
                            x = [];
                            for (var d = c, p; d !== null; ) {
                                p = d;
                                var y = p.stateNode;
                                if (
                                    (p.tag === 5 &&
                                        y !== null &&
                                        ((p = y), h !== null && ((y = Ir(d, h)), y != null && x.push(Or(d, y, p)))),
                                    R)
                                )
                                    break;
                                d = d.return;
                            }
                            0 < x.length && ((f = new v(f, k, null, n, m)), g.push({ event: f, listeners: x }));
                        }
                    }
                    if ((t & 7) === 0) {
                        e: {
                            if (
                                ((f = e === "mouseover" || e === "pointerover"),
                                (v = e === "mouseout" || e === "pointerout"),
                                f && n !== go && (k = n.relatedTarget || n.fromElement) && (sn(k) || k[Ct]))
                            )
                                break e;
                            if (
                                (v || f) &&
                                ((f =
                                    m.window === m
                                        ? m
                                        : (f = m.ownerDocument)
                                          ? f.defaultView || f.parentWindow
                                          : window),
                                v
                                    ? ((k = n.relatedTarget || n.toElement),
                                      (v = c),
                                      (k = k ? sn(k) : null),
                                      k !== null &&
                                          ((R = yn(k)), k !== R || (k.tag !== 5 && k.tag !== 6)) &&
                                          (k = null))
                                    : ((v = null), (k = c)),
                                v !== k)
                            ) {
                                if (
                                    ((x = Mu),
                                    (y = "onMouseLeave"),
                                    (h = "onMouseEnter"),
                                    (d = "mouse"),
                                    (e === "pointerout" || e === "pointerover") &&
                                        ((x = Iu), (y = "onPointerLeave"), (h = "onPointerEnter"), (d = "pointer")),
                                    (R = v == null ? f : Tn(v)),
                                    (p = k == null ? f : Tn(k)),
                                    (f = new x(y, d + "leave", v, n, m)),
                                    (f.target = R),
                                    (f.relatedTarget = p),
                                    (y = null),
                                    sn(m) === c &&
                                        ((x = new x(h, d + "enter", k, n, m)),
                                        (x.target = p),
                                        (x.relatedTarget = R),
                                        (y = x)),
                                    (R = y),
                                    v && k)
                                )
                                    t: {
                                        for (x = v, h = k, d = 0, p = x; p; p = xn(p)) d++;
                                        for (p = 0, y = h; y; y = xn(y)) p++;
                                        for (; 0 < d - p; ) (x = xn(x)), d--;
                                        for (; 0 < p - d; ) (h = xn(h)), p--;
                                        for (; d--; ) {
                                            if (x === h || (h !== null && x === h.alternate)) break t;
                                            (x = xn(x)), (h = xn(h));
                                        }
                                        x = null;
                                    }
                                else x = null;
                                v !== null && ju(g, f, v, x, !1), k !== null && R !== null && ju(g, R, k, x, !0);
                            }
                        }
                        e: {
                            if (
                                ((f = c ? Tn(c) : window),
                                (v = f.nodeName && f.nodeName.toLowerCase()),
                                v === "select" || (v === "input" && f.type === "file"))
                            )
                                var z = hp;
                            else if (Wu(f))
                                if (rc) z = yp;
                                else {
                                    z = gp;
                                    var C = mp;
                                }
                            else
                                (v = f.nodeName) &&
                                    v.toLowerCase() === "input" &&
                                    (f.type === "checkbox" || f.type === "radio") &&
                                    (z = vp);
                            if (z && (z = z(e, c))) {
                                nc(g, z, n, m);
                                break e;
                            }
                            C && C(e, f, c),
                                e === "focusout" &&
                                    (C = f._wrapperState) &&
                                    C.controlled &&
                                    f.type === "number" &&
                                    co(f, "number", f.value);
                        }
                        switch (((C = c ? Tn(c) : window), e)) {
                            case "focusin":
                                (Wu(C) || C.contentEditable === "true") && ((Cn = C), (xo = c), (xr = null));
                                break;
                            case "focusout":
                                xr = xo = Cn = null;
                                break;
                            case "mousedown":
                                zo = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                (zo = !1), Ou(g, n, m);
                                break;
                            case "selectionchange":
                                if (Sp) break;
                            case "keydown":
                            case "keyup":
                                Ou(g, n, m);
                        }
                        var I;
                        if (cs)
                            e: {
                                switch (e) {
                                    case "compositionstart":
                                        var T = "onCompositionStart";
                                        break e;
                                    case "compositionend":
                                        T = "onCompositionEnd";
                                        break e;
                                    case "compositionupdate":
                                        T = "onCompositionUpdate";
                                        break e;
                                }
                                T = void 0;
                            }
                        else
                            Pn
                                ? ec(e, n) && (T = "onCompositionEnd")
                                : e === "keydown" && n.keyCode === 229 && (T = "onCompositionStart");
                        T &&
                            (Ja &&
                                n.locale !== "ko" &&
                                (Pn || T !== "onCompositionStart"
                                    ? T === "onCompositionEnd" && Pn && (I = Ya())
                                    : ((At = m), (ss = "value" in At ? At.value : At.textContent), (Pn = !0))),
                            (C = ji(c, T)),
                            0 < C.length &&
                                ((T = new Tu(T, e, null, n, m)),
                                g.push({ event: T, listeners: C }),
                                I ? (T.data = I) : ((I = tc(n)), I !== null && (T.data = I)))),
                            (I = ap ? cp(e, n) : dp(e, n)) &&
                                ((c = ji(c, "onBeforeInput")),
                                0 < c.length &&
                                    ((m = new Tu("onBeforeInput", "beforeinput", null, n, m)),
                                    g.push({ event: m, listeners: c }),
                                    (m.data = I)));
                    }
                    pc(g, t);
                });
            }
            function Or(e, t, n) {
                return { instance: e, listener: t, currentTarget: n };
            }
            function ji(e, t) {
                for (var n = t + "Capture", r = []; e !== null; ) {
                    var i = e,
                        l = i.stateNode;
                    i.tag === 5 &&
                        l !== null &&
                        ((i = l),
                        (l = Ir(e, n)),
                        l != null && r.unshift(Or(e, l, i)),
                        (l = Ir(e, t)),
                        l != null && r.push(Or(e, l, i))),
                        (e = e.return);
                }
                return r;
            }
            function xn(e) {
                if (e === null) return null;
                do e = e.return;
                while (e && e.tag !== 5);
                return e || null;
            }
            function ju(e, t, n, r, i) {
                for (var l = t._reactName, o = []; n !== null && n !== r; ) {
                    var u = n,
                        a = u.alternate,
                        c = u.stateNode;
                    if (a !== null && a === r) break;
                    u.tag === 5 &&
                        c !== null &&
                        ((u = c),
                        i
                            ? ((a = Ir(n, l)), a != null && o.unshift(Or(n, a, u)))
                            : i || ((a = Ir(n, l)), a != null && o.push(Or(n, a, u)))),
                        (n = n.return);
                }
                o.length !== 0 && e.push({ event: t, listeners: o });
            }
            var xp = /\r\n?/g,
                zp = /\u0000|\uFFFD/g;
            function Uu(e) {
                return (typeof e == "string" ? e : "" + e)
                    .replace(
                        xp,
                        `
`
                    )
                    .replace(zp, "");
            }
            function wi(e, t, n) {
                if (((t = Uu(t)), Uu(e) !== t && n)) throw Error(S(425));
            }
            function Ui() {}
            var Eo = null,
                Po = null;
            function Co(e, t) {
                return (
                    e === "textarea" ||
                    e === "noscript" ||
                    typeof t.children == "string" ||
                    typeof t.children == "number" ||
                    (typeof t.dangerouslySetInnerHTML == "object" &&
                        t.dangerouslySetInnerHTML !== null &&
                        t.dangerouslySetInnerHTML.__html != null)
                );
            }
            var Mo = typeof setTimeout == "function" ? setTimeout : void 0,
                Ep = typeof clearTimeout == "function" ? clearTimeout : void 0,
                Hu = typeof Promise == "function" ? Promise : void 0,
                Pp =
                    typeof queueMicrotask == "function"
                        ? queueMicrotask
                        : typeof Hu < "u"
                          ? function (e) {
                                return Hu.resolve(null).then(e).catch(Cp);
                            }
                          : Mo;
            function Cp(e) {
                setTimeout(function () {
                    throw e;
                });
            }
            function Gl(e, t) {
                var n = t,
                    r = 0;
                do {
                    var i = n.nextSibling;
                    if ((e.removeChild(n), i && i.nodeType === 8))
                        if (((n = i.data), n === "/$")) {
                            if (r === 0) {
                                e.removeChild(i), Wr(t);
                                return;
                            }
                            r--;
                        } else (n !== "$" && n !== "$?" && n !== "$!") || r++;
                    n = i;
                } while (n);
                Wr(t);
            }
            function Ut(e) {
                for (; e != null; e = e.nextSibling) {
                    var t = e.nodeType;
                    if (t === 1 || t === 3) break;
                    if (t === 8) {
                        if (((t = e.data), t === "$" || t === "$!" || t === "$?")) break;
                        if (t === "/$") return null;
                    }
                }
                return e;
            }
            function qu(e) {
                e = e.previousSibling;
                for (var t = 0; e; ) {
                    if (e.nodeType === 8) {
                        var n = e.data;
                        if (n === "$" || n === "$!" || n === "$?") {
                            if (t === 0) return e;
                            t--;
                        } else n === "/$" && t++;
                    }
                    e = e.previousSibling;
                }
                return null;
            }
            var Zn = Math.random().toString(36).slice(2),
                ht = "__reactFiber$" + Zn,
                Ar = "__reactProps$" + Zn,
                Ct = "__reactContainer$" + Zn,
                To = "__reactEvents$" + Zn,
                Mp = "__reactListeners$" + Zn,
                Tp = "__reactHandles$" + Zn;
            function sn(e) {
                var t = e[ht];
                if (t) return t;
                for (var n = e.parentNode; n; ) {
                    if ((t = n[Ct] || n[ht])) {
                        if (((n = t.alternate), t.child !== null || (n !== null && n.child !== null)))
                            for (e = qu(e); e !== null; ) {
                                if ((n = e[ht])) return n;
                                e = qu(e);
                            }
                        return t;
                    }
                    (e = n), (n = e.parentNode);
                }
                return null;
            }
            function Gr(e) {
                return (
                    (e = e[ht] || e[Ct]), !e || (e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3) ? null : e
                );
            }
            function Tn(e) {
                if (e.tag === 5 || e.tag === 6) return e.stateNode;
                throw Error(S(33));
            }
            function al(e) {
                return e[Ar] || null;
            }
            var Io = [],
                In = -1;
            function Xt(e) {
                return { current: e };
            }
            function $(e) {
                0 > In || ((e.current = Io[In]), (Io[In] = null), In--);
            }
            function K(e, t) {
                In++, (Io[In] = e.current), (e.current = t);
            }
            var Qt = {},
                Me = Xt(Qt),
                Re = Xt(!1),
                fn = Qt;
            function Un(e, t) {
                var n = e.type.contextTypes;
                if (!n) return Qt;
                var r = e.stateNode;
                if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
                    return r.__reactInternalMemoizedMaskedChildContext;
                var i = {},
                    l;
                for (l in n) i[l] = t[l];
                return (
                    r &&
                        ((e = e.stateNode),
                        (e.__reactInternalMemoizedUnmaskedChildContext = t),
                        (e.__reactInternalMemoizedMaskedChildContext = i)),
                    i
                );
            }
            function De(e) {
                return (e = e.childContextTypes), e != null;
            }
            function Hi() {
                $(Re), $(Me);
            }
            function Ku(e, t, n) {
                if (Me.current !== Qt) throw Error(S(168));
                K(Me, t), K(Re, n);
            }
            function mc(e, t, n) {
                var r = e.stateNode;
                if (((t = t.childContextTypes), typeof r.getChildContext != "function")) return n;
                r = r.getChildContext();
                for (var i in r) if (!(i in t)) throw Error(S(108, mf(e) || "Unknown", i));
                return le({}, n, r);
            }
            function qi(e) {
                return (
                    (e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || Qt),
                    (fn = Me.current),
                    K(Me, e),
                    K(Re, Re.current),
                    !0
                );
            }
            function Gu(e, t, n) {
                var r = e.stateNode;
                if (!r) throw Error(S(169));
                n
                    ? ((e = mc(e, t, fn)), (r.__reactInternalMemoizedMergedChildContext = e), $(Re), $(Me), K(Me, e))
                    : $(Re),
                    K(Re, n);
            }
            var _t = null,
                cl = !1,
                $l = !1;
            function gc(e) {
                _t === null ? (_t = [e]) : _t.push(e);
            }
            function Ip(e) {
                (cl = !0), gc(e);
            }
            function Yt() {
                if (!$l && _t !== null) {
                    $l = !0;
                    var e = 0,
                        t = H;
                    try {
                        var n = _t;
                        for (H = 1; e < n.length; e++) {
                            var r = n[e];
                            do r = r(!0);
                            while (r !== null);
                        }
                        (_t = null), (cl = !1);
                    } catch (i) {
                        throw (_t !== null && (_t = _t.slice(e + 1)), Ba(rs, Yt), i);
                    } finally {
                        (H = t), ($l = !1);
                    }
                }
                return null;
            }
            var Nn = [],
                Ln = 0,
                Ki = null,
                Gi = 0,
                Ge = [],
                $e = 0,
                pn = null,
                xt = 1,
                zt = "";
            function ln(e, t) {
                (Nn[Ln++] = Gi), (Nn[Ln++] = Ki), (Ki = e), (Gi = t);
            }
            function vc(e, t, n) {
                (Ge[$e++] = xt), (Ge[$e++] = zt), (Ge[$e++] = pn), (pn = e);
                var r = xt;
                e = zt;
                var i = 32 - it(r) - 1;
                (r &= ~(1 << i)), (n += 1);
                var l = 32 - it(t) + i;
                if (30 < l) {
                    var o = i - (i % 5);
                    (l = (r & ((1 << o) - 1)).toString(32)),
                        (r >>= o),
                        (i -= o),
                        (xt = (1 << (32 - it(t) + i)) | (n << i) | r),
                        (zt = l + e);
                } else (xt = (1 << l) | (n << i) | r), (zt = e);
            }
            function fs(e) {
                e.return !== null && (ln(e, 1), vc(e, 1, 0));
            }
            function ps(e) {
                for (; e === Ki; ) (Ki = Nn[--Ln]), (Nn[Ln] = null), (Gi = Nn[--Ln]), (Nn[Ln] = null);
                for (; e === pn; )
                    (pn = Ge[--$e]),
                        (Ge[$e] = null),
                        (zt = Ge[--$e]),
                        (Ge[$e] = null),
                        (xt = Ge[--$e]),
                        (Ge[$e] = null);
            }
            var be = null,
                Fe = null,
                Y = !1,
                rt = null;
            function yc(e, t) {
                var n = Qe(5, null, null, 0);
                (n.elementType = "DELETED"),
                    (n.stateNode = t),
                    (n.return = e),
                    (t = e.deletions),
                    t === null ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n);
            }
            function $u(e, t) {
                switch (e.tag) {
                    case 5:
                        var n = e.type;
                        return (
                            (t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t),
                            t !== null ? ((e.stateNode = t), (be = e), (Fe = Ut(t.firstChild)), !0) : !1
                        );
                    case 6:
                        return (
                            (t = e.pendingProps === "" || t.nodeType !== 3 ? null : t),
                            t !== null ? ((e.stateNode = t), (be = e), (Fe = null), !0) : !1
                        );
                    case 13:
                        return (
                            (t = t.nodeType !== 8 ? null : t),
                            t !== null
                                ? ((n = pn !== null ? { id: xt, overflow: zt } : null),
                                  (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
                                  (n = Qe(18, null, null, 0)),
                                  (n.stateNode = t),
                                  (n.return = e),
                                  (e.child = n),
                                  (be = e),
                                  (Fe = null),
                                  !0)
                                : !1
                        );
                    default:
                        return !1;
                }
            }
            function No(e) {
                return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
            }
            function Lo(e) {
                if (Y) {
                    var t = Fe;
                    if (t) {
                        var n = t;
                        if (!$u(e, t)) {
                            if (No(e)) throw Error(S(418));
                            t = Ut(n.nextSibling);
                            var r = be;
                            t && $u(e, t) ? yc(r, n) : ((e.flags = (e.flags & -4097) | 2), (Y = !1), (be = e));
                        }
                    } else {
                        if (No(e)) throw Error(S(418));
                        (e.flags = (e.flags & -4097) | 2), (Y = !1), (be = e);
                    }
                }
            }
            function Qu(e) {
                for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
                be = e;
            }
            function ki(e) {
                if (e !== be) return !1;
                if (!Y) return Qu(e), (Y = !0), !1;
                var t;
                if (
                    ((t = e.tag !== 3) &&
                        !(t = e.tag !== 5) &&
                        ((t = e.type), (t = t !== "head" && t !== "body" && !Co(e.type, e.memoizedProps))),
                    t && (t = Fe))
                ) {
                    if (No(e)) throw (wc(), Error(S(418)));
                    for (; t; ) yc(e, t), (t = Ut(t.nextSibling));
                }
                if ((Qu(e), e.tag === 13)) {
                    if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e)) throw Error(S(317));
                    e: {
                        for (e = e.nextSibling, t = 0; e; ) {
                            if (e.nodeType === 8) {
                                var n = e.data;
                                if (n === "/$") {
                                    if (t === 0) {
                                        Fe = Ut(e.nextSibling);
                                        break e;
                                    }
                                    t--;
                                } else (n !== "$" && n !== "$!" && n !== "$?") || t++;
                            }
                            e = e.nextSibling;
                        }
                        Fe = null;
                    }
                } else Fe = be ? Ut(e.stateNode.nextSibling) : null;
                return !0;
            }
            function wc() {
                for (var e = Fe; e; ) e = Ut(e.nextSibling);
            }
            function Hn() {
                (Fe = be = null), (Y = !1);
            }
            function hs(e) {
                rt === null ? (rt = [e]) : rt.push(e);
            }
            var Np = It.ReactCurrentBatchConfig;
            function dr(e, t, n) {
                if (((e = n.ref), e !== null && typeof e != "function" && typeof e != "object")) {
                    if (n._owner) {
                        if (((n = n._owner), n)) {
                            if (n.tag !== 1) throw Error(S(309));
                            var r = n.stateNode;
                        }
                        if (!r) throw Error(S(147, e));
                        var i = r,
                            l = "" + e;
                        return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === l
                            ? t.ref
                            : ((t = function (o) {
                                  var u = i.refs;
                                  o === null ? delete u[l] : (u[l] = o);
                              }),
                              (t._stringRef = l),
                              t);
                    }
                    if (typeof e != "string") throw Error(S(284));
                    if (!n._owner) throw Error(S(290, e));
                }
                return e;
            }
            function Si(e, t) {
                throw (
                    ((e = Object.prototype.toString.call(t)),
                    Error(S(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)))
                );
            }
            function Zu(e) {
                var t = e._init;
                return t(e._payload);
            }
            function kc(e) {
                function t(h, d) {
                    if (e) {
                        var p = h.deletions;
                        p === null ? ((h.deletions = [d]), (h.flags |= 16)) : p.push(d);
                    }
                }
                function n(h, d) {
                    if (!e) return null;
                    for (; d !== null; ) t(h, d), (d = d.sibling);
                    return null;
                }
                function r(h, d) {
                    for (h = new Map(); d !== null; )
                        d.key !== null ? h.set(d.key, d) : h.set(d.index, d), (d = d.sibling);
                    return h;
                }
                function i(h, d) {
                    return (h = Gt(h, d)), (h.index = 0), (h.sibling = null), h;
                }
                function l(h, d, p) {
                    return (
                        (h.index = p),
                        e
                            ? ((p = h.alternate),
                              p !== null ? ((p = p.index), p < d ? ((h.flags |= 2), d) : p) : ((h.flags |= 2), d))
                            : ((h.flags |= 1048576), d)
                    );
                }
                function o(h) {
                    return e && h.alternate === null && (h.flags |= 2), h;
                }
                function u(h, d, p, y) {
                    return d === null || d.tag !== 6
                        ? ((d = to(p, h.mode, y)), (d.return = h), d)
                        : ((d = i(d, p)), (d.return = h), d);
                }
                function a(h, d, p, y) {
                    var z = p.type;
                    return z === En
                        ? m(h, d, p.props.children, y, p.key)
                        : d !== null &&
                            (d.elementType === z ||
                                (typeof z == "object" && z !== null && z.$$typeof === Vt && Zu(z) === d.type))
                          ? ((y = i(d, p.props)), (y.ref = dr(h, d, p)), (y.return = h), y)
                          : ((y = Vi(p.type, p.key, p.props, null, h.mode, y)),
                            (y.ref = dr(h, d, p)),
                            (y.return = h),
                            y);
                }
                function c(h, d, p, y) {
                    return d === null ||
                        d.tag !== 4 ||
                        d.stateNode.containerInfo !== p.containerInfo ||
                        d.stateNode.implementation !== p.implementation
                        ? ((d = no(p, h.mode, y)), (d.return = h), d)
                        : ((d = i(d, p.children || [])), (d.return = h), d);
                }
                function m(h, d, p, y, z) {
                    return d === null || d.tag !== 7
                        ? ((d = dn(p, h.mode, y, z)), (d.return = h), d)
                        : ((d = i(d, p)), (d.return = h), d);
                }
                function g(h, d, p) {
                    if ((typeof d == "string" && d !== "") || typeof d == "number")
                        return (d = to("" + d, h.mode, p)), (d.return = h), d;
                    if (typeof d == "object" && d !== null) {
                        switch (d.$$typeof) {
                            case oi:
                                return (
                                    (p = Vi(d.type, d.key, d.props, null, h.mode, p)),
                                    (p.ref = dr(h, null, d)),
                                    (p.return = h),
                                    p
                                );
                            case zn:
                                return (d = no(d, h.mode, p)), (d.return = h), d;
                            case Vt:
                                var y = d._init;
                                return g(h, y(d._payload), p);
                        }
                        if (gr(d) || sr(d)) return (d = dn(d, h.mode, p, null)), (d.return = h), d;
                        Si(h, d);
                    }
                    return null;
                }
                function f(h, d, p, y) {
                    var z = d !== null ? d.key : null;
                    if ((typeof p == "string" && p !== "") || typeof p == "number")
                        return z !== null ? null : u(h, d, "" + p, y);
                    if (typeof p == "object" && p !== null) {
                        switch (p.$$typeof) {
                            case oi:
                                return p.key === z ? a(h, d, p, y) : null;
                            case zn:
                                return p.key === z ? c(h, d, p, y) : null;
                            case Vt:
                                return (z = p._init), f(h, d, z(p._payload), y);
                        }
                        if (gr(p) || sr(p)) return z !== null ? null : m(h, d, p, y, null);
                        Si(h, p);
                    }
                    return null;
                }
                function v(h, d, p, y, z) {
                    if ((typeof y == "string" && y !== "") || typeof y == "number")
                        return (h = h.get(p) || null), u(d, h, "" + y, z);
                    if (typeof y == "object" && y !== null) {
                        switch (y.$$typeof) {
                            case oi:
                                return (h = h.get(y.key === null ? p : y.key) || null), a(d, h, y, z);
                            case zn:
                                return (h = h.get(y.key === null ? p : y.key) || null), c(d, h, y, z);
                            case Vt:
                                var C = y._init;
                                return v(h, d, p, C(y._payload), z);
                        }
                        if (gr(y) || sr(y)) return (h = h.get(p) || null), m(d, h, y, z, null);
                        Si(d, y);
                    }
                    return null;
                }
                function k(h, d, p, y) {
                    for (var z = null, C = null, I = d, T = (d = 0), O = null; I !== null && T < p.length; T++) {
                        I.index > T ? ((O = I), (I = null)) : (O = I.sibling);
                        var D = f(h, I, p[T], y);
                        if (D === null) {
                            I === null && (I = O);
                            break;
                        }
                        e && I && D.alternate === null && t(h, I),
                            (d = l(D, d, T)),
                            C === null ? (z = D) : (C.sibling = D),
                            (C = D),
                            (I = O);
                    }
                    if (T === p.length) return n(h, I), Y && ln(h, T), z;
                    if (I === null) {
                        for (; T < p.length; T++)
                            (I = g(h, p[T], y)),
                                I !== null && ((d = l(I, d, T)), C === null ? (z = I) : (C.sibling = I), (C = I));
                        return Y && ln(h, T), z;
                    }
                    for (I = r(h, I); T < p.length; T++)
                        (O = v(I, h, T, p[T], y)),
                            O !== null &&
                                (e && O.alternate !== null && I.delete(O.key === null ? T : O.key),
                                (d = l(O, d, T)),
                                C === null ? (z = O) : (C.sibling = O),
                                (C = O));
                    return (
                        e &&
                            I.forEach(function (J) {
                                return t(h, J);
                            }),
                        Y && ln(h, T),
                        z
                    );
                }
                function x(h, d, p, y) {
                    var z = sr(p);
                    if (typeof z != "function") throw Error(S(150));
                    if (((p = z.call(p)), p == null)) throw Error(S(151));
                    for (
                        var C = (z = null), I = d, T = (d = 0), O = null, D = p.next();
                        I !== null && !D.done;
                        T++, D = p.next()
                    ) {
                        I.index > T ? ((O = I), (I = null)) : (O = I.sibling);
                        var J = f(h, I, D.value, y);
                        if (J === null) {
                            I === null && (I = O);
                            break;
                        }
                        e && I && J.alternate === null && t(h, I),
                            (d = l(J, d, T)),
                            C === null ? (z = J) : (C.sibling = J),
                            (C = J),
                            (I = O);
                    }
                    if (D.done) return n(h, I), Y && ln(h, T), z;
                    if (I === null) {
                        for (; !D.done; T++, D = p.next())
                            (D = g(h, D.value, y)),
                                D !== null && ((d = l(D, d, T)), C === null ? (z = D) : (C.sibling = D), (C = D));
                        return Y && ln(h, T), z;
                    }
                    for (I = r(h, I); !D.done; T++, D = p.next())
                        (D = v(I, h, T, D.value, y)),
                            D !== null &&
                                (e && D.alternate !== null && I.delete(D.key === null ? T : D.key),
                                (d = l(D, d, T)),
                                C === null ? (z = D) : (C.sibling = D),
                                (C = D));
                    return (
                        e &&
                            I.forEach(function (st) {
                                return t(h, st);
                            }),
                        Y && ln(h, T),
                        z
                    );
                }
                function R(h, d, p, y) {
                    if (
                        (typeof p == "object" &&
                            p !== null &&
                            p.type === En &&
                            p.key === null &&
                            (p = p.props.children),
                        typeof p == "object" && p !== null)
                    ) {
                        switch (p.$$typeof) {
                            case oi:
                                e: {
                                    for (var z = p.key, C = d; C !== null; ) {
                                        if (C.key === z) {
                                            if (((z = p.type), z === En)) {
                                                if (C.tag === 7) {
                                                    n(h, C.sibling),
                                                        (d = i(C, p.props.children)),
                                                        (d.return = h),
                                                        (h = d);
                                                    break e;
                                                }
                                            } else if (
                                                C.elementType === z ||
                                                (typeof z == "object" &&
                                                    z !== null &&
                                                    z.$$typeof === Vt &&
                                                    Zu(z) === C.type)
                                            ) {
                                                n(h, C.sibling),
                                                    (d = i(C, p.props)),
                                                    (d.ref = dr(h, C, p)),
                                                    (d.return = h),
                                                    (h = d);
                                                break e;
                                            }
                                            n(h, C);
                                            break;
                                        } else t(h, C);
                                        C = C.sibling;
                                    }
                                    p.type === En
                                        ? ((d = dn(p.props.children, h.mode, y, p.key)), (d.return = h), (h = d))
                                        : ((y = Vi(p.type, p.key, p.props, null, h.mode, y)),
                                          (y.ref = dr(h, d, p)),
                                          (y.return = h),
                                          (h = y));
                                }
                                return o(h);
                            case zn:
                                e: {
                                    for (C = p.key; d !== null; ) {
                                        if (d.key === C)
                                            if (
                                                d.tag === 4 &&
                                                d.stateNode.containerInfo === p.containerInfo &&
                                                d.stateNode.implementation === p.implementation
                                            ) {
                                                n(h, d.sibling), (d = i(d, p.children || [])), (d.return = h), (h = d);
                                                break e;
                                            } else {
                                                n(h, d);
                                                break;
                                            }
                                        else t(h, d);
                                        d = d.sibling;
                                    }
                                    (d = no(p, h.mode, y)), (d.return = h), (h = d);
                                }
                                return o(h);
                            case Vt:
                                return (C = p._init), R(h, d, C(p._payload), y);
                        }
                        if (gr(p)) return k(h, d, p, y);
                        if (sr(p)) return x(h, d, p, y);
                        Si(h, p);
                    }
                    return (typeof p == "string" && p !== "") || typeof p == "number"
                        ? ((p = "" + p),
                          d !== null && d.tag === 6
                              ? (n(h, d.sibling), (d = i(d, p)), (d.return = h), (h = d))
                              : (n(h, d), (d = to(p, h.mode, y)), (d.return = h), (h = d)),
                          o(h))
                        : n(h, d);
                }
                return R;
            }
            var qn = kc(!0),
                Sc = kc(!1),
                $i = Xt(null),
                Qi = null,
                Wn = null,
                ms = null;
            function gs() {
                ms = Wn = Qi = null;
            }
            function vs(e) {
                var t = $i.current;
                $($i), (e._currentValue = t);
            }
            function Wo(e, t, n) {
                for (; e !== null; ) {
                    var r = e.alternate;
                    if (
                        ((e.childLanes & t) !== t
                            ? ((e.childLanes |= t), r !== null && (r.childLanes |= t))
                            : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t),
                        e === n)
                    )
                        break;
                    e = e.return;
                }
            }
            function bn(e, t) {
                (Qi = e),
                    (ms = Wn = null),
                    (e = e.dependencies),
                    e !== null &&
                        e.firstContext !== null &&
                        ((e.lanes & t) !== 0 && (Ve = !0), (e.firstContext = null));
            }
            function Xe(e) {
                var t = e._currentValue;
                if (ms !== e)
                    if (((e = { context: e, memoizedValue: t, next: null }), Wn === null)) {
                        if (Qi === null) throw Error(S(308));
                        (Wn = e), (Qi.dependencies = { lanes: 0, firstContext: e });
                    } else Wn = Wn.next = e;
                return t;
            }
            var un = null;
            function ys(e) {
                un === null ? (un = [e]) : un.push(e);
            }
            function _c(e, t, n, r) {
                var i = t.interleaved;
                return (
                    i === null ? ((n.next = n), ys(t)) : ((n.next = i.next), (i.next = n)),
                    (t.interleaved = n),
                    Mt(e, r)
                );
            }
            function Mt(e, t) {
                e.lanes |= t;
                var n = e.alternate;
                for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; )
                    (e.childLanes |= t), (n = e.alternate), n !== null && (n.childLanes |= t), (n = e), (e = e.return);
                return n.tag === 3 ? n.stateNode : null;
            }
            var Rt = !1;
            function ws(e) {
                e.updateQueue = {
                    baseState: e.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: { pending: null, interleaved: null, lanes: 0 },
                    effects: null,
                };
            }
            function xc(e, t) {
                (e = e.updateQueue),
                    t.updateQueue === e &&
                        (t.updateQueue = {
                            baseState: e.baseState,
                            firstBaseUpdate: e.firstBaseUpdate,
                            lastBaseUpdate: e.lastBaseUpdate,
                            shared: e.shared,
                            effects: e.effects,
                        });
            }
            function Et(e, t) {
                return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
            }
            function Ht(e, t, n) {
                var r = e.updateQueue;
                if (r === null) return null;
                if (((r = r.shared), (j & 2) !== 0)) {
                    var i = r.pending;
                    return i === null ? (t.next = t) : ((t.next = i.next), (i.next = t)), (r.pending = t), Mt(e, n);
                }
                return (
                    (i = r.interleaved),
                    i === null ? ((t.next = t), ys(r)) : ((t.next = i.next), (i.next = t)),
                    (r.interleaved = t),
                    Mt(e, n)
                );
            }
            function Mi(e, t, n) {
                if (((t = t.updateQueue), t !== null && ((t = t.shared), (n & 4194240) !== 0))) {
                    var r = t.lanes;
                    (r &= e.pendingLanes), (n |= r), (t.lanes = n), is(e, n);
                }
            }
            function Xu(e, t) {
                var n = e.updateQueue,
                    r = e.alternate;
                if (r !== null && ((r = r.updateQueue), n === r)) {
                    var i = null,
                        l = null;
                    if (((n = n.firstBaseUpdate), n !== null)) {
                        do {
                            var o = {
                                eventTime: n.eventTime,
                                lane: n.lane,
                                tag: n.tag,
                                payload: n.payload,
                                callback: n.callback,
                                next: null,
                            };
                            l === null ? (i = l = o) : (l = l.next = o), (n = n.next);
                        } while (n !== null);
                        l === null ? (i = l = t) : (l = l.next = t);
                    } else i = l = t;
                    (n = {
                        baseState: r.baseState,
                        firstBaseUpdate: i,
                        lastBaseUpdate: l,
                        shared: r.shared,
                        effects: r.effects,
                    }),
                        (e.updateQueue = n);
                    return;
                }
                (e = n.lastBaseUpdate), e === null ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t);
            }
            function Zi(e, t, n, r) {
                var i = e.updateQueue;
                Rt = !1;
                var l = i.firstBaseUpdate,
                    o = i.lastBaseUpdate,
                    u = i.shared.pending;
                if (u !== null) {
                    i.shared.pending = null;
                    var a = u,
                        c = a.next;
                    (a.next = null), o === null ? (l = c) : (o.next = c), (o = a);
                    var m = e.alternate;
                    m !== null &&
                        ((m = m.updateQueue),
                        (u = m.lastBaseUpdate),
                        u !== o && (u === null ? (m.firstBaseUpdate = c) : (u.next = c), (m.lastBaseUpdate = a)));
                }
                if (l !== null) {
                    var g = i.baseState;
                    (o = 0), (m = c = a = null), (u = l);
                    do {
                        var f = u.lane,
                            v = u.eventTime;
                        if ((r & f) === f) {
                            m !== null &&
                                (m = m.next =
                                    {
                                        eventTime: v,
                                        lane: 0,
                                        tag: u.tag,
                                        payload: u.payload,
                                        callback: u.callback,
                                        next: null,
                                    });
                            e: {
                                var k = e,
                                    x = u;
                                switch (((f = t), (v = n), x.tag)) {
                                    case 1:
                                        if (((k = x.payload), typeof k == "function")) {
                                            g = k.call(v, g, f);
                                            break e;
                                        }
                                        g = k;
                                        break e;
                                    case 3:
                                        k.flags = (k.flags & -65537) | 128;
                                    case 0:
                                        if (
                                            ((k = x.payload),
                                            (f = typeof k == "function" ? k.call(v, g, f) : k),
                                            f == null)
                                        )
                                            break e;
                                        g = le({}, g, f);
                                        break e;
                                    case 2:
                                        Rt = !0;
                                }
                            }
                            u.callback !== null &&
                                u.lane !== 0 &&
                                ((e.flags |= 64), (f = i.effects), f === null ? (i.effects = [u]) : f.push(u));
                        } else
                            (v = {
                                eventTime: v,
                                lane: f,
                                tag: u.tag,
                                payload: u.payload,
                                callback: u.callback,
                                next: null,
                            }),
                                m === null ? ((c = m = v), (a = g)) : (m = m.next = v),
                                (o |= f);
                        if (((u = u.next), u === null)) {
                            if (((u = i.shared.pending), u === null)) break;
                            (f = u), (u = f.next), (f.next = null), (i.lastBaseUpdate = f), (i.shared.pending = null);
                        }
                    } while (!0);
                    if (
                        (m === null && (a = g),
                        (i.baseState = a),
                        (i.firstBaseUpdate = c),
                        (i.lastBaseUpdate = m),
                        (t = i.shared.interleaved),
                        t !== null)
                    ) {
                        i = t;
                        do (o |= i.lane), (i = i.next);
                        while (i !== t);
                    } else l === null && (i.shared.lanes = 0);
                    (mn |= o), (e.lanes = o), (e.memoizedState = g);
                }
            }
            function Yu(e, t, n) {
                if (((e = t.effects), (t.effects = null), e !== null))
                    for (t = 0; t < e.length; t++) {
                        var r = e[t],
                            i = r.callback;
                        if (i !== null) {
                            if (((r.callback = null), (r = n), typeof i != "function")) throw Error(S(191, i));
                            i.call(r);
                        }
                    }
            }
            var $r = {},
                gt = Xt($r),
                Fr = Xt($r),
                br = Xt($r);
            function an(e) {
                if (e === $r) throw Error(S(174));
                return e;
            }
            function ks(e, t) {
                switch ((K(br, t), K(Fr, e), K(gt, $r), (e = t.nodeType), e)) {
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : po(null, "");
                        break;
                    default:
                        (e = e === 8 ? t.parentNode : t), (t = e.namespaceURI || null), (e = e.tagName), (t = po(t, e));
                }
                $(gt), K(gt, t);
            }
            function Kn() {
                $(gt), $(Fr), $(br);
            }
            function zc(e) {
                an(br.current);
                var t = an(gt.current),
                    n = po(t, e.type);
                t !== n && (K(Fr, e), K(gt, n));
            }
            function Ss(e) {
                Fr.current === e && ($(gt), $(Fr));
            }
            var re = Xt(0);
            function Xi(e) {
                for (var t = e; t !== null; ) {
                    if (t.tag === 13) {
                        var n = t.memoizedState;
                        if (n !== null && ((n = n.dehydrated), n === null || n.data === "$?" || n.data === "$!"))
                            return t;
                    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
                        if ((t.flags & 128) !== 0) return t;
                    } else if (t.child !== null) {
                        (t.child.return = t), (t = t.child);
                        continue;
                    }
                    if (t === e) break;
                    for (; t.sibling === null; ) {
                        if (t.return === null || t.return === e) return null;
                        t = t.return;
                    }
                    (t.sibling.return = t.return), (t = t.sibling);
                }
                return null;
            }
            var Ql = [];
            function _s() {
                for (var e = 0; e < Ql.length; e++) Ql[e]._workInProgressVersionPrimary = null;
                Ql.length = 0;
            }
            var Ti = It.ReactCurrentDispatcher,
                Zl = It.ReactCurrentBatchConfig,
                hn = 0,
                ie = null,
                pe = null,
                ge = null,
                Yi = !1,
                zr = !1,
                Br = 0,
                Lp = 0;
            function Ee() {
                throw Error(S(321));
            }
            function xs(e, t) {
                if (t === null) return !1;
                for (var n = 0; n < t.length && n < e.length; n++) if (!ot(e[n], t[n])) return !1;
                return !0;
            }
            function zs(e, t, n, r, i, l) {
                if (
                    ((hn = l),
                    (ie = t),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    (t.lanes = 0),
                    (Ti.current = e === null || e.memoizedState === null ? Dp : Op),
                    (e = n(r, i)),
                    zr)
                ) {
                    l = 0;
                    do {
                        if (((zr = !1), (Br = 0), 25 <= l)) throw Error(S(301));
                        (l += 1), (ge = pe = null), (t.updateQueue = null), (Ti.current = Ap), (e = n(r, i));
                    } while (zr);
                }
                if (
                    ((Ti.current = Ji),
                    (t = pe !== null && pe.next !== null),
                    (hn = 0),
                    (ge = pe = ie = null),
                    (Yi = !1),
                    t)
                )
                    throw Error(S(300));
                return e;
            }
            function Es() {
                var e = Br !== 0;
                return (Br = 0), e;
            }
            function pt() {
                var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
                return ge === null ? (ie.memoizedState = ge = e) : (ge = ge.next = e), ge;
            }
            function Ye() {
                if (pe === null) {
                    var e = ie.alternate;
                    e = e !== null ? e.memoizedState : null;
                } else e = pe.next;
                var t = ge === null ? ie.memoizedState : ge.next;
                if (t !== null) (ge = t), (pe = e);
                else {
                    if (e === null) throw Error(S(310));
                    (pe = e),
                        (e = {
                            memoizedState: pe.memoizedState,
                            baseState: pe.baseState,
                            baseQueue: pe.baseQueue,
                            queue: pe.queue,
                            next: null,
                        }),
                        ge === null ? (ie.memoizedState = ge = e) : (ge = ge.next = e);
                }
                return ge;
            }
            function jr(e, t) {
                return typeof t == "function" ? t(e) : t;
            }
            function Xl(e) {
                var t = Ye(),
                    n = t.queue;
                if (n === null) throw Error(S(311));
                n.lastRenderedReducer = e;
                var r = pe,
                    i = r.baseQueue,
                    l = n.pending;
                if (l !== null) {
                    if (i !== null) {
                        var o = i.next;
                        (i.next = l.next), (l.next = o);
                    }
                    (r.baseQueue = i = l), (n.pending = null);
                }
                if (i !== null) {
                    (l = i.next), (r = r.baseState);
                    var u = (o = null),
                        a = null,
                        c = l;
                    do {
                        var m = c.lane;
                        if ((hn & m) === m)
                            a !== null &&
                                (a = a.next =
                                    {
                                        lane: 0,
                                        action: c.action,
                                        hasEagerState: c.hasEagerState,
                                        eagerState: c.eagerState,
                                        next: null,
                                    }),
                                (r = c.hasEagerState ? c.eagerState : e(r, c.action));
                        else {
                            var g = {
                                lane: m,
                                action: c.action,
                                hasEagerState: c.hasEagerState,
                                eagerState: c.eagerState,
                                next: null,
                            };
                            a === null ? ((u = a = g), (o = r)) : (a = a.next = g), (ie.lanes |= m), (mn |= m);
                        }
                        c = c.next;
                    } while (c !== null && c !== l);
                    a === null ? (o = r) : (a.next = u),
                        ot(r, t.memoizedState) || (Ve = !0),
                        (t.memoizedState = r),
                        (t.baseState = o),
                        (t.baseQueue = a),
                        (n.lastRenderedState = r);
                }
                if (((e = n.interleaved), e !== null)) {
                    i = e;
                    do (l = i.lane), (ie.lanes |= l), (mn |= l), (i = i.next);
                    while (i !== e);
                } else i === null && (n.lanes = 0);
                return [t.memoizedState, n.dispatch];
            }
            function Yl(e) {
                var t = Ye(),
                    n = t.queue;
                if (n === null) throw Error(S(311));
                n.lastRenderedReducer = e;
                var r = n.dispatch,
                    i = n.pending,
                    l = t.memoizedState;
                if (i !== null) {
                    n.pending = null;
                    var o = (i = i.next);
                    do (l = e(l, o.action)), (o = o.next);
                    while (o !== i);
                    ot(l, t.memoizedState) || (Ve = !0),
                        (t.memoizedState = l),
                        t.baseQueue === null && (t.baseState = l),
                        (n.lastRenderedState = l);
                }
                return [l, r];
            }
            function Ec() {}
            function Pc(e, t) {
                var n = ie,
                    r = Ye(),
                    i = t(),
                    l = !ot(r.memoizedState, i);
                if (
                    (l && ((r.memoizedState = i), (Ve = !0)),
                    (r = r.queue),
                    Ps(Tc.bind(null, n, r, e), [e]),
                    r.getSnapshot !== t || l || (ge !== null && ge.memoizedState.tag & 1))
                ) {
                    if (((n.flags |= 2048), Ur(9, Mc.bind(null, n, r, i, t), void 0, null), ve === null))
                        throw Error(S(349));
                    (hn & 30) !== 0 || Cc(n, t, i);
                }
                return i;
            }
            function Cc(e, t, n) {
                (e.flags |= 16384),
                    (e = { getSnapshot: t, value: n }),
                    (t = ie.updateQueue),
                    t === null
                        ? ((t = { lastEffect: null, stores: null }), (ie.updateQueue = t), (t.stores = [e]))
                        : ((n = t.stores), n === null ? (t.stores = [e]) : n.push(e));
            }
            function Mc(e, t, n, r) {
                (t.value = n), (t.getSnapshot = r), Ic(t) && Nc(e);
            }
            function Tc(e, t, n) {
                return n(function () {
                    Ic(t) && Nc(e);
                });
            }
            function Ic(e) {
                var t = e.getSnapshot;
                e = e.value;
                try {
                    var n = t();
                    return !ot(e, n);
                } catch {
                    return !0;
                }
            }
            function Nc(e) {
                var t = Mt(e, 1);
                t !== null && lt(t, e, 1, -1);
            }
            function Ju(e) {
                var t = pt();
                return (
                    typeof e == "function" && (e = e()),
                    (t.memoizedState = t.baseState = e),
                    (e = {
                        pending: null,
                        interleaved: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: jr,
                        lastRenderedState: e,
                    }),
                    (t.queue = e),
                    (e = e.dispatch = Rp.bind(null, ie, e)),
                    [t.memoizedState, e]
                );
            }
            function Ur(e, t, n, r) {
                return (
                    (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
                    (t = ie.updateQueue),
                    t === null
                        ? ((t = { lastEffect: null, stores: null }), (ie.updateQueue = t), (t.lastEffect = e.next = e))
                        : ((n = t.lastEffect),
                          n === null
                              ? (t.lastEffect = e.next = e)
                              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e))),
                    e
                );
            }
            function Lc() {
                return Ye().memoizedState;
            }
            function Ii(e, t, n, r) {
                var i = pt();
                (ie.flags |= e), (i.memoizedState = Ur(1 | t, n, void 0, r === void 0 ? null : r));
            }
            function dl(e, t, n, r) {
                var i = Ye();
                r = r === void 0 ? null : r;
                var l = void 0;
                if (pe !== null) {
                    var o = pe.memoizedState;
                    if (((l = o.destroy), r !== null && xs(r, o.deps))) {
                        i.memoizedState = Ur(t, n, l, r);
                        return;
                    }
                }
                (ie.flags |= e), (i.memoizedState = Ur(1 | t, n, l, r));
            }
            function ea(e, t) {
                return Ii(8390656, 8, e, t);
            }
            function Ps(e, t) {
                return dl(2048, 8, e, t);
            }
            function Wc(e, t) {
                return dl(4, 2, e, t);
            }
            function Vc(e, t) {
                return dl(4, 4, e, t);
            }
            function Rc(e, t) {
                if (typeof t == "function")
                    return (
                        (e = e()),
                        t(e),
                        function () {
                            t(null);
                        }
                    );
                if (t != null)
                    return (
                        (e = e()),
                        (t.current = e),
                        function () {
                            t.current = null;
                        }
                    );
            }
            function Dc(e, t, n) {
                return (n = n != null ? n.concat([e]) : null), dl(4, 4, Rc.bind(null, t, e), n);
            }
            function Cs() {}
            function Oc(e, t) {
                var n = Ye();
                t = t === void 0 ? null : t;
                var r = n.memoizedState;
                return r !== null && t !== null && xs(t, r[1]) ? r[0] : ((n.memoizedState = [e, t]), e);
            }
            function Ac(e, t) {
                var n = Ye();
                t = t === void 0 ? null : t;
                var r = n.memoizedState;
                return r !== null && t !== null && xs(t, r[1]) ? r[0] : ((e = e()), (n.memoizedState = [e, t]), e);
            }
            function Fc(e, t, n) {
                return (hn & 21) === 0
                    ? (e.baseState && ((e.baseState = !1), (Ve = !0)), (e.memoizedState = n))
                    : (ot(n, t) || ((n = Ha()), (ie.lanes |= n), (mn |= n), (e.baseState = !0)), t);
            }
            function Wp(e, t) {
                var n = H;
                (H = n !== 0 && 4 > n ? n : 4), e(!0);
                var r = Zl.transition;
                Zl.transition = {};
                try {
                    e(!1), t();
                } finally {
                    (H = n), (Zl.transition = r);
                }
            }
            function bc() {
                return Ye().memoizedState;
            }
            function Vp(e, t, n) {
                var r = Kt(e);
                if (((n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }), Bc(e))) jc(t, n);
                else if (((n = _c(e, t, n, r)), n !== null)) {
                    var i = Ne();
                    lt(n, e, r, i), Uc(n, t, r);
                }
            }
            function Rp(e, t, n) {
                var r = Kt(e),
                    i = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
                if (Bc(e)) jc(t, i);
                else {
                    var l = e.alternate;
                    if (e.lanes === 0 && (l === null || l.lanes === 0) && ((l = t.lastRenderedReducer), l !== null))
                        try {
                            var o = t.lastRenderedState,
                                u = l(o, n);
                            if (((i.hasEagerState = !0), (i.eagerState = u), ot(u, o))) {
                                var a = t.interleaved;
                                a === null ? ((i.next = i), ys(t)) : ((i.next = a.next), (a.next = i)),
                                    (t.interleaved = i);
                                return;
                            }
                        } catch {
                        } finally {
                        }
                    (n = _c(e, t, i, r)), n !== null && ((i = Ne()), lt(n, e, r, i), Uc(n, t, r));
                }
            }
            function Bc(e) {
                var t = e.alternate;
                return e === ie || (t !== null && t === ie);
            }
            function jc(e, t) {
                zr = Yi = !0;
                var n = e.pending;
                n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t);
            }
            function Uc(e, t, n) {
                if ((n & 4194240) !== 0) {
                    var r = t.lanes;
                    (r &= e.pendingLanes), (n |= r), (t.lanes = n), is(e, n);
                }
            }
            var Ji = {
                    readContext: Xe,
                    useCallback: Ee,
                    useContext: Ee,
                    useEffect: Ee,
                    useImperativeHandle: Ee,
                    useInsertionEffect: Ee,
                    useLayoutEffect: Ee,
                    useMemo: Ee,
                    useReducer: Ee,
                    useRef: Ee,
                    useState: Ee,
                    useDebugValue: Ee,
                    useDeferredValue: Ee,
                    useTransition: Ee,
                    useMutableSource: Ee,
                    useSyncExternalStore: Ee,
                    useId: Ee,
                    unstable_isNewReconciler: !1,
                },
                Dp = {
                    readContext: Xe,
                    useCallback: function (e, t) {
                        return (pt().memoizedState = [e, t === void 0 ? null : t]), e;
                    },
                    useContext: Xe,
                    useEffect: ea,
                    useImperativeHandle: function (e, t, n) {
                        return (n = n != null ? n.concat([e]) : null), Ii(4194308, 4, Rc.bind(null, t, e), n);
                    },
                    useLayoutEffect: function (e, t) {
                        return Ii(4194308, 4, e, t);
                    },
                    useInsertionEffect: function (e, t) {
                        return Ii(4, 2, e, t);
                    },
                    useMemo: function (e, t) {
                        var n = pt();
                        return (t = t === void 0 ? null : t), (e = e()), (n.memoizedState = [e, t]), e;
                    },
                    useReducer: function (e, t, n) {
                        var r = pt();
                        return (
                            (t = n !== void 0 ? n(t) : t),
                            (r.memoizedState = r.baseState = t),
                            (e = {
                                pending: null,
                                interleaved: null,
                                lanes: 0,
                                dispatch: null,
                                lastRenderedReducer: e,
                                lastRenderedState: t,
                            }),
                            (r.queue = e),
                            (e = e.dispatch = Vp.bind(null, ie, e)),
                            [r.memoizedState, e]
                        );
                    },
                    useRef: function (e) {
                        var t = pt();
                        return (e = { current: e }), (t.memoizedState = e);
                    },
                    useState: Ju,
                    useDebugValue: Cs,
                    useDeferredValue: function (e) {
                        return (pt().memoizedState = e);
                    },
                    useTransition: function () {
                        var e = Ju(!1),
                            t = e[0];
                        return (e = Wp.bind(null, e[1])), (pt().memoizedState = e), [t, e];
                    },
                    useMutableSource: function () {},
                    useSyncExternalStore: function (e, t, n) {
                        var r = ie,
                            i = pt();
                        if (Y) {
                            if (n === void 0) throw Error(S(407));
                            n = n();
                        } else {
                            if (((n = t()), ve === null)) throw Error(S(349));
                            (hn & 30) !== 0 || Cc(r, t, n);
                        }
                        i.memoizedState = n;
                        var l = { value: n, getSnapshot: t };
                        return (
                            (i.queue = l),
                            ea(Tc.bind(null, r, l, e), [e]),
                            (r.flags |= 2048),
                            Ur(9, Mc.bind(null, r, l, n, t), void 0, null),
                            n
                        );
                    },
                    useId: function () {
                        var e = pt(),
                            t = ve.identifierPrefix;
                        if (Y) {
                            var n = zt,
                                r = xt;
                            (n = (r & ~(1 << (32 - it(r) - 1))).toString(32) + n),
                                (t = ":" + t + "R" + n),
                                (n = Br++),
                                0 < n && (t += "H" + n.toString(32)),
                                (t += ":");
                        } else (n = Lp++), (t = ":" + t + "r" + n.toString(32) + ":");
                        return (e.memoizedState = t);
                    },
                    unstable_isNewReconciler: !1,
                },
                Op = {
                    readContext: Xe,
                    useCallback: Oc,
                    useContext: Xe,
                    useEffect: Ps,
                    useImperativeHandle: Dc,
                    useInsertionEffect: Wc,
                    useLayoutEffect: Vc,
                    useMemo: Ac,
                    useReducer: Xl,
                    useRef: Lc,
                    useState: function () {
                        return Xl(jr);
                    },
                    useDebugValue: Cs,
                    useDeferredValue: function (e) {
                        var t = Ye();
                        return Fc(t, pe.memoizedState, e);
                    },
                    useTransition: function () {
                        var e = Xl(jr)[0],
                            t = Ye().memoizedState;
                        return [e, t];
                    },
                    useMutableSource: Ec,
                    useSyncExternalStore: Pc,
                    useId: bc,
                    unstable_isNewReconciler: !1,
                },
                Ap = {
                    readContext: Xe,
                    useCallback: Oc,
                    useContext: Xe,
                    useEffect: Ps,
                    useImperativeHandle: Dc,
                    useInsertionEffect: Wc,
                    useLayoutEffect: Vc,
                    useMemo: Ac,
                    useReducer: Yl,
                    useRef: Lc,
                    useState: function () {
                        return Yl(jr);
                    },
                    useDebugValue: Cs,
                    useDeferredValue: function (e) {
                        var t = Ye();
                        return pe === null ? (t.memoizedState = e) : Fc(t, pe.memoizedState, e);
                    },
                    useTransition: function () {
                        var e = Yl(jr)[0],
                            t = Ye().memoizedState;
                        return [e, t];
                    },
                    useMutableSource: Ec,
                    useSyncExternalStore: Pc,
                    useId: bc,
                    unstable_isNewReconciler: !1,
                };
            function tt(e, t) {
                if (e && e.defaultProps) {
                    (t = le({}, t)), (e = e.defaultProps);
                    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
                    return t;
                }
                return t;
            }
            function Vo(e, t, n, r) {
                (t = e.memoizedState),
                    (n = n(r, t)),
                    (n = n == null ? t : le({}, t, n)),
                    (e.memoizedState = n),
                    e.lanes === 0 && (e.updateQueue.baseState = n);
            }
            var fl = {
                isMounted: function (e) {
                    return (e = e._reactInternals) ? yn(e) === e : !1;
                },
                enqueueSetState: function (e, t, n) {
                    e = e._reactInternals;
                    var r = Ne(),
                        i = Kt(e),
                        l = Et(r, i);
                    (l.payload = t),
                        n != null && (l.callback = n),
                        (t = Ht(e, l, i)),
                        t !== null && (lt(t, e, i, r), Mi(t, e, i));
                },
                enqueueReplaceState: function (e, t, n) {
                    e = e._reactInternals;
                    var r = Ne(),
                        i = Kt(e),
                        l = Et(r, i);
                    (l.tag = 1),
                        (l.payload = t),
                        n != null && (l.callback = n),
                        (t = Ht(e, l, i)),
                        t !== null && (lt(t, e, i, r), Mi(t, e, i));
                },
                enqueueForceUpdate: function (e, t) {
                    e = e._reactInternals;
                    var n = Ne(),
                        r = Kt(e),
                        i = Et(n, r);
                    (i.tag = 2),
                        t != null && (i.callback = t),
                        (t = Ht(e, i, r)),
                        t !== null && (lt(t, e, r, n), Mi(t, e, r));
                },
            };
            function ta(e, t, n, r, i, l, o) {
                return (
                    (e = e.stateNode),
                    typeof e.shouldComponentUpdate == "function"
                        ? e.shouldComponentUpdate(r, l, o)
                        : t.prototype && t.prototype.isPureReactComponent
                          ? !Rr(n, r) || !Rr(i, l)
                          : !0
                );
            }
            function Hc(e, t, n) {
                var r = !1,
                    i = Qt,
                    l = t.contextType;
                return (
                    typeof l == "object" && l !== null
                        ? (l = Xe(l))
                        : ((i = De(t) ? fn : Me.current), (r = t.contextTypes), (l = (r = r != null) ? Un(e, i) : Qt)),
                    (t = new t(n, l)),
                    (e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null),
                    (t.updater = fl),
                    (e.stateNode = t),
                    (t._reactInternals = e),
                    r &&
                        ((e = e.stateNode),
                        (e.__reactInternalMemoizedUnmaskedChildContext = i),
                        (e.__reactInternalMemoizedMaskedChildContext = l)),
                    t
                );
            }
            function na(e, t, n, r) {
                (e = t.state),
                    typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r),
                    typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r),
                    t.state !== e && fl.enqueueReplaceState(t, t.state, null);
            }
            function Ro(e, t, n, r) {
                var i = e.stateNode;
                (i.props = n), (i.state = e.memoizedState), (i.refs = {}), ws(e);
                var l = t.contextType;
                typeof l == "object" && l !== null
                    ? (i.context = Xe(l))
                    : ((l = De(t) ? fn : Me.current), (i.context = Un(e, l))),
                    (i.state = e.memoizedState),
                    (l = t.getDerivedStateFromProps),
                    typeof l == "function" && (Vo(e, t, l, n), (i.state = e.memoizedState)),
                    typeof t.getDerivedStateFromProps == "function" ||
                        typeof i.getSnapshotBeforeUpdate == "function" ||
                        (typeof i.UNSAFE_componentWillMount != "function" &&
                            typeof i.componentWillMount != "function") ||
                        ((t = i.state),
                        typeof i.componentWillMount == "function" && i.componentWillMount(),
                        typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(),
                        t !== i.state && fl.enqueueReplaceState(i, i.state, null),
                        Zi(e, n, i, r),
                        (i.state = e.memoizedState)),
                    typeof i.componentDidMount == "function" && (e.flags |= 4194308);
            }
            function Gn(e, t) {
                try {
                    var n = "",
                        r = t;
                    do (n += hf(r)), (r = r.return);
                    while (r);
                    var i = n;
                } catch (l) {
                    i =
                        `
Error generating stack: ` +
                        l.message +
                        `
` +
                        l.stack;
                }
                return { value: e, source: t, stack: i, digest: null };
            }
            function Jl(e, t, n) {
                return { value: e, source: null, stack: n ?? null, digest: t ?? null };
            }
            function Do(e, t) {
                try {
                    console.error(t.value);
                } catch (n) {
                    setTimeout(function () {
                        throw n;
                    });
                }
            }
            var Fp = typeof WeakMap == "function" ? WeakMap : Map;
            function qc(e, t, n) {
                (n = Et(-1, n)), (n.tag = 3), (n.payload = { element: null });
                var r = t.value;
                return (
                    (n.callback = function () {
                        tl || ((tl = !0), (Ko = r)), Do(e, t);
                    }),
                    n
                );
            }
            function Kc(e, t, n) {
                (n = Et(-1, n)), (n.tag = 3);
                var r = e.type.getDerivedStateFromError;
                if (typeof r == "function") {
                    var i = t.value;
                    (n.payload = function () {
                        return r(i);
                    }),
                        (n.callback = function () {
                            Do(e, t);
                        });
                }
                var l = e.stateNode;
                return (
                    l !== null &&
                        typeof l.componentDidCatch == "function" &&
                        (n.callback = function () {
                            Do(e, t), typeof r != "function" && (qt === null ? (qt = new Set([this])) : qt.add(this));
                            var o = t.stack;
                            this.componentDidCatch(t.value, { componentStack: o !== null ? o : "" });
                        }),
                    n
                );
            }
            function ra(e, t, n) {
                var r = e.pingCache;
                if (r === null) {
                    r = e.pingCache = new Fp();
                    var i = new Set();
                    r.set(t, i);
                } else (i = r.get(t)), i === void 0 && ((i = new Set()), r.set(t, i));
                i.has(n) || (i.add(n), (e = Jp.bind(null, e, t, n)), t.then(e, e));
            }
            function ia(e) {
                do {
                    var t;
                    if (
                        ((t = e.tag === 13) && ((t = e.memoizedState), (t = t !== null ? t.dehydrated !== null : !0)),
                        t)
                    )
                        return e;
                    e = e.return;
                } while (e !== null);
                return null;
            }
            function la(e, t, n, r, i) {
                return (e.mode & 1) === 0
                    ? (e === t
                          ? (e.flags |= 65536)
                          : ((e.flags |= 128),
                            (n.flags |= 131072),
                            (n.flags &= -52805),
                            n.tag === 1 &&
                                (n.alternate === null ? (n.tag = 17) : ((t = Et(-1, 1)), (t.tag = 2), Ht(n, t, 1))),
                            (n.lanes |= 1)),
                      e)
                    : ((e.flags |= 65536), (e.lanes = i), e);
            }
            var bp = It.ReactCurrentOwner,
                Ve = !1;
            function Ie(e, t, n, r) {
                t.child = e === null ? Sc(t, null, n, r) : qn(t, e.child, n, r);
            }
            function oa(e, t, n, r, i) {
                n = n.render;
                var l = t.ref;
                return (
                    bn(t, i),
                    (r = zs(e, t, n, r, l, i)),
                    (n = Es()),
                    e !== null && !Ve
                        ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Tt(e, t, i))
                        : (Y && n && fs(t), (t.flags |= 1), Ie(e, t, r, i), t.child)
                );
            }
            function sa(e, t, n, r, i) {
                if (e === null) {
                    var l = n.type;
                    return typeof l == "function" &&
                        !Rs(l) &&
                        l.defaultProps === void 0 &&
                        n.compare === null &&
                        n.defaultProps === void 0
                        ? ((t.tag = 15), (t.type = l), Gc(e, t, l, r, i))
                        : ((e = Vi(n.type, null, r, t, t.mode, i)), (e.ref = t.ref), (e.return = t), (t.child = e));
                }
                if (((l = e.child), (e.lanes & i) === 0)) {
                    var o = l.memoizedProps;
                    if (((n = n.compare), (n = n !== null ? n : Rr), n(o, r) && e.ref === t.ref)) return Tt(e, t, i);
                }
                return (t.flags |= 1), (e = Gt(l, r)), (e.ref = t.ref), (e.return = t), (t.child = e);
            }
            function Gc(e, t, n, r, i) {
                if (e !== null) {
                    var l = e.memoizedProps;
                    if (Rr(l, r) && e.ref === t.ref)
                        if (((Ve = !1), (t.pendingProps = r = l), (e.lanes & i) !== 0))
                            (e.flags & 131072) !== 0 && (Ve = !0);
                        else return (t.lanes = e.lanes), Tt(e, t, i);
                }
                return Oo(e, t, n, r, i);
            }
            function $c(e, t, n) {
                var r = t.pendingProps,
                    i = r.children,
                    l = e !== null ? e.memoizedState : null;
                if (r.mode === "hidden")
                    if ((t.mode & 1) === 0)
                        (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), K(Rn, Ae), (Ae |= n);
                    else {
                        if ((n & 1073741824) === 0)
                            return (
                                (e = l !== null ? l.baseLanes | n : n),
                                (t.lanes = t.childLanes = 1073741824),
                                (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
                                (t.updateQueue = null),
                                K(Rn, Ae),
                                (Ae |= e),
                                null
                            );
                        (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
                            (r = l !== null ? l.baseLanes : n),
                            K(Rn, Ae),
                            (Ae |= r);
                    }
                else l !== null ? ((r = l.baseLanes | n), (t.memoizedState = null)) : (r = n), K(Rn, Ae), (Ae |= r);
                return Ie(e, t, i, n), t.child;
            }
            function Qc(e, t) {
                var n = t.ref;
                ((e === null && n !== null) || (e !== null && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152));
            }
            function Oo(e, t, n, r, i) {
                var l = De(n) ? fn : Me.current;
                return (
                    (l = Un(t, l)),
                    bn(t, i),
                    (n = zs(e, t, n, r, l, i)),
                    (r = Es()),
                    e !== null && !Ve
                        ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~i), Tt(e, t, i))
                        : (Y && r && fs(t), (t.flags |= 1), Ie(e, t, n, i), t.child)
                );
            }
            function ua(e, t, n, r, i) {
                if (De(n)) {
                    var l = !0;
                    qi(t);
                } else l = !1;
                if ((bn(t, i), t.stateNode === null)) Ni(e, t), Hc(t, n, r), Ro(t, n, r, i), (r = !0);
                else if (e === null) {
                    var o = t.stateNode,
                        u = t.memoizedProps;
                    o.props = u;
                    var a = o.context,
                        c = n.contextType;
                    typeof c == "object" && c !== null ? (c = Xe(c)) : ((c = De(n) ? fn : Me.current), (c = Un(t, c)));
                    var m = n.getDerivedStateFromProps,
                        g = typeof m == "function" || typeof o.getSnapshotBeforeUpdate == "function";
                    g ||
                        (typeof o.UNSAFE_componentWillReceiveProps != "function" &&
                            typeof o.componentWillReceiveProps != "function") ||
                        ((u !== r || a !== c) && na(t, o, r, c)),
                        (Rt = !1);
                    var f = t.memoizedState;
                    (o.state = f),
                        Zi(t, r, o, i),
                        (a = t.memoizedState),
                        u !== r || f !== a || Re.current || Rt
                            ? (typeof m == "function" && (Vo(t, n, m, r), (a = t.memoizedState)),
                              (u = Rt || ta(t, n, u, r, f, a, c))
                                  ? (g ||
                                        (typeof o.UNSAFE_componentWillMount != "function" &&
                                            typeof o.componentWillMount != "function") ||
                                        (typeof o.componentWillMount == "function" && o.componentWillMount(),
                                        typeof o.UNSAFE_componentWillMount == "function" &&
                                            o.UNSAFE_componentWillMount()),
                                    typeof o.componentDidMount == "function" && (t.flags |= 4194308))
                                  : (typeof o.componentDidMount == "function" && (t.flags |= 4194308),
                                    (t.memoizedProps = r),
                                    (t.memoizedState = a)),
                              (o.props = r),
                              (o.state = a),
                              (o.context = c),
                              (r = u))
                            : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), (r = !1));
                } else {
                    (o = t.stateNode),
                        xc(e, t),
                        (u = t.memoizedProps),
                        (c = t.type === t.elementType ? u : tt(t.type, u)),
                        (o.props = c),
                        (g = t.pendingProps),
                        (f = o.context),
                        (a = n.contextType),
                        typeof a == "object" && a !== null
                            ? (a = Xe(a))
                            : ((a = De(n) ? fn : Me.current), (a = Un(t, a)));
                    var v = n.getDerivedStateFromProps;
                    (m = typeof v == "function" || typeof o.getSnapshotBeforeUpdate == "function") ||
                        (typeof o.UNSAFE_componentWillReceiveProps != "function" &&
                            typeof o.componentWillReceiveProps != "function") ||
                        ((u !== g || f !== a) && na(t, o, r, a)),
                        (Rt = !1),
                        (f = t.memoizedState),
                        (o.state = f),
                        Zi(t, r, o, i);
                    var k = t.memoizedState;
                    u !== g || f !== k || Re.current || Rt
                        ? (typeof v == "function" && (Vo(t, n, v, r), (k = t.memoizedState)),
                          (c = Rt || ta(t, n, c, r, f, k, a) || !1)
                              ? (m ||
                                    (typeof o.UNSAFE_componentWillUpdate != "function" &&
                                        typeof o.componentWillUpdate != "function") ||
                                    (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, k, a),
                                    typeof o.UNSAFE_componentWillUpdate == "function" &&
                                        o.UNSAFE_componentWillUpdate(r, k, a)),
                                typeof o.componentDidUpdate == "function" && (t.flags |= 4),
                                typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024))
                              : (typeof o.componentDidUpdate != "function" ||
                                    (u === e.memoizedProps && f === e.memoizedState) ||
                                    (t.flags |= 4),
                                typeof o.getSnapshotBeforeUpdate != "function" ||
                                    (u === e.memoizedProps && f === e.memoizedState) ||
                                    (t.flags |= 1024),
                                (t.memoizedProps = r),
                                (t.memoizedState = k)),
                          (o.props = r),
                          (o.state = k),
                          (o.context = a),
                          (r = c))
                        : (typeof o.componentDidUpdate != "function" ||
                              (u === e.memoizedProps && f === e.memoizedState) ||
                              (t.flags |= 4),
                          typeof o.getSnapshotBeforeUpdate != "function" ||
                              (u === e.memoizedProps && f === e.memoizedState) ||
                              (t.flags |= 1024),
                          (r = !1));
                }
                return Ao(e, t, n, r, l, i);
            }
            function Ao(e, t, n, r, i, l) {
                Qc(e, t);
                var o = (t.flags & 128) !== 0;
                if (!r && !o) return i && Gu(t, n, !1), Tt(e, t, l);
                (r = t.stateNode), (bp.current = t);
                var u = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
                return (
                    (t.flags |= 1),
                    e !== null && o
                        ? ((t.child = qn(t, e.child, null, l)), (t.child = qn(t, null, u, l)))
                        : Ie(e, t, u, l),
                    (t.memoizedState = r.state),
                    i && Gu(t, n, !0),
                    t.child
                );
            }
            function Zc(e) {
                var t = e.stateNode;
                t.pendingContext
                    ? Ku(e, t.pendingContext, t.pendingContext !== t.context)
                    : t.context && Ku(e, t.context, !1),
                    ks(e, t.containerInfo);
            }
            function aa(e, t, n, r, i) {
                return Hn(), hs(i), (t.flags |= 256), Ie(e, t, n, r), t.child;
            }
            var Fo = { dehydrated: null, treeContext: null, retryLane: 0 };
            function bo(e) {
                return { baseLanes: e, cachePool: null, transitions: null };
            }
            function Xc(e, t, n) {
                var r = t.pendingProps,
                    i = re.current,
                    l = !1,
                    o = (t.flags & 128) !== 0,
                    u;
                if (
                    ((u = o) || (u = e !== null && e.memoizedState === null ? !1 : (i & 2) !== 0),
                    u ? ((l = !0), (t.flags &= -129)) : (e === null || e.memoizedState !== null) && (i |= 1),
                    K(re, i & 1),
                    e === null)
                )
                    return (
                        Lo(t),
                        (e = t.memoizedState),
                        e !== null && ((e = e.dehydrated), e !== null)
                            ? ((t.mode & 1) === 0
                                  ? (t.lanes = 1)
                                  : e.data === "$!"
                                    ? (t.lanes = 8)
                                    : (t.lanes = 1073741824),
                              null)
                            : ((o = r.children),
                              (e = r.fallback),
                              l
                                  ? ((r = t.mode),
                                    (l = t.child),
                                    (o = { mode: "hidden", children: o }),
                                    (r & 1) === 0 && l !== null
                                        ? ((l.childLanes = 0), (l.pendingProps = o))
                                        : (l = ml(o, r, 0, null)),
                                    (e = dn(e, r, n, null)),
                                    (l.return = t),
                                    (e.return = t),
                                    (l.sibling = e),
                                    (t.child = l),
                                    (t.child.memoizedState = bo(n)),
                                    (t.memoizedState = Fo),
                                    e)
                                  : Ms(t, o))
                    );
                if (((i = e.memoizedState), i !== null && ((u = i.dehydrated), u !== null)))
                    return Bp(e, t, o, r, u, i, n);
                if (l) {
                    (l = r.fallback), (o = t.mode), (i = e.child), (u = i.sibling);
                    var a = { mode: "hidden", children: r.children };
                    return (
                        (o & 1) === 0 && t.child !== i
                            ? ((r = t.child), (r.childLanes = 0), (r.pendingProps = a), (t.deletions = null))
                            : ((r = Gt(i, a)), (r.subtreeFlags = i.subtreeFlags & 14680064)),
                        u !== null ? (l = Gt(u, l)) : ((l = dn(l, o, n, null)), (l.flags |= 2)),
                        (l.return = t),
                        (r.return = t),
                        (r.sibling = l),
                        (t.child = r),
                        (r = l),
                        (l = t.child),
                        (o = e.child.memoizedState),
                        (o =
                            o === null
                                ? bo(n)
                                : { baseLanes: o.baseLanes | n, cachePool: null, transitions: o.transitions }),
                        (l.memoizedState = o),
                        (l.childLanes = e.childLanes & ~n),
                        (t.memoizedState = Fo),
                        r
                    );
                }
                return (
                    (l = e.child),
                    (e = l.sibling),
                    (r = Gt(l, { mode: "visible", children: r.children })),
                    (t.mode & 1) === 0 && (r.lanes = n),
                    (r.return = t),
                    (r.sibling = null),
                    e !== null && ((n = t.deletions), n === null ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
                    (t.child = r),
                    (t.memoizedState = null),
                    r
                );
            }
            function Ms(e, t) {
                return (t = ml({ mode: "visible", children: t }, e.mode, 0, null)), (t.return = e), (e.child = t);
            }
            function _i(e, t, n, r) {
                return (
                    r !== null && hs(r),
                    qn(t, e.child, null, n),
                    (e = Ms(t, t.pendingProps.children)),
                    (e.flags |= 2),
                    (t.memoizedState = null),
                    e
                );
            }
            function Bp(e, t, n, r, i, l, o) {
                if (n)
                    return t.flags & 256
                        ? ((t.flags &= -257), (r = Jl(Error(S(422)))), _i(e, t, o, r))
                        : t.memoizedState !== null
                          ? ((t.child = e.child), (t.flags |= 128), null)
                          : ((l = r.fallback),
                            (i = t.mode),
                            (r = ml({ mode: "visible", children: r.children }, i, 0, null)),
                            (l = dn(l, i, o, null)),
                            (l.flags |= 2),
                            (r.return = t),
                            (l.return = t),
                            (r.sibling = l),
                            (t.child = r),
                            (t.mode & 1) !== 0 && qn(t, e.child, null, o),
                            (t.child.memoizedState = bo(o)),
                            (t.memoizedState = Fo),
                            l);
                if ((t.mode & 1) === 0) return _i(e, t, o, null);
                if (i.data === "$!") {
                    if (((r = i.nextSibling && i.nextSibling.dataset), r)) var u = r.dgst;
                    return (r = u), (l = Error(S(419))), (r = Jl(l, r, void 0)), _i(e, t, o, r);
                }
                if (((u = (o & e.childLanes) !== 0), Ve || u)) {
                    if (((r = ve), r !== null)) {
                        switch (o & -o) {
                            case 4:
                                i = 2;
                                break;
                            case 16:
                                i = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                i = 32;
                                break;
                            case 536870912:
                                i = 268435456;
                                break;
                            default:
                                i = 0;
                        }
                        (i = (i & (r.suspendedLanes | o)) !== 0 ? 0 : i),
                            i !== 0 && i !== l.retryLane && ((l.retryLane = i), Mt(e, i), lt(r, e, i, -1));
                    }
                    return Vs(), (r = Jl(Error(S(421)))), _i(e, t, o, r);
                }
                return i.data === "$?"
                    ? ((t.flags |= 128), (t.child = e.child), (t = eh.bind(null, e)), (i._reactRetry = t), null)
                    : ((e = l.treeContext),
                      (Fe = Ut(i.nextSibling)),
                      (be = t),
                      (Y = !0),
                      (rt = null),
                      e !== null &&
                          ((Ge[$e++] = xt), (Ge[$e++] = zt), (Ge[$e++] = pn), (xt = e.id), (zt = e.overflow), (pn = t)),
                      (t = Ms(t, r.children)),
                      (t.flags |= 4096),
                      t);
            }
            function ca(e, t, n) {
                e.lanes |= t;
                var r = e.alternate;
                r !== null && (r.lanes |= t), Wo(e.return, t, n);
            }
            function eo(e, t, n, r, i) {
                var l = e.memoizedState;
                l === null
                    ? (e.memoizedState = {
                          isBackwards: t,
                          rendering: null,
                          renderingStartTime: 0,
                          last: r,
                          tail: n,
                          tailMode: i,
                      })
                    : ((l.isBackwards = t),
                      (l.rendering = null),
                      (l.renderingStartTime = 0),
                      (l.last = r),
                      (l.tail = n),
                      (l.tailMode = i));
            }
            function Yc(e, t, n) {
                var r = t.pendingProps,
                    i = r.revealOrder,
                    l = r.tail;
                if ((Ie(e, t, r.children, n), (r = re.current), (r & 2) !== 0)) (r = (r & 1) | 2), (t.flags |= 128);
                else {
                    if (e !== null && (e.flags & 128) !== 0)
                        e: for (e = t.child; e !== null; ) {
                            if (e.tag === 13) e.memoizedState !== null && ca(e, n, t);
                            else if (e.tag === 19) ca(e, n, t);
                            else if (e.child !== null) {
                                (e.child.return = e), (e = e.child);
                                continue;
                            }
                            if (e === t) break e;
                            for (; e.sibling === null; ) {
                                if (e.return === null || e.return === t) break e;
                                e = e.return;
                            }
                            (e.sibling.return = e.return), (e = e.sibling);
                        }
                    r &= 1;
                }
                if ((K(re, r), (t.mode & 1) === 0)) t.memoizedState = null;
                else
                    switch (i) {
                        case "forwards":
                            for (n = t.child, i = null; n !== null; )
                                (e = n.alternate), e !== null && Xi(e) === null && (i = n), (n = n.sibling);
                            (n = i),
                                n === null ? ((i = t.child), (t.child = null)) : ((i = n.sibling), (n.sibling = null)),
                                eo(t, !1, i, n, l);
                            break;
                        case "backwards":
                            for (n = null, i = t.child, t.child = null; i !== null; ) {
                                if (((e = i.alternate), e !== null && Xi(e) === null)) {
                                    t.child = i;
                                    break;
                                }
                                (e = i.sibling), (i.sibling = n), (n = i), (i = e);
                            }
                            eo(t, !0, n, null, l);
                            break;
                        case "together":
                            eo(t, !1, null, null, void 0);
                            break;
                        default:
                            t.memoizedState = null;
                    }
                return t.child;
            }
            function Ni(e, t) {
                (t.mode & 1) === 0 && e !== null && ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
            }
            function Tt(e, t, n) {
                if ((e !== null && (t.dependencies = e.dependencies), (mn |= t.lanes), (n & t.childLanes) === 0))
                    return null;
                if (e !== null && t.child !== e.child) throw Error(S(153));
                if (t.child !== null) {
                    for (e = t.child, n = Gt(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
                        (e = e.sibling), (n = n.sibling = Gt(e, e.pendingProps)), (n.return = t);
                    n.sibling = null;
                }
                return t.child;
            }
            function jp(e, t, n) {
                switch (t.tag) {
                    case 3:
                        Zc(t), Hn();
                        break;
                    case 5:
                        zc(t);
                        break;
                    case 1:
                        De(t.type) && qi(t);
                        break;
                    case 4:
                        ks(t, t.stateNode.containerInfo);
                        break;
                    case 10:
                        var r = t.type._context,
                            i = t.memoizedProps.value;
                        K($i, r._currentValue), (r._currentValue = i);
                        break;
                    case 13:
                        if (((r = t.memoizedState), r !== null))
                            return r.dehydrated !== null
                                ? (K(re, re.current & 1), (t.flags |= 128), null)
                                : (n & t.child.childLanes) !== 0
                                  ? Xc(e, t, n)
                                  : (K(re, re.current & 1), (e = Tt(e, t, n)), e !== null ? e.sibling : null);
                        K(re, re.current & 1);
                        break;
                    case 19:
                        if (((r = (n & t.childLanes) !== 0), (e.flags & 128) !== 0)) {
                            if (r) return Yc(e, t, n);
                            t.flags |= 128;
                        }
                        if (
                            ((i = t.memoizedState),
                            i !== null && ((i.rendering = null), (i.tail = null), (i.lastEffect = null)),
                            K(re, re.current),
                            r)
                        )
                            break;
                        return null;
                    case 22:
                    case 23:
                        return (t.lanes = 0), $c(e, t, n);
                }
                return Tt(e, t, n);
            }
            var Jc, Bo, ed, td;
            (Jc = function (e, t) {
                for (var n = t.child; n !== null; ) {
                    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
                    else if (n.tag !== 4 && n.child !== null) {
                        (n.child.return = n), (n = n.child);
                        continue;
                    }
                    if (n === t) break;
                    for (; n.sibling === null; ) {
                        if (n.return === null || n.return === t) return;
                        n = n.return;
                    }
                    (n.sibling.return = n.return), (n = n.sibling);
                }
            }),
                (Bo = function () {}),
                (ed = function (e, t, n, r) {
                    var i = e.memoizedProps;
                    if (i !== r) {
                        (e = t.stateNode), an(gt.current);
                        var l = null;
                        switch (n) {
                            case "input":
                                (i = uo(e, i)), (r = uo(e, r)), (l = []);
                                break;
                            case "select":
                                (i = le({}, i, { value: void 0 })), (r = le({}, r, { value: void 0 })), (l = []);
                                break;
                            case "textarea":
                                (i = fo(e, i)), (r = fo(e, r)), (l = []);
                                break;
                            default:
                                typeof i.onClick != "function" && typeof r.onClick == "function" && (e.onclick = Ui);
                        }
                        ho(n, r);
                        var o;
                        n = null;
                        for (c in i)
                            if (!r.hasOwnProperty(c) && i.hasOwnProperty(c) && i[c] != null)
                                if (c === "style") {
                                    var u = i[c];
                                    for (o in u) u.hasOwnProperty(o) && (n || (n = {}), (n[o] = ""));
                                } else
                                    c !== "dangerouslySetInnerHTML" &&
                                        c !== "children" &&
                                        c !== "suppressContentEditableWarning" &&
                                        c !== "suppressHydrationWarning" &&
                                        c !== "autoFocus" &&
                                        (Mr.hasOwnProperty(c) ? l || (l = []) : (l = l || []).push(c, null));
                        for (c in r) {
                            var a = r[c];
                            if (((u = i?.[c]), r.hasOwnProperty(c) && a !== u && (a != null || u != null)))
                                if (c === "style")
                                    if (u) {
                                        for (o in u)
                                            !u.hasOwnProperty(o) ||
                                                (a && a.hasOwnProperty(o)) ||
                                                (n || (n = {}), (n[o] = ""));
                                        for (o in a)
                                            a.hasOwnProperty(o) && u[o] !== a[o] && (n || (n = {}), (n[o] = a[o]));
                                    } else n || (l || (l = []), l.push(c, n)), (n = a);
                                else
                                    c === "dangerouslySetInnerHTML"
                                        ? ((a = a ? a.__html : void 0),
                                          (u = u ? u.__html : void 0),
                                          a != null && u !== a && (l = l || []).push(c, a))
                                        : c === "children"
                                          ? (typeof a != "string" && typeof a != "number") ||
                                            (l = l || []).push(c, "" + a)
                                          : c !== "suppressContentEditableWarning" &&
                                            c !== "suppressHydrationWarning" &&
                                            (Mr.hasOwnProperty(c)
                                                ? (a != null && c === "onScroll" && G("scroll", e),
                                                  l || u === a || (l = []))
                                                : (l = l || []).push(c, a));
                        }
                        n && (l = l || []).push("style", n);
                        var c = l;
                        (t.updateQueue = c) && (t.flags |= 4);
                    }
                }),
                (td = function (e, t, n, r) {
                    n !== r && (t.flags |= 4);
                });
            function fr(e, t) {
                if (!Y)
                    switch (e.tailMode) {
                        case "hidden":
                            t = e.tail;
                            for (var n = null; t !== null; ) t.alternate !== null && (n = t), (t = t.sibling);
                            n === null ? (e.tail = null) : (n.sibling = null);
                            break;
                        case "collapsed":
                            n = e.tail;
                            for (var r = null; n !== null; ) n.alternate !== null && (r = n), (n = n.sibling);
                            r === null
                                ? t || e.tail === null
                                    ? (e.tail = null)
                                    : (e.tail.sibling = null)
                                : (r.sibling = null);
                    }
            }
            function Pe(e) {
                var t = e.alternate !== null && e.alternate.child === e.child,
                    n = 0,
                    r = 0;
                if (t)
                    for (var i = e.child; i !== null; )
                        (n |= i.lanes | i.childLanes),
                            (r |= i.subtreeFlags & 14680064),
                            (r |= i.flags & 14680064),
                            (i.return = e),
                            (i = i.sibling);
                else
                    for (i = e.child; i !== null; )
                        (n |= i.lanes | i.childLanes),
                            (r |= i.subtreeFlags),
                            (r |= i.flags),
                            (i.return = e),
                            (i = i.sibling);
                return (e.subtreeFlags |= r), (e.childLanes = n), t;
            }
            function Up(e, t, n) {
                var r = t.pendingProps;
                switch ((ps(t), t.tag)) {
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return Pe(t), null;
                    case 1:
                        return De(t.type) && Hi(), Pe(t), null;
                    case 3:
                        return (
                            (r = t.stateNode),
                            Kn(),
                            $(Re),
                            $(Me),
                            _s(),
                            r.pendingContext && ((r.context = r.pendingContext), (r.pendingContext = null)),
                            (e === null || e.child === null) &&
                                (ki(t)
                                    ? (t.flags |= 4)
                                    : e === null ||
                                      (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                                      ((t.flags |= 1024), rt !== null && (Qo(rt), (rt = null)))),
                            Bo(e, t),
                            Pe(t),
                            null
                        );
                    case 5:
                        Ss(t);
                        var i = an(br.current);
                        if (((n = t.type), e !== null && t.stateNode != null))
                            ed(e, t, n, r, i), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
                        else {
                            if (!r) {
                                if (t.stateNode === null) throw Error(S(166));
                                return Pe(t), null;
                            }
                            if (((e = an(gt.current)), ki(t))) {
                                (r = t.stateNode), (n = t.type);
                                var l = t.memoizedProps;
                                switch (((r[ht] = t), (r[Ar] = l), (e = (t.mode & 1) !== 0), n)) {
                                    case "dialog":
                                        G("cancel", r), G("close", r);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        G("load", r);
                                        break;
                                    case "video":
                                    case "audio":
                                        for (i = 0; i < yr.length; i++) G(yr[i], r);
                                        break;
                                    case "source":
                                        G("error", r);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        G("error", r), G("load", r);
                                        break;
                                    case "details":
                                        G("toggle", r);
                                        break;
                                    case "input":
                                        yu(r, l), G("invalid", r);
                                        break;
                                    case "select":
                                        (r._wrapperState = { wasMultiple: !!l.multiple }), G("invalid", r);
                                        break;
                                    case "textarea":
                                        ku(r, l), G("invalid", r);
                                }
                                ho(n, l), (i = null);
                                for (var o in l)
                                    if (l.hasOwnProperty(o)) {
                                        var u = l[o];
                                        o === "children"
                                            ? typeof u == "string"
                                                ? r.textContent !== u &&
                                                  (l.suppressHydrationWarning !== !0 && wi(r.textContent, u, e),
                                                  (i = ["children", u]))
                                                : typeof u == "number" &&
                                                  r.textContent !== "" + u &&
                                                  (l.suppressHydrationWarning !== !0 && wi(r.textContent, u, e),
                                                  (i = ["children", "" + u]))
                                            : Mr.hasOwnProperty(o) && u != null && o === "onScroll" && G("scroll", r);
                                    }
                                switch (n) {
                                    case "input":
                                        si(r), wu(r, l, !0);
                                        break;
                                    case "textarea":
                                        si(r), Su(r);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        typeof l.onClick == "function" && (r.onclick = Ui);
                                }
                                (r = i), (t.updateQueue = r), r !== null && (t.flags |= 4);
                            } else {
                                (o = i.nodeType === 9 ? i : i.ownerDocument),
                                    e === "http://www.w3.org/1999/xhtml" && (e = Ta(n)),
                                    e === "http://www.w3.org/1999/xhtml"
                                        ? n === "script"
                                            ? ((e = o.createElement("div")),
                                              (e.innerHTML = "<script></script>"),
                                              (e = e.removeChild(e.firstChild)))
                                            : typeof r.is == "string"
                                              ? (e = o.createElement(n, { is: r.is }))
                                              : ((e = o.createElement(n)),
                                                n === "select" &&
                                                    ((o = e),
                                                    r.multiple ? (o.multiple = !0) : r.size && (o.size = r.size)))
                                        : (e = o.createElementNS(e, n)),
                                    (e[ht] = t),
                                    (e[Ar] = r),
                                    Jc(e, t, !1, !1),
                                    (t.stateNode = e);
                                e: {
                                    switch (((o = mo(n, r)), n)) {
                                        case "dialog":
                                            G("cancel", e), G("close", e), (i = r);
                                            break;
                                        case "iframe":
                                        case "object":
                                        case "embed":
                                            G("load", e), (i = r);
                                            break;
                                        case "video":
                                        case "audio":
                                            for (i = 0; i < yr.length; i++) G(yr[i], e);
                                            i = r;
                                            break;
                                        case "source":
                                            G("error", e), (i = r);
                                            break;
                                        case "img":
                                        case "image":
                                        case "link":
                                            G("error", e), G("load", e), (i = r);
                                            break;
                                        case "details":
                                            G("toggle", e), (i = r);
                                            break;
                                        case "input":
                                            yu(e, r), (i = uo(e, r)), G("invalid", e);
                                            break;
                                        case "option":
                                            i = r;
                                            break;
                                        case "select":
                                            (e._wrapperState = { wasMultiple: !!r.multiple }),
                                                (i = le({}, r, { value: void 0 })),
                                                G("invalid", e);
                                            break;
                                        case "textarea":
                                            ku(e, r), (i = fo(e, r)), G("invalid", e);
                                            break;
                                        default:
                                            i = r;
                                    }
                                    ho(n, i), (u = i);
                                    for (l in u)
                                        if (u.hasOwnProperty(l)) {
                                            var a = u[l];
                                            l === "style"
                                                ? La(e, a)
                                                : l === "dangerouslySetInnerHTML"
                                                  ? ((a = a ? a.__html : void 0), a != null && Ia(e, a))
                                                  : l === "children"
                                                    ? typeof a == "string"
                                                        ? (n !== "textarea" || a !== "") && Tr(e, a)
                                                        : typeof a == "number" && Tr(e, "" + a)
                                                    : l !== "suppressContentEditableWarning" &&
                                                      l !== "suppressHydrationWarning" &&
                                                      l !== "autoFocus" &&
                                                      (Mr.hasOwnProperty(l)
                                                          ? a != null && l === "onScroll" && G("scroll", e)
                                                          : a != null && Yo(e, l, a, o));
                                        }
                                    switch (n) {
                                        case "input":
                                            si(e), wu(e, r, !1);
                                            break;
                                        case "textarea":
                                            si(e), Su(e);
                                            break;
                                        case "option":
                                            r.value != null && e.setAttribute("value", "" + $t(r.value));
                                            break;
                                        case "select":
                                            (e.multiple = !!r.multiple),
                                                (l = r.value),
                                                l != null
                                                    ? Dn(e, !!r.multiple, l, !1)
                                                    : r.defaultValue != null && Dn(e, !!r.multiple, r.defaultValue, !0);
                                            break;
                                        default:
                                            typeof i.onClick == "function" && (e.onclick = Ui);
                                    }
                                    switch (n) {
                                        case "button":
                                        case "input":
                                        case "select":
                                        case "textarea":
                                            r = !!r.autoFocus;
                                            break e;
                                        case "img":
                                            r = !0;
                                            break e;
                                        default:
                                            r = !1;
                                    }
                                }
                                r && (t.flags |= 4);
                            }
                            t.ref !== null && ((t.flags |= 512), (t.flags |= 2097152));
                        }
                        return Pe(t), null;
                    case 6:
                        if (e && t.stateNode != null) td(e, t, e.memoizedProps, r);
                        else {
                            if (typeof r != "string" && t.stateNode === null) throw Error(S(166));
                            if (((n = an(br.current)), an(gt.current), ki(t))) {
                                if (
                                    ((r = t.stateNode),
                                    (n = t.memoizedProps),
                                    (r[ht] = t),
                                    (l = r.nodeValue !== n) && ((e = be), e !== null))
                                )
                                    switch (e.tag) {
                                        case 3:
                                            wi(r.nodeValue, n, (e.mode & 1) !== 0);
                                            break;
                                        case 5:
                                            e.memoizedProps.suppressHydrationWarning !== !0 &&
                                                wi(r.nodeValue, n, (e.mode & 1) !== 0);
                                    }
                                l && (t.flags |= 4);
                            } else
                                (r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r)),
                                    (r[ht] = t),
                                    (t.stateNode = r);
                        }
                        return Pe(t), null;
                    case 13:
                        if (
                            ($(re),
                            (r = t.memoizedState),
                            e === null || (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
                        ) {
                            if (Y && Fe !== null && (t.mode & 1) !== 0 && (t.flags & 128) === 0)
                                wc(), Hn(), (t.flags |= 98560), (l = !1);
                            else if (((l = ki(t)), r !== null && r.dehydrated !== null)) {
                                if (e === null) {
                                    if (!l) throw Error(S(318));
                                    if (((l = t.memoizedState), (l = l !== null ? l.dehydrated : null), !l))
                                        throw Error(S(317));
                                    l[ht] = t;
                                } else Hn(), (t.flags & 128) === 0 && (t.memoizedState = null), (t.flags |= 4);
                                Pe(t), (l = !1);
                            } else rt !== null && (Qo(rt), (rt = null)), (l = !0);
                            if (!l) return t.flags & 65536 ? t : null;
                        }
                        return (t.flags & 128) !== 0
                            ? ((t.lanes = n), t)
                            : ((r = r !== null),
                              r !== (e !== null && e.memoizedState !== null) &&
                                  r &&
                                  ((t.child.flags |= 8192),
                                  (t.mode & 1) !== 0 &&
                                      (e === null || (re.current & 1) !== 0 ? he === 0 && (he = 3) : Vs())),
                              t.updateQueue !== null && (t.flags |= 4),
                              Pe(t),
                              null);
                    case 4:
                        return Kn(), Bo(e, t), e === null && Dr(t.stateNode.containerInfo), Pe(t), null;
                    case 10:
                        return vs(t.type._context), Pe(t), null;
                    case 17:
                        return De(t.type) && Hi(), Pe(t), null;
                    case 19:
                        if (($(re), (l = t.memoizedState), l === null)) return Pe(t), null;
                        if (((r = (t.flags & 128) !== 0), (o = l.rendering), o === null))
                            if (r) fr(l, !1);
                            else {
                                if (he !== 0 || (e !== null && (e.flags & 128) !== 0))
                                    for (e = t.child; e !== null; ) {
                                        if (((o = Xi(e)), o !== null)) {
                                            for (
                                                t.flags |= 128,
                                                    fr(l, !1),
                                                    r = o.updateQueue,
                                                    r !== null && ((t.updateQueue = r), (t.flags |= 4)),
                                                    t.subtreeFlags = 0,
                                                    r = n,
                                                    n = t.child;
                                                n !== null;

                                            )
                                                (l = n),
                                                    (e = r),
                                                    (l.flags &= 14680066),
                                                    (o = l.alternate),
                                                    o === null
                                                        ? ((l.childLanes = 0),
                                                          (l.lanes = e),
                                                          (l.child = null),
                                                          (l.subtreeFlags = 0),
                                                          (l.memoizedProps = null),
                                                          (l.memoizedState = null),
                                                          (l.updateQueue = null),
                                                          (l.dependencies = null),
                                                          (l.stateNode = null))
                                                        : ((l.childLanes = o.childLanes),
                                                          (l.lanes = o.lanes),
                                                          (l.child = o.child),
                                                          (l.subtreeFlags = 0),
                                                          (l.deletions = null),
                                                          (l.memoizedProps = o.memoizedProps),
                                                          (l.memoizedState = o.memoizedState),
                                                          (l.updateQueue = o.updateQueue),
                                                          (l.type = o.type),
                                                          (e = o.dependencies),
                                                          (l.dependencies =
                                                              e === null
                                                                  ? null
                                                                  : { lanes: e.lanes, firstContext: e.firstContext })),
                                                    (n = n.sibling);
                                            return K(re, (re.current & 1) | 2), t.child;
                                        }
                                        e = e.sibling;
                                    }
                                l.tail !== null &&
                                    ae() > $n &&
                                    ((t.flags |= 128), (r = !0), fr(l, !1), (t.lanes = 4194304));
                            }
                        else {
                            if (!r)
                                if (((e = Xi(o)), e !== null)) {
                                    if (
                                        ((t.flags |= 128),
                                        (r = !0),
                                        (n = e.updateQueue),
                                        n !== null && ((t.updateQueue = n), (t.flags |= 4)),
                                        fr(l, !0),
                                        l.tail === null && l.tailMode === "hidden" && !o.alternate && !Y)
                                    )
                                        return Pe(t), null;
                                } else
                                    2 * ae() - l.renderingStartTime > $n &&
                                        n !== 1073741824 &&
                                        ((t.flags |= 128), (r = !0), fr(l, !1), (t.lanes = 4194304));
                            l.isBackwards
                                ? ((o.sibling = t.child), (t.child = o))
                                : ((n = l.last), n !== null ? (n.sibling = o) : (t.child = o), (l.last = o));
                        }
                        return l.tail !== null
                            ? ((t = l.tail),
                              (l.rendering = t),
                              (l.tail = t.sibling),
                              (l.renderingStartTime = ae()),
                              (t.sibling = null),
                              (n = re.current),
                              K(re, r ? (n & 1) | 2 : n & 1),
                              t)
                            : (Pe(t), null);
                    case 22:
                    case 23:
                        return (
                            Ws(),
                            (r = t.memoizedState !== null),
                            e !== null && (e.memoizedState !== null) !== r && (t.flags |= 8192),
                            r && (t.mode & 1) !== 0
                                ? (Ae & 1073741824) !== 0 && (Pe(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                                : Pe(t),
                            null
                        );
                    case 24:
                        return null;
                    case 25:
                        return null;
                }
                throw Error(S(156, t.tag));
            }
            function Hp(e, t) {
                switch ((ps(t), t.tag)) {
                    case 1:
                        return (
                            De(t.type) && Hi(), (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
                        );
                    case 3:
                        return (
                            Kn(),
                            $(Re),
                            $(Me),
                            _s(),
                            (e = t.flags),
                            (e & 65536) !== 0 && (e & 128) === 0 ? ((t.flags = (e & -65537) | 128), t) : null
                        );
                    case 5:
                        return Ss(t), null;
                    case 13:
                        if (($(re), (e = t.memoizedState), e !== null && e.dehydrated !== null)) {
                            if (t.alternate === null) throw Error(S(340));
                            Hn();
                        }
                        return (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null;
                    case 19:
                        return $(re), null;
                    case 4:
                        return Kn(), null;
                    case 10:
                        return vs(t.type._context), null;
                    case 22:
                    case 23:
                        return Ws(), null;
                    case 24:
                        return null;
                    default:
                        return null;
                }
            }
            var xi = !1,
                Ce = !1,
                qp = typeof WeakSet == "function" ? WeakSet : Set,
                M = null;
            function Vn(e, t) {
                var n = e.ref;
                if (n !== null)
                    if (typeof n == "function")
                        try {
                            n(null);
                        } catch (r) {
                            oe(e, t, r);
                        }
                    else n.current = null;
            }
            function jo(e, t, n) {
                try {
                    n();
                } catch (r) {
                    oe(e, t, r);
                }
            }
            var da = !1;
            function Kp(e, t) {
                if (((Eo = bi), (e = oc()), ds(e))) {
                    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
                    else
                        e: {
                            n = ((n = e.ownerDocument) && n.defaultView) || window;
                            var r = n.getSelection && n.getSelection();
                            if (r && r.rangeCount !== 0) {
                                n = r.anchorNode;
                                var i = r.anchorOffset,
                                    l = r.focusNode;
                                r = r.focusOffset;
                                try {
                                    n.nodeType, l.nodeType;
                                } catch {
                                    n = null;
                                    break e;
                                }
                                var o = 0,
                                    u = -1,
                                    a = -1,
                                    c = 0,
                                    m = 0,
                                    g = e,
                                    f = null;
                                t: for (;;) {
                                    for (
                                        var v;
                                        g !== n || (i !== 0 && g.nodeType !== 3) || (u = o + i),
                                            g !== l || (r !== 0 && g.nodeType !== 3) || (a = o + r),
                                            g.nodeType === 3 && (o += g.nodeValue.length),
                                            (v = g.firstChild) !== null;

                                    )
                                        (f = g), (g = v);
                                    for (;;) {
                                        if (g === e) break t;
                                        if (
                                            (f === n && ++c === i && (u = o),
                                            f === l && ++m === r && (a = o),
                                            (v = g.nextSibling) !== null)
                                        )
                                            break;
                                        (g = f), (f = g.parentNode);
                                    }
                                    g = v;
                                }
                                n = u === -1 || a === -1 ? null : { start: u, end: a };
                            } else n = null;
                        }
                    n = n || { start: 0, end: 0 };
                } else n = null;
                for (Po = { focusedElem: e, selectionRange: n }, bi = !1, M = t; M !== null; )
                    if (((t = M), (e = t.child), (t.subtreeFlags & 1028) !== 0 && e !== null)) (e.return = t), (M = e);
                    else
                        for (; M !== null; ) {
                            t = M;
                            try {
                                var k = t.alternate;
                                if ((t.flags & 1024) !== 0)
                                    switch (t.tag) {
                                        case 0:
                                        case 11:
                                        case 15:
                                            break;
                                        case 1:
                                            if (k !== null) {
                                                var x = k.memoizedProps,
                                                    R = k.memoizedState,
                                                    h = t.stateNode,
                                                    d = h.getSnapshotBeforeUpdate(
                                                        t.elementType === t.type ? x : tt(t.type, x),
                                                        R
                                                    );
                                                h.__reactInternalSnapshotBeforeUpdate = d;
                                            }
                                            break;
                                        case 3:
                                            var p = t.stateNode.containerInfo;
                                            p.nodeType === 1
                                                ? (p.textContent = "")
                                                : p.nodeType === 9 &&
                                                  p.documentElement &&
                                                  p.removeChild(p.documentElement);
                                            break;
                                        case 5:
                                        case 6:
                                        case 4:
                                        case 17:
                                            break;
                                        default:
                                            throw Error(S(163));
                                    }
                            } catch (y) {
                                oe(t, t.return, y);
                            }
                            if (((e = t.sibling), e !== null)) {
                                (e.return = t.return), (M = e);
                                break;
                            }
                            M = t.return;
                        }
                return (k = da), (da = !1), k;
            }
            function Er(e, t, n) {
                var r = t.updateQueue;
                if (((r = r !== null ? r.lastEffect : null), r !== null)) {
                    var i = (r = r.next);
                    do {
                        if ((i.tag & e) === e) {
                            var l = i.destroy;
                            (i.destroy = void 0), l !== void 0 && jo(t, n, l);
                        }
                        i = i.next;
                    } while (i !== r);
                }
            }
            function pl(e, t) {
                if (((t = t.updateQueue), (t = t !== null ? t.lastEffect : null), t !== null)) {
                    var n = (t = t.next);
                    do {
                        if ((n.tag & e) === e) {
                            var r = n.create;
                            n.destroy = r();
                        }
                        n = n.next;
                    } while (n !== t);
                }
            }
            function Uo(e) {
                var t = e.ref;
                if (t !== null) {
                    var n = e.stateNode;
                    switch (e.tag) {
                        case 5:
                            e = n;
                            break;
                        default:
                            e = n;
                    }
                    typeof t == "function" ? t(e) : (t.current = e);
                }
            }
            function nd(e) {
                var t = e.alternate;
                t !== null && ((e.alternate = null), nd(t)),
                    (e.child = null),
                    (e.deletions = null),
                    (e.sibling = null),
                    e.tag === 5 &&
                        ((t = e.stateNode),
                        t !== null && (delete t[ht], delete t[Ar], delete t[To], delete t[Mp], delete t[Tp])),
                    (e.stateNode = null),
                    (e.return = null),
                    (e.dependencies = null),
                    (e.memoizedProps = null),
                    (e.memoizedState = null),
                    (e.pendingProps = null),
                    (e.stateNode = null),
                    (e.updateQueue = null);
            }
            function rd(e) {
                return e.tag === 5 || e.tag === 3 || e.tag === 4;
            }
            function fa(e) {
                e: for (;;) {
                    for (; e.sibling === null; ) {
                        if (e.return === null || rd(e.return)) return null;
                        e = e.return;
                    }
                    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
                        if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
                        (e.child.return = e), (e = e.child);
                    }
                    if (!(e.flags & 2)) return e.stateNode;
                }
            }
            function Ho(e, t, n) {
                var r = e.tag;
                if (r === 5 || r === 6)
                    (e = e.stateNode),
                        t
                            ? n.nodeType === 8
                                ? n.parentNode.insertBefore(e, t)
                                : n.insertBefore(e, t)
                            : (n.nodeType === 8
                                  ? ((t = n.parentNode), t.insertBefore(e, n))
                                  : ((t = n), t.appendChild(e)),
                              (n = n._reactRootContainer),
                              n != null || t.onclick !== null || (t.onclick = Ui));
                else if (r !== 4 && ((e = e.child), e !== null))
                    for (Ho(e, t, n), e = e.sibling; e !== null; ) Ho(e, t, n), (e = e.sibling);
            }
            function qo(e, t, n) {
                var r = e.tag;
                if (r === 5 || r === 6) (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
                else if (r !== 4 && ((e = e.child), e !== null))
                    for (qo(e, t, n), e = e.sibling; e !== null; ) qo(e, t, n), (e = e.sibling);
            }
            var we = null,
                nt = !1;
            function Wt(e, t, n) {
                for (n = n.child; n !== null; ) id(e, t, n), (n = n.sibling);
            }
            function id(e, t, n) {
                if (mt && typeof mt.onCommitFiberUnmount == "function")
                    try {
                        mt.onCommitFiberUnmount(ll, n);
                    } catch {}
                switch (n.tag) {
                    case 5:
                        Ce || Vn(n, t);
                    case 6:
                        var r = we,
                            i = nt;
                        (we = null),
                            Wt(e, t, n),
                            (we = r),
                            (nt = i),
                            we !== null &&
                                (nt
                                    ? ((e = we),
                                      (n = n.stateNode),
                                      e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n))
                                    : we.removeChild(n.stateNode));
                        break;
                    case 18:
                        we !== null &&
                            (nt
                                ? ((e = we),
                                  (n = n.stateNode),
                                  e.nodeType === 8 ? Gl(e.parentNode, n) : e.nodeType === 1 && Gl(e, n),
                                  Wr(e))
                                : Gl(we, n.stateNode));
                        break;
                    case 4:
                        (r = we),
                            (i = nt),
                            (we = n.stateNode.containerInfo),
                            (nt = !0),
                            Wt(e, t, n),
                            (we = r),
                            (nt = i);
                        break;
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        if (!Ce && ((r = n.updateQueue), r !== null && ((r = r.lastEffect), r !== null))) {
                            i = r = r.next;
                            do {
                                var l = i,
                                    o = l.destroy;
                                (l = l.tag),
                                    o !== void 0 && ((l & 2) !== 0 || (l & 4) !== 0) && jo(n, t, o),
                                    (i = i.next);
                            } while (i !== r);
                        }
                        Wt(e, t, n);
                        break;
                    case 1:
                        if (!Ce && (Vn(n, t), (r = n.stateNode), typeof r.componentWillUnmount == "function"))
                            try {
                                (r.props = n.memoizedProps), (r.state = n.memoizedState), r.componentWillUnmount();
                            } catch (u) {
                                oe(n, t, u);
                            }
                        Wt(e, t, n);
                        break;
                    case 21:
                        Wt(e, t, n);
                        break;
                    case 22:
                        n.mode & 1 ? ((Ce = (r = Ce) || n.memoizedState !== null), Wt(e, t, n), (Ce = r)) : Wt(e, t, n);
                        break;
                    default:
                        Wt(e, t, n);
                }
            }
            function pa(e) {
                var t = e.updateQueue;
                if (t !== null) {
                    e.updateQueue = null;
                    var n = e.stateNode;
                    n === null && (n = e.stateNode = new qp()),
                        t.forEach(function (r) {
                            var i = th.bind(null, e, r);
                            n.has(r) || (n.add(r), r.then(i, i));
                        });
                }
            }
            function et(e, t) {
                var n = t.deletions;
                if (n !== null)
                    for (var r = 0; r < n.length; r++) {
                        var i = n[r];
                        try {
                            var l = e,
                                o = t,
                                u = o;
                            e: for (; u !== null; ) {
                                switch (u.tag) {
                                    case 5:
                                        (we = u.stateNode), (nt = !1);
                                        break e;
                                    case 3:
                                        (we = u.stateNode.containerInfo), (nt = !0);
                                        break e;
                                    case 4:
                                        (we = u.stateNode.containerInfo), (nt = !0);
                                        break e;
                                }
                                u = u.return;
                            }
                            if (we === null) throw Error(S(160));
                            id(l, o, i), (we = null), (nt = !1);
                            var a = i.alternate;
                            a !== null && (a.return = null), (i.return = null);
                        } catch (c) {
                            oe(i, t, c);
                        }
                    }
                if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) ld(t, e), (t = t.sibling);
            }
            function ld(e, t) {
                var n = e.alternate,
                    r = e.flags;
                switch (e.tag) {
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        if ((et(t, e), ft(e), r & 4)) {
                            try {
                                Er(3, e, e.return), pl(3, e);
                            } catch (x) {
                                oe(e, e.return, x);
                            }
                            try {
                                Er(5, e, e.return);
                            } catch (x) {
                                oe(e, e.return, x);
                            }
                        }
                        break;
                    case 1:
                        et(t, e), ft(e), r & 512 && n !== null && Vn(n, n.return);
                        break;
                    case 5:
                        if ((et(t, e), ft(e), r & 512 && n !== null && Vn(n, n.return), e.flags & 32)) {
                            var i = e.stateNode;
                            try {
                                Tr(i, "");
                            } catch (x) {
                                oe(e, e.return, x);
                            }
                        }
                        if (r & 4 && ((i = e.stateNode), i != null)) {
                            var l = e.memoizedProps,
                                o = n !== null ? n.memoizedProps : l,
                                u = e.type,
                                a = e.updateQueue;
                            if (((e.updateQueue = null), a !== null))
                                try {
                                    u === "input" && l.type === "radio" && l.name != null && Ca(i, l), mo(u, o);
                                    var c = mo(u, l);
                                    for (o = 0; o < a.length; o += 2) {
                                        var m = a[o],
                                            g = a[o + 1];
                                        m === "style"
                                            ? La(i, g)
                                            : m === "dangerouslySetInnerHTML"
                                              ? Ia(i, g)
                                              : m === "children"
                                                ? Tr(i, g)
                                                : Yo(i, m, g, c);
                                    }
                                    switch (u) {
                                        case "input":
                                            ao(i, l);
                                            break;
                                        case "textarea":
                                            Ma(i, l);
                                            break;
                                        case "select":
                                            var f = i._wrapperState.wasMultiple;
                                            i._wrapperState.wasMultiple = !!l.multiple;
                                            var v = l.value;
                                            v != null
                                                ? Dn(i, !!l.multiple, v, !1)
                                                : f !== !!l.multiple &&
                                                  (l.defaultValue != null
                                                      ? Dn(i, !!l.multiple, l.defaultValue, !0)
                                                      : Dn(i, !!l.multiple, l.multiple ? [] : "", !1));
                                    }
                                    i[Ar] = l;
                                } catch (x) {
                                    oe(e, e.return, x);
                                }
                        }
                        break;
                    case 6:
                        if ((et(t, e), ft(e), r & 4)) {
                            if (e.stateNode === null) throw Error(S(162));
                            (i = e.stateNode), (l = e.memoizedProps);
                            try {
                                i.nodeValue = l;
                            } catch (x) {
                                oe(e, e.return, x);
                            }
                        }
                        break;
                    case 3:
                        if ((et(t, e), ft(e), r & 4 && n !== null && n.memoizedState.isDehydrated))
                            try {
                                Wr(t.containerInfo);
                            } catch (x) {
                                oe(e, e.return, x);
                            }
                        break;
                    case 4:
                        et(t, e), ft(e);
                        break;
                    case 13:
                        et(t, e),
                            ft(e),
                            (i = e.child),
                            i.flags & 8192 &&
                                ((l = i.memoizedState !== null),
                                (i.stateNode.isHidden = l),
                                !l || (i.alternate !== null && i.alternate.memoizedState !== null) || (Ns = ae())),
                            r & 4 && pa(e);
                        break;
                    case 22:
                        if (
                            ((m = n !== null && n.memoizedState !== null),
                            e.mode & 1 ? ((Ce = (c = Ce) || m), et(t, e), (Ce = c)) : et(t, e),
                            ft(e),
                            r & 8192)
                        ) {
                            if (
                                ((c = e.memoizedState !== null), (e.stateNode.isHidden = c) && !m && (e.mode & 1) !== 0)
                            )
                                for (M = e, m = e.child; m !== null; ) {
                                    for (g = M = m; M !== null; ) {
                                        switch (((f = M), (v = f.child), f.tag)) {
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Er(4, f, f.return);
                                                break;
                                            case 1:
                                                Vn(f, f.return);
                                                var k = f.stateNode;
                                                if (typeof k.componentWillUnmount == "function") {
                                                    (r = f), (n = f.return);
                                                    try {
                                                        (t = r),
                                                            (k.props = t.memoizedProps),
                                                            (k.state = t.memoizedState),
                                                            k.componentWillUnmount();
                                                    } catch (x) {
                                                        oe(r, n, x);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Vn(f, f.return);
                                                break;
                                            case 22:
                                                if (f.memoizedState !== null) {
                                                    ma(g);
                                                    continue;
                                                }
                                        }
                                        v !== null ? ((v.return = f), (M = v)) : ma(g);
                                    }
                                    m = m.sibling;
                                }
                            e: for (m = null, g = e; ; ) {
                                if (g.tag === 5) {
                                    if (m === null) {
                                        m = g;
                                        try {
                                            (i = g.stateNode),
                                                c
                                                    ? ((l = i.style),
                                                      typeof l.setProperty == "function"
                                                          ? l.setProperty("display", "none", "important")
                                                          : (l.display = "none"))
                                                    : ((u = g.stateNode),
                                                      (a = g.memoizedProps.style),
                                                      (o = a != null && a.hasOwnProperty("display") ? a.display : null),
                                                      (u.style.display = Na("display", o)));
                                        } catch (x) {
                                            oe(e, e.return, x);
                                        }
                                    }
                                } else if (g.tag === 6) {
                                    if (m === null)
                                        try {
                                            g.stateNode.nodeValue = c ? "" : g.memoizedProps;
                                        } catch (x) {
                                            oe(e, e.return, x);
                                        }
                                } else if (
                                    ((g.tag !== 22 && g.tag !== 23) || g.memoizedState === null || g === e) &&
                                    g.child !== null
                                ) {
                                    (g.child.return = g), (g = g.child);
                                    continue;
                                }
                                if (g === e) break e;
                                for (; g.sibling === null; ) {
                                    if (g.return === null || g.return === e) break e;
                                    m === g && (m = null), (g = g.return);
                                }
                                m === g && (m = null), (g.sibling.return = g.return), (g = g.sibling);
                            }
                        }
                        break;
                    case 19:
                        et(t, e), ft(e), r & 4 && pa(e);
                        break;
                    case 21:
                        break;
                    default:
                        et(t, e), ft(e);
                }
            }
            function ft(e) {
                var t = e.flags;
                if (t & 2) {
                    try {
                        e: {
                            for (var n = e.return; n !== null; ) {
                                if (rd(n)) {
                                    var r = n;
                                    break e;
                                }
                                n = n.return;
                            }
                            throw Error(S(160));
                        }
                        switch (r.tag) {
                            case 5:
                                var i = r.stateNode;
                                r.flags & 32 && (Tr(i, ""), (r.flags &= -33));
                                var l = fa(e);
                                qo(e, l, i);
                                break;
                            case 3:
                            case 4:
                                var o = r.stateNode.containerInfo,
                                    u = fa(e);
                                Ho(e, u, o);
                                break;
                            default:
                                throw Error(S(161));
                        }
                    } catch (a) {
                        oe(e, e.return, a);
                    }
                    e.flags &= -3;
                }
                t & 4096 && (e.flags &= -4097);
            }
            function Gp(e, t, n) {
                (M = e), od(e, t, n);
            }
            function od(e, t, n) {
                for (var r = (e.mode & 1) !== 0; M !== null; ) {
                    var i = M,
                        l = i.child;
                    if (i.tag === 22 && r) {
                        var o = i.memoizedState !== null || xi;
                        if (!o) {
                            var u = i.alternate,
                                a = (u !== null && u.memoizedState !== null) || Ce;
                            u = xi;
                            var c = Ce;
                            if (((xi = o), (Ce = a) && !c))
                                for (M = i; M !== null; )
                                    (o = M),
                                        (a = o.child),
                                        o.tag === 22 && o.memoizedState !== null
                                            ? ga(i)
                                            : a !== null
                                              ? ((a.return = o), (M = a))
                                              : ga(i);
                            for (; l !== null; ) (M = l), od(l, t, n), (l = l.sibling);
                            (M = i), (xi = u), (Ce = c);
                        }
                        ha(e, t, n);
                    } else (i.subtreeFlags & 8772) !== 0 && l !== null ? ((l.return = i), (M = l)) : ha(e, t, n);
                }
            }
            function ha(e) {
                for (; M !== null; ) {
                    var t = M;
                    if ((t.flags & 8772) !== 0) {
                        var n = t.alternate;
                        try {
                            if ((t.flags & 8772) !== 0)
                                switch (t.tag) {
                                    case 0:
                                    case 11:
                                    case 15:
                                        Ce || pl(5, t);
                                        break;
                                    case 1:
                                        var r = t.stateNode;
                                        if (t.flags & 4 && !Ce)
                                            if (n === null) r.componentDidMount();
                                            else {
                                                var i =
                                                    t.elementType === t.type
                                                        ? n.memoizedProps
                                                        : tt(t.type, n.memoizedProps);
                                                r.componentDidUpdate(
                                                    i,
                                                    n.memoizedState,
                                                    r.__reactInternalSnapshotBeforeUpdate
                                                );
                                            }
                                        var l = t.updateQueue;
                                        l !== null && Yu(t, l, r);
                                        break;
                                    case 3:
                                        var o = t.updateQueue;
                                        if (o !== null) {
                                            if (((n = null), t.child !== null))
                                                switch (t.child.tag) {
                                                    case 5:
                                                        n = t.child.stateNode;
                                                        break;
                                                    case 1:
                                                        n = t.child.stateNode;
                                                }
                                            Yu(t, o, n);
                                        }
                                        break;
                                    case 5:
                                        var u = t.stateNode;
                                        if (n === null && t.flags & 4) {
                                            n = u;
                                            var a = t.memoizedProps;
                                            switch (t.type) {
                                                case "button":
                                                case "input":
                                                case "select":
                                                case "textarea":
                                                    a.autoFocus && n.focus();
                                                    break;
                                                case "img":
                                                    a.src && (n.src = a.src);
                                            }
                                        }
                                        break;
                                    case 6:
                                        break;
                                    case 4:
                                        break;
                                    case 12:
                                        break;
                                    case 13:
                                        if (t.memoizedState === null) {
                                            var c = t.alternate;
                                            if (c !== null) {
                                                var m = c.memoizedState;
                                                if (m !== null) {
                                                    var g = m.dehydrated;
                                                    g !== null && Wr(g);
                                                }
                                            }
                                        }
                                        break;
                                    case 19:
                                    case 17:
                                    case 21:
                                    case 22:
                                    case 23:
                                    case 25:
                                        break;
                                    default:
                                        throw Error(S(163));
                                }
                            Ce || (t.flags & 512 && Uo(t));
                        } catch (f) {
                            oe(t, t.return, f);
                        }
                    }
                    if (t === e) {
                        M = null;
                        break;
                    }
                    if (((n = t.sibling), n !== null)) {
                        (n.return = t.return), (M = n);
                        break;
                    }
                    M = t.return;
                }
            }
            function ma(e) {
                for (; M !== null; ) {
                    var t = M;
                    if (t === e) {
                        M = null;
                        break;
                    }
                    var n = t.sibling;
                    if (n !== null) {
                        (n.return = t.return), (M = n);
                        break;
                    }
                    M = t.return;
                }
            }
            function ga(e) {
                for (; M !== null; ) {
                    var t = M;
                    try {
                        switch (t.tag) {
                            case 0:
                            case 11:
                            case 15:
                                var n = t.return;
                                try {
                                    pl(4, t);
                                } catch (a) {
                                    oe(t, n, a);
                                }
                                break;
                            case 1:
                                var r = t.stateNode;
                                if (typeof r.componentDidMount == "function") {
                                    var i = t.return;
                                    try {
                                        r.componentDidMount();
                                    } catch (a) {
                                        oe(t, i, a);
                                    }
                                }
                                var l = t.return;
                                try {
                                    Uo(t);
                                } catch (a) {
                                    oe(t, l, a);
                                }
                                break;
                            case 5:
                                var o = t.return;
                                try {
                                    Uo(t);
                                } catch (a) {
                                    oe(t, o, a);
                                }
                        }
                    } catch (a) {
                        oe(t, t.return, a);
                    }
                    if (t === e) {
                        M = null;
                        break;
                    }
                    var u = t.sibling;
                    if (u !== null) {
                        (u.return = t.return), (M = u);
                        break;
                    }
                    M = t.return;
                }
            }
            var $p = Math.ceil,
                el = It.ReactCurrentDispatcher,
                Ts = It.ReactCurrentOwner,
                Ze = It.ReactCurrentBatchConfig,
                j = 0,
                ve = null,
                de = null,
                ke = 0,
                Ae = 0,
                Rn = Xt(0),
                he = 0,
                Hr = null,
                mn = 0,
                hl = 0,
                Is = 0,
                Pr = null,
                We = null,
                Ns = 0,
                $n = 1 / 0,
                St = null,
                tl = !1,
                Ko = null,
                qt = null,
                zi = !1,
                Ft = null,
                nl = 0,
                Cr = 0,
                Go = null,
                Li = -1,
                Wi = 0;
            function Ne() {
                return (j & 6) !== 0 ? ae() : Li !== -1 ? Li : (Li = ae());
            }
            function Kt(e) {
                return (e.mode & 1) === 0
                    ? 1
                    : (j & 2) !== 0 && ke !== 0
                      ? ke & -ke
                      : Np.transition !== null
                        ? (Wi === 0 && (Wi = Ha()), Wi)
                        : ((e = H), e !== 0 || ((e = window.event), (e = e === void 0 ? 16 : Xa(e.type))), e);
            }
            function lt(e, t, n, r) {
                if (50 < Cr) throw ((Cr = 0), (Go = null), Error(S(185)));
                qr(e, n, r),
                    ((j & 2) === 0 || e !== ve) &&
                        (e === ve && ((j & 2) === 0 && (hl |= n), he === 4 && Ot(e, ke)),
                        Oe(e, r),
                        n === 1 && j === 0 && (t.mode & 1) === 0 && (($n = ae() + 500), cl && Yt()));
            }
            function Oe(e, t) {
                var n = e.callbackNode;
                Wf(e, t);
                var r = Fi(e, e === ve ? ke : 0);
                if (r === 0) n !== null && zu(n), (e.callbackNode = null), (e.callbackPriority = 0);
                else if (((t = r & -r), e.callbackPriority !== t)) {
                    if ((n != null && zu(n), t === 1))
                        e.tag === 0 ? Ip(va.bind(null, e)) : gc(va.bind(null, e)),
                            Pp(function () {
                                (j & 6) === 0 && Yt();
                            }),
                            (n = null);
                    else {
                        switch (qa(r)) {
                            case 1:
                                n = rs;
                                break;
                            case 4:
                                n = ja;
                                break;
                            case 16:
                                n = Ai;
                                break;
                            case 536870912:
                                n = Ua;
                                break;
                            default:
                                n = Ai;
                        }
                        n = hd(n, sd.bind(null, e));
                    }
                    (e.callbackPriority = t), (e.callbackNode = n);
                }
            }
            function sd(e, t) {
                if (((Li = -1), (Wi = 0), (j & 6) !== 0)) throw Error(S(327));
                var n = e.callbackNode;
                if (Bn() && e.callbackNode !== n) return null;
                var r = Fi(e, e === ve ? ke : 0);
                if (r === 0) return null;
                if ((r & 30) !== 0 || (r & e.expiredLanes) !== 0 || t) t = rl(e, r);
                else {
                    t = r;
                    var i = j;
                    j |= 2;
                    var l = ad();
                    (ve !== e || ke !== t) && ((St = null), ($n = ae() + 500), cn(e, t));
                    do
                        try {
                            Xp();
                            break;
                        } catch (u) {
                            ud(e, u);
                        }
                    while (!0);
                    gs(), (el.current = l), (j = i), de !== null ? (t = 0) : ((ve = null), (ke = 0), (t = he));
                }
                if (t !== 0) {
                    if ((t === 2 && ((i = ko(e)), i !== 0 && ((r = i), (t = $o(e, i)))), t === 1))
                        throw ((n = Hr), cn(e, 0), Ot(e, r), Oe(e, ae()), n);
                    if (t === 6) Ot(e, r);
                    else {
                        if (
                            ((i = e.current.alternate),
                            (r & 30) === 0 &&
                                !Qp(i) &&
                                ((t = rl(e, r)),
                                t === 2 && ((l = ko(e)), l !== 0 && ((r = l), (t = $o(e, l)))),
                                t === 1))
                        )
                            throw ((n = Hr), cn(e, 0), Ot(e, r), Oe(e, ae()), n);
                        switch (((e.finishedWork = i), (e.finishedLanes = r), t)) {
                            case 0:
                            case 1:
                                throw Error(S(345));
                            case 2:
                                on(e, We, St);
                                break;
                            case 3:
                                if ((Ot(e, r), (r & 130023424) === r && ((t = Ns + 500 - ae()), 10 < t))) {
                                    if (Fi(e, 0) !== 0) break;
                                    if (((i = e.suspendedLanes), (i & r) !== r)) {
                                        Ne(), (e.pingedLanes |= e.suspendedLanes & i);
                                        break;
                                    }
                                    e.timeoutHandle = Mo(on.bind(null, e, We, St), t);
                                    break;
                                }
                                on(e, We, St);
                                break;
                            case 4:
                                if ((Ot(e, r), (r & 4194240) === r)) break;
                                for (t = e.eventTimes, i = -1; 0 < r; ) {
                                    var o = 31 - it(r);
                                    (l = 1 << o), (o = t[o]), o > i && (i = o), (r &= ~l);
                                }
                                if (
                                    ((r = i),
                                    (r = ae() - r),
                                    (r =
                                        (120 > r
                                            ? 120
                                            : 480 > r
                                              ? 480
                                              : 1080 > r
                                                ? 1080
                                                : 1920 > r
                                                  ? 1920
                                                  : 3e3 > r
                                                    ? 3e3
                                                    : 4320 > r
                                                      ? 4320
                                                      : 1960 * $p(r / 1960)) - r),
                                    10 < r)
                                ) {
                                    e.timeoutHandle = Mo(on.bind(null, e, We, St), r);
                                    break;
                                }
                                on(e, We, St);
                                break;
                            case 5:
                                on(e, We, St);
                                break;
                            default:
                                throw Error(S(329));
                        }
                    }
                }
                return Oe(e, ae()), e.callbackNode === n ? sd.bind(null, e) : null;
            }
            function $o(e, t) {
                var n = Pr;
                return (
                    e.current.memoizedState.isDehydrated && (cn(e, t).flags |= 256),
                    (e = rl(e, t)),
                    e !== 2 && ((t = We), (We = n), t !== null && Qo(t)),
                    e
                );
            }
            function Qo(e) {
                We === null ? (We = e) : We.push.apply(We, e);
            }
            function Qp(e) {
                for (var t = e; ; ) {
                    if (t.flags & 16384) {
                        var n = t.updateQueue;
                        if (n !== null && ((n = n.stores), n !== null))
                            for (var r = 0; r < n.length; r++) {
                                var i = n[r],
                                    l = i.getSnapshot;
                                i = i.value;
                                try {
                                    if (!ot(l(), i)) return !1;
                                } catch {
                                    return !1;
                                }
                            }
                    }
                    if (((n = t.child), t.subtreeFlags & 16384 && n !== null)) (n.return = t), (t = n);
                    else {
                        if (t === e) break;
                        for (; t.sibling === null; ) {
                            if (t.return === null || t.return === e) return !0;
                            t = t.return;
                        }
                        (t.sibling.return = t.return), (t = t.sibling);
                    }
                }
                return !0;
            }
            function Ot(e, t) {
                for (t &= ~Is, t &= ~hl, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
                    var n = 31 - it(t),
                        r = 1 << n;
                    (e[n] = -1), (t &= ~r);
                }
            }
            function va(e) {
                if ((j & 6) !== 0) throw Error(S(327));
                Bn();
                var t = Fi(e, 0);
                if ((t & 1) === 0) return Oe(e, ae()), null;
                var n = rl(e, t);
                if (e.tag !== 0 && n === 2) {
                    var r = ko(e);
                    r !== 0 && ((t = r), (n = $o(e, r)));
                }
                if (n === 1) throw ((n = Hr), cn(e, 0), Ot(e, t), Oe(e, ae()), n);
                if (n === 6) throw Error(S(345));
                return (e.finishedWork = e.current.alternate), (e.finishedLanes = t), on(e, We, St), Oe(e, ae()), null;
            }
            function Ls(e, t) {
                var n = j;
                j |= 1;
                try {
                    return e(t);
                } finally {
                    (j = n), j === 0 && (($n = ae() + 500), cl && Yt());
                }
            }
            function gn(e) {
                Ft !== null && Ft.tag === 0 && (j & 6) === 0 && Bn();
                var t = j;
                j |= 1;
                var n = Ze.transition,
                    r = H;
                try {
                    if (((Ze.transition = null), (H = 1), e)) return e();
                } finally {
                    (H = r), (Ze.transition = n), (j = t), (j & 6) === 0 && Yt();
                }
            }
            function Ws() {
                (Ae = Rn.current), $(Rn);
            }
            function cn(e, t) {
                (e.finishedWork = null), (e.finishedLanes = 0);
                var n = e.timeoutHandle;
                if ((n !== -1 && ((e.timeoutHandle = -1), Ep(n)), de !== null))
                    for (n = de.return; n !== null; ) {
                        var r = n;
                        switch ((ps(r), r.tag)) {
                            case 1:
                                (r = r.type.childContextTypes), r != null && Hi();
                                break;
                            case 3:
                                Kn(), $(Re), $(Me), _s();
                                break;
                            case 5:
                                Ss(r);
                                break;
                            case 4:
                                Kn();
                                break;
                            case 13:
                                $(re);
                                break;
                            case 19:
                                $(re);
                                break;
                            case 10:
                                vs(r.type._context);
                                break;
                            case 22:
                            case 23:
                                Ws();
                        }
                        n = n.return;
                    }
                if (
                    ((ve = e),
                    (de = e = Gt(e.current, null)),
                    (ke = Ae = t),
                    (he = 0),
                    (Hr = null),
                    (Is = hl = mn = 0),
                    (We = Pr = null),
                    un !== null)
                ) {
                    for (t = 0; t < un.length; t++)
                        if (((n = un[t]), (r = n.interleaved), r !== null)) {
                            n.interleaved = null;
                            var i = r.next,
                                l = n.pending;
                            if (l !== null) {
                                var o = l.next;
                                (l.next = i), (r.next = o);
                            }
                            n.pending = r;
                        }
                    un = null;
                }
                return e;
            }
            function ud(e, t) {
                do {
                    var n = de;
                    try {
                        if ((gs(), (Ti.current = Ji), Yi)) {
                            for (var r = ie.memoizedState; r !== null; ) {
                                var i = r.queue;
                                i !== null && (i.pending = null), (r = r.next);
                            }
                            Yi = !1;
                        }
                        if (
                            ((hn = 0),
                            (ge = pe = ie = null),
                            (zr = !1),
                            (Br = 0),
                            (Ts.current = null),
                            n === null || n.return === null)
                        ) {
                            (he = 1), (Hr = t), (de = null);
                            break;
                        }
                        e: {
                            var l = e,
                                o = n.return,
                                u = n,
                                a = t;
                            if (
                                ((t = ke),
                                (u.flags |= 32768),
                                a !== null && typeof a == "object" && typeof a.then == "function")
                            ) {
                                var c = a,
                                    m = u,
                                    g = m.tag;
                                if ((m.mode & 1) === 0 && (g === 0 || g === 11 || g === 15)) {
                                    var f = m.alternate;
                                    f
                                        ? ((m.updateQueue = f.updateQueue),
                                          (m.memoizedState = f.memoizedState),
                                          (m.lanes = f.lanes))
                                        : ((m.updateQueue = null), (m.memoizedState = null));
                                }
                                var v = ia(o);
                                if (v !== null) {
                                    (v.flags &= -257), la(v, o, u, l, t), v.mode & 1 && ra(l, c, t), (t = v), (a = c);
                                    var k = t.updateQueue;
                                    if (k === null) {
                                        var x = new Set();
                                        x.add(a), (t.updateQueue = x);
                                    } else k.add(a);
                                    break e;
                                } else {
                                    if ((t & 1) === 0) {
                                        ra(l, c, t), Vs();
                                        break e;
                                    }
                                    a = Error(S(426));
                                }
                            } else if (Y && u.mode & 1) {
                                var R = ia(o);
                                if (R !== null) {
                                    (R.flags & 65536) === 0 && (R.flags |= 256), la(R, o, u, l, t), hs(Gn(a, u));
                                    break e;
                                }
                            }
                            (l = a = Gn(a, u)), he !== 4 && (he = 2), Pr === null ? (Pr = [l]) : Pr.push(l), (l = o);
                            do {
                                switch (l.tag) {
                                    case 3:
                                        (l.flags |= 65536), (t &= -t), (l.lanes |= t);
                                        var h = qc(l, a, t);
                                        Xu(l, h);
                                        break e;
                                    case 1:
                                        u = a;
                                        var d = l.type,
                                            p = l.stateNode;
                                        if (
                                            (l.flags & 128) === 0 &&
                                            (typeof d.getDerivedStateFromError == "function" ||
                                                (p !== null &&
                                                    typeof p.componentDidCatch == "function" &&
                                                    (qt === null || !qt.has(p))))
                                        ) {
                                            (l.flags |= 65536), (t &= -t), (l.lanes |= t);
                                            var y = Kc(l, u, t);
                                            Xu(l, y);
                                            break e;
                                        }
                                }
                                l = l.return;
                            } while (l !== null);
                        }
                        dd(n);
                    } catch (z) {
                        (t = z), de === n && n !== null && (de = n = n.return);
                        continue;
                    }
                    break;
                } while (!0);
            }
            function ad() {
                var e = el.current;
                return (el.current = Ji), e === null ? Ji : e;
            }
            function Vs() {
                (he === 0 || he === 3 || he === 2) && (he = 4),
                    ve === null || ((mn & 268435455) === 0 && (hl & 268435455) === 0) || Ot(ve, ke);
            }
            function rl(e, t) {
                var n = j;
                j |= 2;
                var r = ad();
                (ve !== e || ke !== t) && ((St = null), cn(e, t));
                do
                    try {
                        Zp();
                        break;
                    } catch (i) {
                        ud(e, i);
                    }
                while (!0);
                if ((gs(), (j = n), (el.current = r), de !== null)) throw Error(S(261));
                return (ve = null), (ke = 0), he;
            }
            function Zp() {
                for (; de !== null; ) cd(de);
            }
            function Xp() {
                for (; de !== null && !zf(); ) cd(de);
            }
            function cd(e) {
                var t = pd(e.alternate, e, Ae);
                (e.memoizedProps = e.pendingProps), t === null ? dd(e) : (de = t), (Ts.current = null);
            }
            function dd(e) {
                var t = e;
                do {
                    var n = t.alternate;
                    if (((e = t.return), (t.flags & 32768) === 0)) {
                        if (((n = Up(n, t, Ae)), n !== null)) {
                            de = n;
                            return;
                        }
                    } else {
                        if (((n = Hp(n, t)), n !== null)) {
                            (n.flags &= 32767), (de = n);
                            return;
                        }
                        if (e !== null) (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
                        else {
                            (he = 6), (de = null);
                            return;
                        }
                    }
                    if (((t = t.sibling), t !== null)) {
                        de = t;
                        return;
                    }
                    de = t = e;
                } while (t !== null);
                he === 0 && (he = 5);
            }
            function on(e, t, n) {
                var r = H,
                    i = Ze.transition;
                try {
                    (Ze.transition = null), (H = 1), Yp(e, t, n, r);
                } finally {
                    (Ze.transition = i), (H = r);
                }
                return null;
            }
            function Yp(e, t, n, r) {
                do Bn();
                while (Ft !== null);
                if ((j & 6) !== 0) throw Error(S(327));
                n = e.finishedWork;
                var i = e.finishedLanes;
                if (n === null) return null;
                if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current)) throw Error(S(177));
                (e.callbackNode = null), (e.callbackPriority = 0);
                var l = n.lanes | n.childLanes;
                if (
                    (Vf(e, l),
                    e === ve && ((de = ve = null), (ke = 0)),
                    ((n.subtreeFlags & 2064) === 0 && (n.flags & 2064) === 0) ||
                        zi ||
                        ((zi = !0),
                        hd(Ai, function () {
                            return Bn(), null;
                        })),
                    (l = (n.flags & 15990) !== 0),
                    (n.subtreeFlags & 15990) !== 0 || l)
                ) {
                    (l = Ze.transition), (Ze.transition = null);
                    var o = H;
                    H = 1;
                    var u = j;
                    (j |= 4),
                        (Ts.current = null),
                        Kp(e, n),
                        ld(n, e),
                        kp(Po),
                        (bi = !!Eo),
                        (Po = Eo = null),
                        (e.current = n),
                        Gp(n, e, i),
                        Ef(),
                        (j = u),
                        (H = o),
                        (Ze.transition = l);
                } else e.current = n;
                if (
                    (zi && ((zi = !1), (Ft = e), (nl = i)),
                    (l = e.pendingLanes),
                    l === 0 && (qt = null),
                    Mf(n.stateNode, r),
                    Oe(e, ae()),
                    t !== null)
                )
                    for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                        (i = t[n]), r(i.value, { componentStack: i.stack, digest: i.digest });
                if (tl) throw ((tl = !1), (e = Ko), (Ko = null), e);
                return (
                    (nl & 1) !== 0 && e.tag !== 0 && Bn(),
                    (l = e.pendingLanes),
                    (l & 1) !== 0 ? (e === Go ? Cr++ : ((Cr = 0), (Go = e))) : (Cr = 0),
                    Yt(),
                    null
                );
            }
            function Bn() {
                if (Ft !== null) {
                    var e = qa(nl),
                        t = Ze.transition,
                        n = H;
                    try {
                        if (((Ze.transition = null), (H = 16 > e ? 16 : e), Ft === null)) var r = !1;
                        else {
                            if (((e = Ft), (Ft = null), (nl = 0), (j & 6) !== 0)) throw Error(S(331));
                            var i = j;
                            for (j |= 4, M = e.current; M !== null; ) {
                                var l = M,
                                    o = l.child;
                                if ((M.flags & 16) !== 0) {
                                    var u = l.deletions;
                                    if (u !== null) {
                                        for (var a = 0; a < u.length; a++) {
                                            var c = u[a];
                                            for (M = c; M !== null; ) {
                                                var m = M;
                                                switch (m.tag) {
                                                    case 0:
                                                    case 11:
                                                    case 15:
                                                        Er(8, m, l);
                                                }
                                                var g = m.child;
                                                if (g !== null) (g.return = m), (M = g);
                                                else
                                                    for (; M !== null; ) {
                                                        m = M;
                                                        var f = m.sibling,
                                                            v = m.return;
                                                        if ((nd(m), m === c)) {
                                                            M = null;
                                                            break;
                                                        }
                                                        if (f !== null) {
                                                            (f.return = v), (M = f);
                                                            break;
                                                        }
                                                        M = v;
                                                    }
                                            }
                                        }
                                        var k = l.alternate;
                                        if (k !== null) {
                                            var x = k.child;
                                            if (x !== null) {
                                                k.child = null;
                                                do {
                                                    var R = x.sibling;
                                                    (x.sibling = null), (x = R);
                                                } while (x !== null);
                                            }
                                        }
                                        M = l;
                                    }
                                }
                                if ((l.subtreeFlags & 2064) !== 0 && o !== null) (o.return = l), (M = o);
                                else
                                    e: for (; M !== null; ) {
                                        if (((l = M), (l.flags & 2048) !== 0))
                                            switch (l.tag) {
                                                case 0:
                                                case 11:
                                                case 15:
                                                    Er(9, l, l.return);
                                            }
                                        var h = l.sibling;
                                        if (h !== null) {
                                            (h.return = l.return), (M = h);
                                            break e;
                                        }
                                        M = l.return;
                                    }
                            }
                            var d = e.current;
                            for (M = d; M !== null; ) {
                                o = M;
                                var p = o.child;
                                if ((o.subtreeFlags & 2064) !== 0 && p !== null) (p.return = o), (M = p);
                                else
                                    e: for (o = d; M !== null; ) {
                                        if (((u = M), (u.flags & 2048) !== 0))
                                            try {
                                                switch (u.tag) {
                                                    case 0:
                                                    case 11:
                                                    case 15:
                                                        pl(9, u);
                                                }
                                            } catch (z) {
                                                oe(u, u.return, z);
                                            }
                                        if (u === o) {
                                            M = null;
                                            break e;
                                        }
                                        var y = u.sibling;
                                        if (y !== null) {
                                            (y.return = u.return), (M = y);
                                            break e;
                                        }
                                        M = u.return;
                                    }
                            }
                            if (((j = i), Yt(), mt && typeof mt.onPostCommitFiberRoot == "function"))
                                try {
                                    mt.onPostCommitFiberRoot(ll, e);
                                } catch {}
                            r = !0;
                        }
                        return r;
                    } finally {
                        (H = n), (Ze.transition = t);
                    }
                }
                return !1;
            }
            function ya(e, t, n) {
                (t = Gn(n, t)), (t = qc(e, t, 1)), (e = Ht(e, t, 1)), (t = Ne()), e !== null && (qr(e, 1, t), Oe(e, t));
            }
            function oe(e, t, n) {
                if (e.tag === 3) ya(e, e, n);
                else
                    for (; t !== null; ) {
                        if (t.tag === 3) {
                            ya(t, e, n);
                            break;
                        } else if (t.tag === 1) {
                            var r = t.stateNode;
                            if (
                                typeof t.type.getDerivedStateFromError == "function" ||
                                (typeof r.componentDidCatch == "function" && (qt === null || !qt.has(r)))
                            ) {
                                (e = Gn(n, e)),
                                    (e = Kc(t, e, 1)),
                                    (t = Ht(t, e, 1)),
                                    (e = Ne()),
                                    t !== null && (qr(t, 1, e), Oe(t, e));
                                break;
                            }
                        }
                        t = t.return;
                    }
            }
            function Jp(e, t, n) {
                var r = e.pingCache;
                r !== null && r.delete(t),
                    (t = Ne()),
                    (e.pingedLanes |= e.suspendedLanes & n),
                    ve === e &&
                        (ke & n) === n &&
                        (he === 4 || (he === 3 && (ke & 130023424) === ke && 500 > ae() - Ns) ? cn(e, 0) : (Is |= n)),
                    Oe(e, t);
            }
            function fd(e, t) {
                t === 0 &&
                    ((e.mode & 1) === 0 ? (t = 1) : ((t = ci), (ci <<= 1), (ci & 130023424) === 0 && (ci = 4194304)));
                var n = Ne();
                (e = Mt(e, t)), e !== null && (qr(e, t, n), Oe(e, n));
            }
            function eh(e) {
                var t = e.memoizedState,
                    n = 0;
                t !== null && (n = t.retryLane), fd(e, n);
            }
            function th(e, t) {
                var n = 0;
                switch (e.tag) {
                    case 13:
                        var r = e.stateNode,
                            i = e.memoizedState;
                        i !== null && (n = i.retryLane);
                        break;
                    case 19:
                        r = e.stateNode;
                        break;
                    default:
                        throw Error(S(314));
                }
                r !== null && r.delete(t), fd(e, n);
            }
            var pd;
            pd = function (e, t, n) {
                if (e !== null)
                    if (e.memoizedProps !== t.pendingProps || Re.current) Ve = !0;
                    else {
                        if ((e.lanes & n) === 0 && (t.flags & 128) === 0) return (Ve = !1), jp(e, t, n);
                        Ve = (e.flags & 131072) !== 0;
                    }
                else (Ve = !1), Y && (t.flags & 1048576) !== 0 && vc(t, Gi, t.index);
                switch (((t.lanes = 0), t.tag)) {
                    case 2:
                        var r = t.type;
                        Ni(e, t), (e = t.pendingProps);
                        var i = Un(t, Me.current);
                        bn(t, n), (i = zs(null, t, r, e, i, n));
                        var l = Es();
                        return (
                            (t.flags |= 1),
                            typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0
                                ? ((t.tag = 1),
                                  (t.memoizedState = null),
                                  (t.updateQueue = null),
                                  De(r) ? ((l = !0), qi(t)) : (l = !1),
                                  (t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null),
                                  ws(t),
                                  (i.updater = fl),
                                  (t.stateNode = i),
                                  (i._reactInternals = t),
                                  Ro(t, r, e, n),
                                  (t = Ao(null, t, r, !0, l, n)))
                                : ((t.tag = 0), Y && l && fs(t), Ie(null, t, i, n), (t = t.child)),
                            t
                        );
                    case 16:
                        r = t.elementType;
                        e: {
                            switch (
                                (Ni(e, t),
                                (e = t.pendingProps),
                                (i = r._init),
                                (r = i(r._payload)),
                                (t.type = r),
                                (i = t.tag = rh(r)),
                                (e = tt(r, e)),
                                i)
                            ) {
                                case 0:
                                    t = Oo(null, t, r, e, n);
                                    break e;
                                case 1:
                                    t = ua(null, t, r, e, n);
                                    break e;
                                case 11:
                                    t = oa(null, t, r, e, n);
                                    break e;
                                case 14:
                                    t = sa(null, t, r, tt(r.type, e), n);
                                    break e;
                            }
                            throw Error(S(306, r, ""));
                        }
                        return t;
                    case 0:
                        return (
                            (r = t.type),
                            (i = t.pendingProps),
                            (i = t.elementType === r ? i : tt(r, i)),
                            Oo(e, t, r, i, n)
                        );
                    case 1:
                        return (
                            (r = t.type),
                            (i = t.pendingProps),
                            (i = t.elementType === r ? i : tt(r, i)),
                            ua(e, t, r, i, n)
                        );
                    case 3:
                        e: {
                            if ((Zc(t), e === null)) throw Error(S(387));
                            (r = t.pendingProps), (l = t.memoizedState), (i = l.element), xc(e, t), Zi(t, r, null, n);
                            var o = t.memoizedState;
                            if (((r = o.element), l.isDehydrated))
                                if (
                                    ((l = {
                                        element: r,
                                        isDehydrated: !1,
                                        cache: o.cache,
                                        pendingSuspenseBoundaries: o.pendingSuspenseBoundaries,
                                        transitions: o.transitions,
                                    }),
                                    (t.updateQueue.baseState = l),
                                    (t.memoizedState = l),
                                    t.flags & 256)
                                ) {
                                    (i = Gn(Error(S(423)), t)), (t = aa(e, t, r, n, i));
                                    break e;
                                } else if (r !== i) {
                                    (i = Gn(Error(S(424)), t)), (t = aa(e, t, r, n, i));
                                    break e;
                                } else
                                    for (
                                        Fe = Ut(t.stateNode.containerInfo.firstChild),
                                            be = t,
                                            Y = !0,
                                            rt = null,
                                            n = Sc(t, null, r, n),
                                            t.child = n;
                                        n;

                                    )
                                        (n.flags = (n.flags & -3) | 4096), (n = n.sibling);
                            else {
                                if ((Hn(), r === i)) {
                                    t = Tt(e, t, n);
                                    break e;
                                }
                                Ie(e, t, r, n);
                            }
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return (
                            zc(t),
                            e === null && Lo(t),
                            (r = t.type),
                            (i = t.pendingProps),
                            (l = e !== null ? e.memoizedProps : null),
                            (o = i.children),
                            Co(r, i) ? (o = null) : l !== null && Co(r, l) && (t.flags |= 32),
                            Qc(e, t),
                            Ie(e, t, o, n),
                            t.child
                        );
                    case 6:
                        return e === null && Lo(t), null;
                    case 13:
                        return Xc(e, t, n);
                    case 4:
                        return (
                            ks(t, t.stateNode.containerInfo),
                            (r = t.pendingProps),
                            e === null ? (t.child = qn(t, null, r, n)) : Ie(e, t, r, n),
                            t.child
                        );
                    case 11:
                        return (
                            (r = t.type),
                            (i = t.pendingProps),
                            (i = t.elementType === r ? i : tt(r, i)),
                            oa(e, t, r, i, n)
                        );
                    case 7:
                        return Ie(e, t, t.pendingProps, n), t.child;
                    case 8:
                        return Ie(e, t, t.pendingProps.children, n), t.child;
                    case 12:
                        return Ie(e, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            if (
                                ((r = t.type._context),
                                (i = t.pendingProps),
                                (l = t.memoizedProps),
                                (o = i.value),
                                K($i, r._currentValue),
                                (r._currentValue = o),
                                l !== null)
                            )
                                if (ot(l.value, o)) {
                                    if (l.children === i.children && !Re.current) {
                                        t = Tt(e, t, n);
                                        break e;
                                    }
                                } else
                                    for (l = t.child, l !== null && (l.return = t); l !== null; ) {
                                        var u = l.dependencies;
                                        if (u !== null) {
                                            o = l.child;
                                            for (var a = u.firstContext; a !== null; ) {
                                                if (a.context === r) {
                                                    if (l.tag === 1) {
                                                        (a = Et(-1, n & -n)), (a.tag = 2);
                                                        var c = l.updateQueue;
                                                        if (c !== null) {
                                                            c = c.shared;
                                                            var m = c.pending;
                                                            m === null
                                                                ? (a.next = a)
                                                                : ((a.next = m.next), (m.next = a)),
                                                                (c.pending = a);
                                                        }
                                                    }
                                                    (l.lanes |= n),
                                                        (a = l.alternate),
                                                        a !== null && (a.lanes |= n),
                                                        Wo(l.return, n, t),
                                                        (u.lanes |= n);
                                                    break;
                                                }
                                                a = a.next;
                                            }
                                        } else if (l.tag === 10) o = l.type === t.type ? null : l.child;
                                        else if (l.tag === 18) {
                                            if (((o = l.return), o === null)) throw Error(S(341));
                                            (o.lanes |= n),
                                                (u = o.alternate),
                                                u !== null && (u.lanes |= n),
                                                Wo(o, n, t),
                                                (o = l.sibling);
                                        } else o = l.child;
                                        if (o !== null) o.return = l;
                                        else
                                            for (o = l; o !== null; ) {
                                                if (o === t) {
                                                    o = null;
                                                    break;
                                                }
                                                if (((l = o.sibling), l !== null)) {
                                                    (l.return = o.return), (o = l);
                                                    break;
                                                }
                                                o = o.return;
                                            }
                                        l = o;
                                    }
                            Ie(e, t, i.children, n), (t = t.child);
                        }
                        return t;
                    case 9:
                        return (
                            (i = t.type),
                            (r = t.pendingProps.children),
                            bn(t, n),
                            (i = Xe(i)),
                            (r = r(i)),
                            (t.flags |= 1),
                            Ie(e, t, r, n),
                            t.child
                        );
                    case 14:
                        return (r = t.type), (i = tt(r, t.pendingProps)), (i = tt(r.type, i)), sa(e, t, r, i, n);
                    case 15:
                        return Gc(e, t, t.type, t.pendingProps, n);
                    case 17:
                        return (
                            (r = t.type),
                            (i = t.pendingProps),
                            (i = t.elementType === r ? i : tt(r, i)),
                            Ni(e, t),
                            (t.tag = 1),
                            De(r) ? ((e = !0), qi(t)) : (e = !1),
                            bn(t, n),
                            Hc(t, r, i),
                            Ro(t, r, i, n),
                            Ao(null, t, r, !0, e, n)
                        );
                    case 19:
                        return Yc(e, t, n);
                    case 22:
                        return $c(e, t, n);
                }
                throw Error(S(156, t.tag));
            };
            function hd(e, t) {
                return Ba(e, t);
            }
            function nh(e, t, n, r) {
                (this.tag = e),
                    (this.key = n),
                    (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
                    (this.index = 0),
                    (this.ref = null),
                    (this.pendingProps = t),
                    (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
                    (this.mode = r),
                    (this.subtreeFlags = this.flags = 0),
                    (this.deletions = null),
                    (this.childLanes = this.lanes = 0),
                    (this.alternate = null);
            }
            function Qe(e, t, n, r) {
                return new nh(e, t, n, r);
            }
            function Rs(e) {
                return (e = e.prototype), !(!e || !e.isReactComponent);
            }
            function rh(e) {
                if (typeof e == "function") return Rs(e) ? 1 : 0;
                if (e != null) {
                    if (((e = e.$$typeof), e === es)) return 11;
                    if (e === ts) return 14;
                }
                return 2;
            }
            function Gt(e, t) {
                var n = e.alternate;
                return (
                    n === null
                        ? ((n = Qe(e.tag, t, e.key, e.mode)),
                          (n.elementType = e.elementType),
                          (n.type = e.type),
                          (n.stateNode = e.stateNode),
                          (n.alternate = e),
                          (e.alternate = n))
                        : ((n.pendingProps = t),
                          (n.type = e.type),
                          (n.flags = 0),
                          (n.subtreeFlags = 0),
                          (n.deletions = null)),
                    (n.flags = e.flags & 14680064),
                    (n.childLanes = e.childLanes),
                    (n.lanes = e.lanes),
                    (n.child = e.child),
                    (n.memoizedProps = e.memoizedProps),
                    (n.memoizedState = e.memoizedState),
                    (n.updateQueue = e.updateQueue),
                    (t = e.dependencies),
                    (n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
                    (n.sibling = e.sibling),
                    (n.index = e.index),
                    (n.ref = e.ref),
                    n
                );
            }
            function Vi(e, t, n, r, i, l) {
                var o = 2;
                if (((r = e), typeof e == "function")) Rs(e) && (o = 1);
                else if (typeof e == "string") o = 5;
                else
                    e: switch (e) {
                        case En:
                            return dn(n.children, i, l, t);
                        case Jo:
                            (o = 8), (i |= 8);
                            break;
                        case io:
                            return (e = Qe(12, n, t, i | 2)), (e.elementType = io), (e.lanes = l), e;
                        case lo:
                            return (e = Qe(13, n, t, i)), (e.elementType = lo), (e.lanes = l), e;
                        case oo:
                            return (e = Qe(19, n, t, i)), (e.elementType = oo), (e.lanes = l), e;
                        case za:
                            return ml(n, i, l, t);
                        default:
                            if (typeof e == "object" && e !== null)
                                switch (e.$$typeof) {
                                    case _a:
                                        o = 10;
                                        break e;
                                    case xa:
                                        o = 9;
                                        break e;
                                    case es:
                                        o = 11;
                                        break e;
                                    case ts:
                                        o = 14;
                                        break e;
                                    case Vt:
                                        (o = 16), (r = null);
                                        break e;
                                }
                            throw Error(S(130, e == null ? e : typeof e, ""));
                    }
                return (t = Qe(o, n, t, i)), (t.elementType = e), (t.type = r), (t.lanes = l), t;
            }
            function dn(e, t, n, r) {
                return (e = Qe(7, e, r, t)), (e.lanes = n), e;
            }
            function ml(e, t, n, r) {
                return (e = Qe(22, e, r, t)), (e.elementType = za), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e;
            }
            function to(e, t, n) {
                return (e = Qe(6, e, null, t)), (e.lanes = n), e;
            }
            function no(e, t, n) {
                return (
                    (t = Qe(4, e.children !== null ? e.children : [], e.key, t)),
                    (t.lanes = n),
                    (t.stateNode = {
                        containerInfo: e.containerInfo,
                        pendingChildren: null,
                        implementation: e.implementation,
                    }),
                    t
                );
            }
            function ih(e, t, n, r, i) {
                (this.tag = t),
                    (this.containerInfo = e),
                    (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
                    (this.timeoutHandle = -1),
                    (this.callbackNode = this.pendingContext = this.context = null),
                    (this.callbackPriority = 0),
                    (this.eventTimes = Fl(0)),
                    (this.expirationTimes = Fl(-1)),
                    (this.entangledLanes =
                        this.finishedLanes =
                        this.mutableReadLanes =
                        this.expiredLanes =
                        this.pingedLanes =
                        this.suspendedLanes =
                        this.pendingLanes =
                            0),
                    (this.entanglements = Fl(0)),
                    (this.identifierPrefix = r),
                    (this.onRecoverableError = i),
                    (this.mutableSourceEagerHydrationData = null);
            }
            function Ds(e, t, n, r, i, l, o, u, a) {
                return (
                    (e = new ih(e, t, n, u, a)),
                    t === 1 ? ((t = 1), l === !0 && (t |= 8)) : (t = 0),
                    (l = Qe(3, null, null, t)),
                    (e.current = l),
                    (l.stateNode = e),
                    (l.memoizedState = {
                        element: r,
                        isDehydrated: n,
                        cache: null,
                        transitions: null,
                        pendingSuspenseBoundaries: null,
                    }),
                    ws(l),
                    e
                );
            }
            function lh(e, t, n) {
                var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
                return {
                    $$typeof: zn,
                    key: r == null ? null : "" + r,
                    children: e,
                    containerInfo: t,
                    implementation: n,
                };
            }
            function md(e) {
                if (!e) return Qt;
                e = e._reactInternals;
                e: {
                    if (yn(e) !== e || e.tag !== 1) throw Error(S(170));
                    var t = e;
                    do {
                        switch (t.tag) {
                            case 3:
                                t = t.stateNode.context;
                                break e;
                            case 1:
                                if (De(t.type)) {
                                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                                    break e;
                                }
                        }
                        t = t.return;
                    } while (t !== null);
                    throw Error(S(171));
                }
                if (e.tag === 1) {
                    var n = e.type;
                    if (De(n)) return mc(e, n, t);
                }
                return t;
            }
            function gd(e, t, n, r, i, l, o, u, a) {
                return (
                    (e = Ds(n, r, !0, e, i, l, o, u, a)),
                    (e.context = md(null)),
                    (n = e.current),
                    (r = Ne()),
                    (i = Kt(n)),
                    (l = Et(r, i)),
                    (l.callback = t ?? null),
                    Ht(n, l, i),
                    (e.current.lanes = i),
                    qr(e, i, r),
                    Oe(e, r),
                    e
                );
            }
            function gl(e, t, n, r) {
                var i = t.current,
                    l = Ne(),
                    o = Kt(i);
                return (
                    (n = md(n)),
                    t.context === null ? (t.context = n) : (t.pendingContext = n),
                    (t = Et(l, o)),
                    (t.payload = { element: e }),
                    (r = r === void 0 ? null : r),
                    r !== null && (t.callback = r),
                    (e = Ht(i, t, o)),
                    e !== null && (lt(e, i, o, l), Mi(e, i, o)),
                    o
                );
            }
            function il(e) {
                if (((e = e.current), !e.child)) return null;
                switch (e.child.tag) {
                    case 5:
                        return e.child.stateNode;
                    default:
                        return e.child.stateNode;
                }
            }
            function wa(e, t) {
                if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
                    var n = e.retryLane;
                    e.retryLane = n !== 0 && n < t ? n : t;
                }
            }
            function Os(e, t) {
                wa(e, t), (e = e.alternate) && wa(e, t);
            }
            function oh() {
                return null;
            }
            var vd =
                typeof reportError == "function"
                    ? reportError
                    : function (e) {
                          console.error(e);
                      };
            function As(e) {
                this._internalRoot = e;
            }
            (vl.prototype.render = As.prototype.render =
                function (e) {
                    var t = this._internalRoot;
                    if (t === null) throw Error(S(409));
                    gl(e, t, null, null);
                }),
                (vl.prototype.unmount = As.prototype.unmount =
                    function () {
                        var e = this._internalRoot;
                        if (e !== null) {
                            this._internalRoot = null;
                            var t = e.containerInfo;
                            gn(function () {
                                gl(null, e, null, null);
                            }),
                                (t[Ct] = null);
                        }
                    });
            function vl(e) {
                this._internalRoot = e;
            }
            vl.prototype.unstable_scheduleHydration = function (e) {
                if (e) {
                    var t = $a();
                    e = { blockedOn: null, target: e, priority: t };
                    for (var n = 0; n < Dt.length && t !== 0 && t < Dt[n].priority; n++);
                    Dt.splice(n, 0, e), n === 0 && Za(e);
                }
            };
            function Fs(e) {
                return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
            }
            function yl(e) {
                return !(
                    !e ||
                    (e.nodeType !== 1 &&
                        e.nodeType !== 9 &&
                        e.nodeType !== 11 &&
                        (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "))
                );
            }
            function ka() {}
            function sh(e, t, n, r, i) {
                if (i) {
                    if (typeof r == "function") {
                        var l = r;
                        r = function () {
                            var c = il(o);
                            l.call(c);
                        };
                    }
                    var o = gd(t, r, e, 0, null, !1, !1, "", ka);
                    return (
                        (e._reactRootContainer = o),
                        (e[Ct] = o.current),
                        Dr(e.nodeType === 8 ? e.parentNode : e),
                        gn(),
                        o
                    );
                }
                for (; (i = e.lastChild); ) e.removeChild(i);
                if (typeof r == "function") {
                    var u = r;
                    r = function () {
                        var c = il(a);
                        u.call(c);
                    };
                }
                var a = Ds(e, 0, !1, null, null, !1, !1, "", ka);
                return (
                    (e._reactRootContainer = a),
                    (e[Ct] = a.current),
                    Dr(e.nodeType === 8 ? e.parentNode : e),
                    gn(function () {
                        gl(t, a, n, r);
                    }),
                    a
                );
            }
            function wl(e, t, n, r, i) {
                var l = n._reactRootContainer;
                if (l) {
                    var o = l;
                    if (typeof i == "function") {
                        var u = i;
                        i = function () {
                            var a = il(o);
                            u.call(a);
                        };
                    }
                    gl(t, o, e, i);
                } else o = sh(n, t, e, i, r);
                return il(o);
            }
            (Ka = function (e) {
                switch (e.tag) {
                    case 3:
                        var t = e.stateNode;
                        if (t.current.memoizedState.isDehydrated) {
                            var n = vr(t.pendingLanes);
                            n !== 0 && (is(t, n | 1), Oe(t, ae()), (j & 6) === 0 && (($n = ae() + 500), Yt()));
                        }
                        break;
                    case 13:
                        gn(function () {
                            var r = Mt(e, 1);
                            if (r !== null) {
                                var i = Ne();
                                lt(r, e, 1, i);
                            }
                        }),
                            Os(e, 1);
                }
            }),
                (ls = function (e) {
                    if (e.tag === 13) {
                        var t = Mt(e, 134217728);
                        if (t !== null) {
                            var n = Ne();
                            lt(t, e, 134217728, n);
                        }
                        Os(e, 134217728);
                    }
                }),
                (Ga = function (e) {
                    if (e.tag === 13) {
                        var t = Kt(e),
                            n = Mt(e, t);
                        if (n !== null) {
                            var r = Ne();
                            lt(n, e, t, r);
                        }
                        Os(e, t);
                    }
                }),
                ($a = function () {
                    return H;
                }),
                (Qa = function (e, t) {
                    var n = H;
                    try {
                        return (H = e), t();
                    } finally {
                        H = n;
                    }
                }),
                (vo = function (e, t, n) {
                    switch (t) {
                        case "input":
                            if ((ao(e, n), (t = n.name), n.type === "radio" && t != null)) {
                                for (n = e; n.parentNode; ) n = n.parentNode;
                                for (
                                    n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'),
                                        t = 0;
                                    t < n.length;
                                    t++
                                ) {
                                    var r = n[t];
                                    if (r !== e && r.form === e.form) {
                                        var i = al(r);
                                        if (!i) throw Error(S(90));
                                        Pa(r), ao(r, i);
                                    }
                                }
                            }
                            break;
                        case "textarea":
                            Ma(e, n);
                            break;
                        case "select":
                            (t = n.value), t != null && Dn(e, !!n.multiple, t, !1);
                    }
                }),
                (Ra = Ls),
                (Da = gn);
            var uh = { usingClientEntryPoint: !1, Events: [Gr, Tn, al, Wa, Va, Ls] },
                pr = {
                    findFiberByHostInstance: sn,
                    bundleType: 0,
                    version: "18.3.1",
                    rendererPackageName: "react-dom",
                },
                ah = {
                    bundleType: pr.bundleType,
                    version: pr.version,
                    rendererPackageName: pr.rendererPackageName,
                    rendererConfig: pr.rendererConfig,
                    overrideHookState: null,
                    overrideHookStateDeletePath: null,
                    overrideHookStateRenamePath: null,
                    overrideProps: null,
                    overridePropsDeletePath: null,
                    overridePropsRenamePath: null,
                    setErrorHandler: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: It.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function (e) {
                        return (e = Fa(e)), e === null ? null : e.stateNode;
                    },
                    findFiberByHostInstance: pr.findFiberByHostInstance || oh,
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null,
                    reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
                };
            if (
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
                ((hr = __REACT_DEVTOOLS_GLOBAL_HOOK__), !hr.isDisabled && hr.supportsFiber)
            )
                try {
                    (ll = hr.inject(ah)), (mt = hr);
                } catch {}
            var hr;
            (Ue.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = uh),
                (Ue.createPortal = function (e, t) {
                    var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
                    if (!Fs(t)) throw Error(S(200));
                    return lh(e, t, null, n);
                }),
                (Ue.createRoot = function (e, t) {
                    if (!Fs(e)) throw Error(S(299));
                    var n = !1,
                        r = "",
                        i = vd;
                    return (
                        t != null &&
                            (t.unstable_strictMode === !0 && (n = !0),
                            t.identifierPrefix !== void 0 && (r = t.identifierPrefix),
                            t.onRecoverableError !== void 0 && (i = t.onRecoverableError)),
                        (t = Ds(e, 1, !1, null, null, n, !1, r, i)),
                        (e[Ct] = t.current),
                        Dr(e.nodeType === 8 ? e.parentNode : e),
                        new As(t)
                    );
                }),
                (Ue.findDOMNode = function (e) {
                    if (e == null) return null;
                    if (e.nodeType === 1) return e;
                    var t = e._reactInternals;
                    if (t === void 0)
                        throw typeof e.render == "function"
                            ? Error(S(188))
                            : ((e = Object.keys(e).join(",")), Error(S(268, e)));
                    return (e = Fa(t)), (e = e === null ? null : e.stateNode), e;
                }),
                (Ue.flushSync = function (e) {
                    return gn(e);
                }),
                (Ue.hydrate = function (e, t, n) {
                    if (!yl(t)) throw Error(S(200));
                    return wl(null, e, t, !0, n);
                }),
                (Ue.hydrateRoot = function (e, t, n) {
                    if (!Fs(e)) throw Error(S(405));
                    var r = (n != null && n.hydratedSources) || null,
                        i = !1,
                        l = "",
                        o = vd;
                    if (
                        (n != null &&
                            (n.unstable_strictMode === !0 && (i = !0),
                            n.identifierPrefix !== void 0 && (l = n.identifierPrefix),
                            n.onRecoverableError !== void 0 && (o = n.onRecoverableError)),
                        (t = gd(t, null, e, 1, n ?? null, i, !1, l, o)),
                        (e[Ct] = t.current),
                        Dr(e),
                        r)
                    )
                        for (e = 0; e < r.length; e++)
                            (n = r[e]),
                                (i = n._getVersion),
                                (i = i(n._source)),
                                t.mutableSourceEagerHydrationData == null
                                    ? (t.mutableSourceEagerHydrationData = [n, i])
                                    : t.mutableSourceEagerHydrationData.push(n, i);
                    return new vl(t);
                }),
                (Ue.render = function (e, t, n) {
                    if (!yl(t)) throw Error(S(200));
                    return wl(null, e, t, !1, n);
                }),
                (Ue.unmountComponentAtNode = function (e) {
                    if (!yl(e)) throw Error(S(40));
                    return e._reactRootContainer
                        ? (gn(function () {
                              wl(null, null, e, !1, function () {
                                  (e._reactRootContainer = null), (e[Ct] = null);
                              });
                          }),
                          !0)
                        : !1;
                }),
                (Ue.unstable_batchedUpdates = Ls),
                (Ue.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
                    if (!yl(n)) throw Error(S(200));
                    if (e == null || e._reactInternals === void 0) throw Error(S(38));
                    return wl(e, t, n, !1, r);
                }),
                (Ue.version = "18.3.1-next-f1338f8080-20240426");
        }),
        Sd = kt((Lh, kd) => {
            "use strict";
            function wd() {
                if (
                    !(
                        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
                        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
                    )
                )
                    try {
                        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(wd);
                    } catch (e) {
                        console.error(e);
                    }
            }
            wd(), (kd.exports = yd());
        }),
        xd = kt((bs) => {
            "use strict";
            var _d = Sd();
            (bs.createRoot = _d.createRoot), (bs.hydrateRoot = _d.hydrateRoot);
            var Wh;
        }),
        Ed = kt((kl) => {
            "use strict";
            var ch = rr(),
                dh = Symbol.for("react.element"),
                fh = Symbol.for("react.fragment"),
                ph = Object.prototype.hasOwnProperty,
                hh = ch.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
                mh = { key: !0, ref: !0, __self: !0, __source: !0 };
            function zd(e, t, n) {
                var r,
                    i = {},
                    l = null,
                    o = null;
                n !== void 0 && (l = "" + n), t.key !== void 0 && (l = "" + t.key), t.ref !== void 0 && (o = t.ref);
                for (r in t) ph.call(t, r) && !mh.hasOwnProperty(r) && (i[r] = t[r]);
                if (e && e.defaultProps) for (r in ((t = e.defaultProps), t)) i[r] === void 0 && (i[r] = t[r]);
                return { $$typeof: dh, type: e, key: l, ref: o, props: i, _owner: hh.current };
            }
            (kl.Fragment = fh), (kl.jsx = zd), (kl.jsxs = zd);
        }),
        Qr = kt((Dh, Pd) => {
            "use strict";
            Pd.exports = Ed();
        }),
        Eh = {};
    Hd(Eh, { mount: () => zh });
    var Ah = nn(rr(), 1),
        Cd = nn(xd(), 1),
        N = nn(rr(), 1),
        s = nn(Qr(), 1),
        gh = new Set(["wattstone", "wandpv", "zaunpv"]);
    function wn(e) {
        if (!e || typeof e != "string") return null;
        let t = e.trim().toLowerCase();
        return gh.has(t) ? t : null;
    }
    function vh(e) {
        try {
            let n = new URLSearchParams(window.location.search),
                r = wn(n.get("configTab") || n.get("tab"));
            if (r) return r;
        } catch {}
        try {
            let n = String(window.location.hash || "").match(/tab=(wattstone|wandpv|zaunpv)/i),
                r = wn(n && n[1]);
            if (r) return r;
        } catch {}
        let t = wn(e);
        if (t) return t;
        try {
            let n = document.querySelector("[data-default-tab]"),
                r = wn(n && n.getAttribute("data-default-tab"));
            if (r) return r;
        } catch {}
        return "wattstone";
    }
    function yh() {
        let [e, t] = (0, N.useState)(0);
        return (
            (0, N.useEffect)(() => {
                let n = () => {
                    var m;
                    let l = 0,
                        o = new Set();
                    [
                        "#shopify-section-header",
                        "header#shopify-section-header",
                        ".shopify-section-header",
                        "header.site-header",
                        "header.Header",
                        'header[role="banner"]',
                        ".announcement-bar",
                        ".shopify-section--header",
                    ].forEach((g) => {
                        document.querySelectorAll(g).forEach((f) => {
                            if (o.has(f) || !f || f.offsetParent === null) return;
                            let v = window.getComputedStyle(f);
                            (v.position === "sticky" || v.position === "fixed") &&
                                ((l += f.offsetHeight || 0), o.add(f));
                        });
                    });
                    let a = (m = document.body) == null ? void 0 : m.getAttribute("data-header-offset");
                    a && !Number.isNaN(Number(a)) && (l = Number(a));
                    let c = getComputedStyle(document.documentElement).getPropertyValue("--header-offset");
                    if (c) {
                        let g = Number(String(c).replace("px", "").trim());
                        !Number.isNaN(g) && g >= 0 && (l = g);
                    }
                    t(l);
                };
                n();
                let r = new ResizeObserver(n);
                document
                    .querySelectorAll("header, .announcement-bar, .shopify-section-header")
                    .forEach((l) => r.observe(l)),
                    window.addEventListener("resize", n),
                    window.addEventListener("orientationchange", n);
                let i = setTimeout(n, 350);
                return () => {
                    r.disconnect(),
                        window.removeEventListener("resize", n),
                        window.removeEventListener("orientationchange", n),
                        clearTimeout(i);
                };
            }, []),
            e
        );
    }
    function wh() {
        let [e, t] = N.default.useState(0);
        return (
            N.default.useEffect(() => {
                let n = () => {
                    var m;
                    let l = 0,
                        o = new Set();
                    [
                        "#shopify-section-header",
                        "header#shopify-section-header",
                        ".shopify-section-header",
                        "header.site-header",
                        "header.Header",
                        'header[role="banner"]',
                        ".announcement-bar",
                        ".shopify-section--header",
                        ".shopify-section-header-sticky",
                    ].forEach((g) => {
                        document.querySelectorAll(g).forEach((f) => {
                            if (o.has(f) || !f || f.offsetParent === null) return;
                            let v = getComputedStyle(f);
                            if (v.position === "sticky" || v.position === "fixed") {
                                let k = parseInt(v.zIndex, 10);
                                Number.isNaN(k) || (l = Math.max(l, k)), o.add(f);
                            }
                        });
                    });
                    let a = (m = document.body) == null ? void 0 : m.getAttribute("data-header-z-index");
                    a && !Number.isNaN(Number(a)) && (l = Number(a));
                    let c = getComputedStyle(document.documentElement).getPropertyValue("--header-z-index");
                    if (c) {
                        let g = Number(String(c).trim());
                        Number.isNaN(g) || (l = g);
                    }
                    t(l || 0);
                };
                n();
                let r = new ResizeObserver(n);
                document
                    .querySelectorAll("header, .announcement-bar, .shopify-section-header")
                    .forEach((l) => r.observe(l)),
                    window.addEventListener("resize", n),
                    window.addEventListener("orientationchange", n);
                let i = setTimeout(n, 350);
                return () => {
                    r.disconnect(),
                        window.removeEventListener("resize", n),
                        window.removeEventListener("orientationchange", n),
                        clearTimeout(i);
                };
            }, []),
            e
        );
    }
    var kh = "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/info.webp?v=1757478776";
    function W({ href: e, children: t }) {
        return (0, s.jsxs)("span", {
            style: { display: "inline-flex", alignItems: "center", gap: 6 },
            children: [
                (0, s.jsx)("img", {
                    src: kh,
                    alt: "",
                    "aria-hidden": "true",
                    width: 14,
                    height: 14,
                    style: { display: "inline-block" },
                }),
                (0, s.jsx)("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: t }),
            ],
        });
    }
    function se({ title: e, children: t, info: n, showInfo: r = !0 }) {
        let [i, l] = (0, N.useState)(!1);
        return (
            (0, N.useEffect)(() => {
                if (!i) return;
                let u = (a) => a.key === "Escape" && l(!1);
                return window.addEventListener("keydown", u), () => window.removeEventListener("keydown", u);
            }, [i]),
            (0, s.jsxs)("div", {
                style: {
                    position: "relative",
                    border: "1px solid #ddd",
                    borderRadius: 14,
                    padding: 12,
                    marginBottom: 12,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                },
                children: [
                    (0, s.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 6,
                        },
                        children: [
                            (0, s.jsx)("h2", { style: { fontSize: 16, margin: 0 }, children: e }),
                            r && n
                                ? (0, s.jsx)(
                                      ({ onClick: u }) =>
                                          (0, s.jsx)("button", {
                                              type: "button",
                                              onClick: u,
                                              "aria-label": `Mehr Infos zu ${e}`,
                                              title: "Mehr Infos",
                                              style: {
                                                  width: 22,
                                                  height: 22,
                                                  borderRadius: "50%",
                                                  background: "#FFE24D",
                                                  border: "none",
                                                  outline: "none",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                  lineHeight: 1,
                                              },
                                              children: (0, s.jsx)("span", {
                                                  "aria-hidden": "true",
                                                  style: {
                                                      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
                                                      fontSize: 12,
                                                      lineHeight: 1,
                                                      color: "#111",
                                                      fontWeight: 800,
                                                  },
                                                  children: "\u2139\uFE0E",
                                              }),
                                          }),
                                      { onClick: () => l(!0) }
                                  )
                                : null,
                        ],
                    }),
                    (0, s.jsx)("div", { style: { display: "flex", flexWrap: "wrap", gap: 8 }, children: t }),
                    i &&
                        (0, s.jsx)("div", {
                            role: "dialog",
                            "aria-modal": "true",
                            onClick: () => l(!1),
                            style: {
                                position: "fixed",
                                inset: 0,
                                background: "rgba(0,0,0,0.45)",
                                zIndex: 1e5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 16,
                            },
                            children: (0, s.jsxs)("div", {
                                onClick: (u) => u.stopPropagation(),
                                style: {
                                    width: "min(700px, 92vw)",
                                    maxHeight: "80vh",
                                    overflowY: "auto",
                                    background: "#fff",
                                    borderRadius: 12,
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                                    padding: 16,
                                },
                                children: [
                                    (0, s.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: 8,
                                        },
                                        children: [
                                            (0, s.jsx)("div", {
                                                style: { fontWeight: 700, fontSize: 16 },
                                                children: e,
                                            }),
                                            (0, s.jsx)("button", {
                                                type: "button",
                                                onClick: () => l(!1),
                                                "aria-label": "Schlie\xDFen",
                                                style: {
                                                    border: "1px solid #ddd",
                                                    background: "#f7f7f7",
                                                    borderRadius: 8,
                                                    padding: "4px 8px",
                                                    cursor: "pointer",
                                                    fontSize: 12,
                                                },
                                                children: "Schlie\xDFen",
                                            }),
                                        ],
                                    }),
                                    (0, s.jsx)("div", { style: { fontSize: 14, lineHeight: 1.55 }, children: n }),
                                ],
                            }),
                        }),
                ],
            })
        );
    }
    function Sh({ stickyTop: e = 0 }) {
        var X, fe;
        let t = {
                wandPV_vertical: {
                    id: "wandPV_vertical",
                    title: "WandPV vertical \u2013 Basis-Set",
                    price: 7.13,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WandPV_Horizontal_5.png?v=1756031182",
                    variantId: 55985487577472,
                },
                wandPV_horizontal: {
                    id: "wandPV_horizontal",
                    title: "WandPV horizontal \u2013 Basis-Set",
                    price: 332.01,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WandPV_Horizontal_7.png?v=1756031182",
                    variantId: 53940260798788,
                },
                wandPV_sandwich: {
                    id: "wandPV_sandwich",
                    title: "WandPV Sandwich \u2013 Basis-Set",
                    price: 308.21,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WandPV_Horizontal_6.png?v=1756031181",
                    variantId: 53940264337732,
                },
                railConnectorSet: {
                    id: "railConnectorSet",
                    title: "Schienenverbinder-Set f\xFCr WandPV-Einlegeschienen",
                    price: 7.13,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_294.png?v=1756000696",
                    variantId: 55985487577472,
                },
                inverter800: {
                    id: "inverter800",
                    title: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                    price: 474.81,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW.png?v=1755742176",
                    variantId: 53940270530884,
                },
                inverter2000: {
                    id: "inverter2000",
                    title: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                    price: 474.81,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW_4.png?v=1755742176",
                    variantId: 53940271382852,
                },
                pvModule: {
                    id: "pvModule",
                    title: "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon Solarmodule 1762x1134x30 mm",
                    price: 78.54,
                    img: "https://wattstone.de/cdn/shop/files/trina_tsm_neg9r.28_alternergyw_1_1_1_1160x_crop_center.jpg?v=1753672912",
                    variantId: 56448182354304,
                },
            },
            n = {
                vertical: [
                    {
                        key: "einlege_1140",
                        title: "Einlegeschiene 30 mm / 1140 mm, schwarz eloxiert",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/einlegeschiene-30-mm-schwarz-alu-wandpv.png?v=1756000696",
                    },
                    {
                        key: "grund_40x40x300",
                        title: "Grundschiene 40\xD740\xD7300 mm, Alu schwarz, vorgebohrt",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/grundschiene-40x40-alu-wandpv_17.png?v=1756000695",
                    },
                    {
                        key: "randanschlag",
                        title: "Randanschlag schwarz m. Schraube & Einwegsicherheitsschraube",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/randanschlag-schwarz-fuer-einlegeschiene-wandpv.png?v=1756000696",
                    },
                    {
                        key: "kreuzverb",
                        title: "Kreuzverbinder Standard ELS m. Nutenschraube M8 & Sicherungsmutter",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/verbinder-einlegeschiene-kraft-und-formschluss-vorkonfiguriert-wandpv.png?v=1756000696",
                    },
                    {
                        key: "verb_einlege",
                        title: "Schienenverbinder f\xFCr Einlegeschienen, schwarz",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/1_10885.png?v=1756001620",
                    },
                    {
                        key: "tellerkopfschraube",
                        title: "Tellerkopfschrauben 8\xD7100 mm m. Fischer D\xFCbel (ETA)",
                        qty: 16,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image.png?v=1756000697",
                    },
                    {
                        key: "nutenstein",
                        title: "Nutenstein m. Schraube M8\xD712 mm & U-Scheibe",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_348.png?v=1756000696",
                    },
                    {
                        key: "abrutschsicherung",
                        title: "Abrutschsicherung: Winkel verzinkt 25\xD725\xD715 mm",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_356.png?v=1756000696",
                    },
                    {
                        key: "klapperschutz",
                        title: "Klapperschutz Filzpl\xE4ttchen",
                        qty: 12,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_295.png?v=1756000695",
                    },
                    {
                        key: "kabelclips",
                        title: "Kabel Clips",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/clip_21.png?v=1756000696",
                    },
                ],
                horizontal: [
                    {
                        key: "einlege_1765",
                        title: "Einlegeschiene 30 mm / 1765 mm, Alu schwarz eloxiert (ETA)",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/einlegeschiene-30-mm-schwarz-alu-wandpv.png?v=1756000696",
                    },
                    {
                        key: "grund_40x40x1200",
                        title: "Grundschiene 40\xD740\xD71200 mm, Alu schwarz, vorgebohrt",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/grundschiene-40x40-alu-wandpv_17.png?v=1756000695",
                    },
                    {
                        key: "randanschlag",
                        title: "Randanschlag schwarz m. Schraube & Einwegsicherheitsschraube",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/randanschlag-schwarz-fuer-einlegeschiene-wandpv.png?v=1756000696",
                    },
                    {
                        key: "kreuzverb",
                        title: "Kreuzverbinder Standard ELS m. Nutenschraube M8 & Sicherungsmutter",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/verbinder-einlegeschiene-kraft-und-formschluss-vorkonfiguriert-wandpv.png?v=1756000696",
                    },
                    {
                        key: "verb_einlege",
                        title: "Schienenverbinder f\xFCr Einlegeschienen, schwarz",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/1_10885.png?v=1756001620",
                    },
                    {
                        key: "tellerkopfschraube",
                        title: "Tellerkopfschrauben 8\xD7100 mm m. Fischer D\xFCbel (ETA)",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image.png?v=1756000697",
                    },
                    {
                        key: "nutenstein",
                        title: "Nutenstein m. Schraube M8\xD712 mm & U-Scheibe",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_348.png?v=1756000696",
                    },
                    {
                        key: "bohr_linsenkopf",
                        title: "Bohrschraube Linsenkopf DIN 7504-N vz, H2 3,5\xD713",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/s-l400_1.png?v=1756000696",
                    },
                    {
                        key: "abrutschsicherung",
                        title: "Abrutschsicherung: Winkel verzinkt 25\xD725\xD715 mm",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_356.png?v=1756000696",
                    },
                    {
                        key: "klapperschutz",
                        title: "Klapperschutz Filzpl\xE4ttchen",
                        qty: 12,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_295.png?v=1756000695",
                    },
                    {
                        key: "kabelclips",
                        title: "Kabel Clips",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/clip_21.png?v=1756000696",
                    },
                ],
                sandwich: [
                    {
                        key: "einlege_1765",
                        title: "Einlegeschiene 30 mm / 1765 mm, Alu schwarz eloxiert (ETA)",
                        qty: 3,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/einlegeschiene-30-mm-schwarz-alu-wandpv.png?v=1756000696",
                    },
                    {
                        key: "grund_40x40x1200",
                        title: "Grundschiene 40\xD740\xD71200 mm, Alu schwarz, vorgebohrt",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/grundschiene-40x40-alu-wandpv_17.png?v=1756000695",
                    },
                    {
                        key: "grund_40x40x300",
                        title: "Grundschiene 40\xD740\xD7300 mm, Alu schwarz, vorgebohrt",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/grundschiene-40x40-alu-wandpv_17.png?v=1756000695",
                    },
                    {
                        key: "randanschlag",
                        title: "Randanschlag schwarz m. Schraube & Einwegsicherheitsschraube",
                        qty: 6,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/randanschlag-schwarz-fuer-einlegeschiene-wandpv.png?v=1756000696",
                    },
                    {
                        key: "kreuzverb",
                        title: "Kreuzverbinder Standard ELS m. Nutenschraube M8 & Sicherungsmutter",
                        qty: 6,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/verbinder-einlegeschiene-kraft-und-formschluss-vorkonfiguriert-wandpv.png?v=1756000696",
                    },
                    {
                        key: "tellerkopfschraube",
                        title: "Tellerkopfschrauben 8\xD7100 mm m. Fischer D\xFCbel (ETA)",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image.png?v=1756000697",
                    },
                    {
                        key: "nutenstein",
                        title: "Nutenstein m. Schraube M8\xD712 mm & U-Scheibe",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_348.png?v=1756000696",
                    },
                    {
                        key: "bohr_linsenkopf",
                        title: "Bohrschraube Linsenkopf DIN 7504-N vz, H2 3,5\xD713",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/s-l400_1.png?v=1756000696",
                    },
                    {
                        key: "abrutschsicherung",
                        title: "Abrutschsicherung: Winkel verzinkt 25\xD725\xD715 mm",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/image_356.png?v=1756000696",
                    },
                    {
                        key: "klapperschutz",
                        title: "Klapperschutz Filzpl\xE4ttchen",
                        qty: 12,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_295.png?v=1756000695",
                    },
                    {
                        key: "kabelclips",
                        title: "Kabel Clips",
                        qty: 8,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/clip_21.png?v=1756000696",
                    },
                ],
            },
            r = [
                {
                    key: "vertical",
                    label: "WandPV vertical",
                    productKey: "wandPV_vertical",
                    img: t.wandPV_vertical.img,
                },
                {
                    key: "horizontal",
                    label: "WandPV horizontal",
                    productKey: "wandPV_horizontal",
                    img: t.wandPV_horizontal.img,
                },
                {
                    key: "sandwich",
                    label: "WandPV Sandwich",
                    productKey: "wandPV_sandwich",
                    img: t.wandPV_sandwich.img,
                },
            ],
            i = "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-7.png?v=1756002636",
            l = {
                vertical: {
                    two: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1_309760f7-96e4-4fdf-b3b0-64b76c58daad.png?v=1756002639",
                    fourPlus: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-5.png?v=1756002642",
                },
                horizontal: {
                    two: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-3.png?v=1756002641",
                    fourPlus: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-4.png?v=1756002641",
                },
                sandwich: {
                    two: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-2.png?v=1756002640",
                    fourPlus: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1-6.png?v=1756002643",
                },
            },
            o = {
                title: "Schienenverbinder f\xFCr Einlegeschienen, schwarz",
                img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/1_10885.png?v=1756001620",
            },
            [u, a] = (0, N.useState)(null),
            [c, m] = (0, N.useState)(null),
            [g, f] = (0, N.useState)("without"),
            [v, k] = (0, N.useState)("without"),
            x = () => {
                try {
                    if (typeof window < "u") {
                        if (typeof window.__CUSTOMER_LOGGED_IN__ < "u") return !!window.__CUSTOMER_LOGGED_IN__;
                        let _ = document.querySelector('meta[name="customer-logged-in"]');
                        if (_) return _.content === "true";
                        let V = document.querySelector("[data-customer-logged-in]");
                        if (V) return V.getAttribute("data-customer-logged-in") === "true";
                    }
                } catch {}
                return !1;
            },
            [R, h] = (0, N.useState)(x());
        (0, N.useEffect)(() => {
            h(x());
        }, []);
        let d = () => {
                let _ = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
                window.location.href = `/account?return_url=${_}`;
            },
            [p, y] = (0, N.useState)(!1);
        (0, N.useEffect)(() => {
            let _ = () => y(window.innerWidth <= 768);
            return _(), window.addEventListener("resize", _), () => window.removeEventListener("resize", _);
        }, []);
        let z = (0, N.useMemo)(
                () => ({
                    gap: p ? 10 : 16,
                    sectionPadding: p ? 10 : 14,
                    sectionTitleSize: p ? 14 : 16,
                    h1Size: p ? 20 : 22,
                    bodyFont: p ? 13 : 14,
                    smallText: p ? 11 : 12,
                    buttonPadding: p ? "8px 10px" : "10px 12px",
                    buttonFont: p ? 13 : 14,
                    cardMinH: p ? "78px" : "88px",
                    listFont: p ? 13 : 14,
                }),
                [p]
            ),
            I = ((_, V, ce = 1) => {
                let ue = [];
                for (let xe = _; xe <= V; xe += ce) ue.push(xe);
                return ue;
            })(2, 100, 2),
            T = ({ label: _, img: V, selected: ce, disabled: ue, onClick: xe }) =>
                (0, s.jsxs)("button", {
                    onClick: xe,
                    disabled: ue,
                    style: {
                        margin: p ? 6 : 8,
                        padding: z.buttonPadding,
                        fontSize: z.buttonFont,
                        borderRadius: 10,
                        cursor: ue ? "not-allowed" : "pointer",
                        backgroundColor: ue ? "#ddd" : ce ? "#FFE24D" : "#f9f9f9",
                        color: ue ? "#888" : "#1b1b1b",
                        border: ce ? "2px solid #FFE24D" : "1px solid #ccc",
                        minWidth: p ? "110px" : "140px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        lineHeight: 1.2,
                    },
                    title: typeof _ == "string" ? _ : void 0,
                    type: "button",
                    children: [
                        V &&
                            (0, s.jsx)("img", {
                                src: V,
                                alt: typeof _ == "string" ? _ : "option",
                                style: { width: 76, height: 54, objectFit: "contain", marginBottom: 6 },
                            }),
                        _,
                    ],
                }),
            O = u && c ? Math.floor(c / 2) : 0,
            D = Math.max(0, O - 1),
            J = u ? n[u] : null,
            st = !u || O <= 1 ? 0 : u === "sandwich" ? Math.ceil(1.5 * D) : D,
            Jt = (fe = (X = J?.find((_) => _.key === "verb_einlege")) == null ? void 0 : X.qty) != null ? fe : 0,
            Xn = O > 0 ? Jt * O : 0,
            Yn = st * 2,
            Q = Xn + Yn,
            b = c
                ? ((_) => {
                      if (!_ || _ <= 0) return { n2000: 0, n800: 0 };
                      let V = Math.floor(_ / 4),
                          ce = _ % 4;
                      return ce === 0
                          ? { n2000: V, n800: 0 }
                          : ce <= 2
                            ? { n2000: V, n800: 1 }
                            : { n2000: V + 1, n800: 0 };
                  })(c)
                : { n2000: 0, n800: 0 },
            Z = [];
        if (u && c) {
            let _ = r.find((ce) => ce.key === u),
                V = t[_.productKey];
            O > 0 && Z.push({ ...V, qty: O, components: J || [] }),
                st > 0 && Z.push({ ...t.railConnectorSet, qty: st }),
                g === "with" && Z.push({ ...t.pvModule, qty: c }),
                v === "with" &&
                    (b.n2000 > 0 && Z.push({ ...t.inverter2000, qty: b.n2000 }),
                    b.n800 > 0 && Z.push({ ...t.inverter800, qty: b.n800 }));
        }
        let He = Z.reduce((_, V) => _ + (Number(V.price) || 0) * (Number(V.qty) || 0), 0),
            ut = [];
        J &&
            O > 0 &&
            J.forEach((_) => {
                _.key !== "verb_einlege" && ut.push({ title: _.title, qty: _.qty * O, img: _.img });
            }),
            Q > 0 && ut.push({ title: o.title, qty: Q, img: o.img }),
            g === "with" && c && ut.push({ title: t.pvModule.title, qty: c, img: t.pvModule.img }),
            v === "with" &&
                (b.n2000 > 0 && ut.push({ title: t.inverter2000.title, qty: b.n2000, img: t.inverter2000.img }),
                b.n800 > 0 && ut.push({ title: t.inverter800.title, qty: b.n800, img: t.inverter800.img }));
        function _e(_) {
            var ce, ue;
            let V = new Map();
            for (let xe of _) {
                let ct = Number(xe.id),
                    me = Number((ue = (ce = xe.quantity) != null ? ce : xe.qty) != null ? ue : 0);
                !ct || me <= 0 || V.set(ct, (V.get(ct) || 0) + me);
            }
            return Array.from(V.entries()).map(([xe, ct]) => ({ id: xe, quantity: ct }));
        }
        let vt = () => {
            var V, ce;
            if (!(u && c)) return [];
            let _ = [];
            for (let ue of Z) {
                let xe =
                        (ce = ue.variantId) != null
                            ? ce
                            : typeof ue.id == "string"
                              ? (V = t[ue.id]) == null
                                  ? void 0
                                  : V.variantId
                              : Number(ue.id),
                    ct = Number(ue.qty || 0);
                xe && ct > 0 && _.push({ id: Number(xe), quantity: ct });
            }
            return _e(_);
        };
        async function yt(_) {
            if (!_ || _.length === 0) throw new Error("No items to add");
            let V = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: _ }),
                credentials: "same-origin",
            });
            if (!V.ok) throw new Error(await V.text());
            return V.json();
        }
        let Nt = async () => {
                try {
                    if (!R) return alert("Bitte anmelden oder ein Konto erstellen, um in den Warenkorb zu legen.");
                    if (!(u && c)) return alert("Bitte Ausrichtung und Anzahl der PV-Module w\xE4hlen.");
                    let _ = vt();
                    if (!_.length) return alert("Keine Artikel gefunden.");
                    await yt(_), alert("Artikel wurden dem Warenkorb hinzugef\xFCgt.");
                                            window.location.href = '/cart';

                } catch (_) {
                    console.error("Add to cart error", _),
                        alert("Fehler beim Hinzuf\xFCgen zum Warenkorb. Siehe Konsole.");
                }
            },
            kn = () => (window.location.href = "/cart"),
            Jn = () => {
                a(null), m(null), f("without"), k("without");
            },
            at = () => {
                var ue;
                if (!u) return i;
                let V = (c ?? 2) >= 4 ? "fourPlus" : "two";
                return ((ue = l[u]) == null ? void 0 : ue[V]) || i;
            },
            tn = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "WandPV ist ein verdecktes Einlege-Montagesystem zur direkten Installation von PV-Modulen an Au\xDFenw\xE4nden. Tragschienen, Einlegeschienen und zugelassene D\xFCbel/Anker bilden eine stabile Basis; die Module \u201Eschwimmen\u201C in den Einlegeschienen \u2013 das reduziert Punktlasten und gleicht thermische L\xE4ngen\xE4nderungen aus. Das modulare System skaliert horizontal wie vertikal \u2013 vom 2-Modul-Start bis zur vollfl\xE4chigen Fassade \u2013 mit sauberer, schraubenfreier Ansicht. Made in Germany.",
                            (0, s.jsx)("br", {}),
                            "Ausrichtungen:",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Horizontal" }),
                            " \u2014 Module im Querformat auf horizontalen Einlegeschienen f\xFCr lange, durchgehende Fassadenb\xE4nder und pr\xE4zise Linienf\xFChrung.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Vertikal" }),
                            " \u2014 Module im Hochformat f\xFCr schlanke Proportionen und bessere Ertr\xE4ge bei niedrigem Sonnenstand (Morgen/Abend, Winter).",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Sandwich" }),
                            " \u2014 Zwei horizontale Einlegeschienen (oben/unten) \u201Esandwichen\u201C das Modul; erm\xF6glicht dichte, b\xFCndige Layouts und maximiert die nutzbare Fassadenfl\xE4che, bei erhaltener Hinterl\xFCftung.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WandPV_Montageset_fur_2_PV-Module_11.12.pdf?v=1741691476",
                            children: "Montageanleitung f\xFCr WandPV Premium horizontal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Projektbericht_Wattstone_WandPV_-_2_Module_horizontal_25.06.25.pdf?v=1750993949",
                            children: "WandPV Statikbericht 2 Module horizontal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WandPV_Montageset_fur_2_PV-Module_vertikal_11.12.pdf?v=1741691476",
                            children: "Montageanleitung f\xFCr WandPV Premium vertikal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Projektbericht_Wattstone_WandPV_-_2_Module_vertikal_25.06.25.pdf?v=1750993948",
                            children: "WandPV Statikbericht 2 Module vertikal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/projekte-wandpv",
                            children: "WandPV Projektportfolio",
                        }),
                    }),
                ],
            }),
            er = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Geben Sie die Anzahl der PV-Module an (immer ",
                            (0, s.jsx)("strong", { children: "gerade" }),
                            " Zahl). Der Konfigurator berechnet Schienen, Verbinder und Kleinteile automatisch.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/montage",
                            children: "Montagehinweise",
                        }),
                    }),
                ],
            }),
            wt = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Sie k\xF6nnen die passenden ",
                            (0, s.jsx)("strong", { children: "PV-Module" }),
                            " direkt mitbestellen (Trina 460 W). Mengen werden automatisch an Ihre Auswahl angepasst.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/22-Vertex_S_plus_NEG9R.28_240411_Datasheet_Vertex_S__NEG9R.28_DE_2024_A_S1_web.pdf?v=1742091602",
                            children:
                                "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon Solarmodule 1762x1134x30 mm",
                        }),
                    }),
                ],
            }),
            tr = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Automatische Planung: bis 2 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS800" }),
                            ", 3\u20134 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS2000(800)" }),
                            ". Optional mitbestellen.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS600_MX1000_2-in-1.pdf?v=1742004341",
                            children: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS1600_MX2250_4-in-1.pdf?v=1742007720",
                            children: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                        }),
                    }),
                ],
            }),
            P = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Hier sehen Sie die St\xFCckliste (BOM) f\xFCr Ihr Set. Schienenverbinder werden je nach Reihen automatisch erg\xE4nzt.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/faq#einlegeschienen",
                            children: "Einlegeschienen & Verbinder",
                        }),
                    }),
                ],
            }),
            E = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Pr\xFCfen Sie Ihre Auswahl und legen Sie alles gesammelt in den Warenkorb. Preise sind nur f\xFCr eingeloggte Kund:innen sichtbar.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, { href: "https://wattstone.de/pages/kontakt", children: "Kontakt" }),
                    }),
                ],
            }),
            ee = () => {
                if (!(u && c))
                    return (0, s.jsx)("p", {
                        style: { fontSize: z.listFont },
                        children: "Bitte Ausrichtung und Anzahl w\xE4hlen.",
                    });
                let _ = r.find((V) => V.key === u);
                return (0, s.jsxs)("div", {
                    style: { width: "100%" },
                    children: [
                        (0, s.jsxs)("div", {
                            style: { marginBottom: 8 },
                            children: [
                                (0, s.jsx)("div", { style: { fontWeight: 700, marginBottom: 6 }, children: _.label }),
                                (0, s.jsx)("ul", {
                                    style: { fontSize: z.listFont, margin: 0, paddingLeft: 18 },
                                    children: (J || [])
                                        .filter((V) => V.key !== "verb_einlege")
                                        .map((V) =>
                                            (0, s.jsxs)(
                                                "li",
                                                { children: [V.title, " \u2014 ", V.qty * O, " St\xFCck"] },
                                                V.key
                                            )
                                        ),
                                }),
                            ],
                        }),
                        (0, s.jsxs)("ul", {
                            style: { fontSize: z.listFont, margin: 0, paddingLeft: 18 },
                            children: [
                                Q > 0 &&
                                    (0, s.jsxs)("li", {
                                        children: [
                                            "Schienenverbinder f\xFCr Einlegeschienen, schwarz \u2014 ",
                                            Q,
                                            " St\xFCck",
                                        ],
                                    }),
                                g === "with" &&
                                    (0, s.jsxs)("li", { children: [t.pvModule.title, " \u2014 ", c, " St\xFCck"] }),
                                v === "with" &&
                                    (b.n2000 > 0 || b.n800 > 0) &&
                                    (0, s.jsxs)(s.Fragment, {
                                        children: [
                                            b.n2000 > 0 &&
                                                (0, s.jsxs)("li", {
                                                    children: [t.inverter2000.title, " \u2014 ", b.n2000, " St\xFCck"],
                                                }),
                                            b.n800 > 0 &&
                                                (0, s.jsxs)("li", {
                                                    children: [t.inverter800.title, " \u2014 ", b.n800, " St\xFCck"],
                                                }),
                                        ],
                                    }),
                            ],
                        }),
                    ],
                });
            };
        return (0, s.jsx)("div", {
            style: {
                fontFamily: "Arial, sans-serif",
                width: "100%",
                maxWidth: 1200,
                margin: "0 auto",
                fontSize: z.bodyFont,
            },
            children: (0, s.jsxs)("div", {
                id: "canvas",
                style: {
                    width: "100%",
                    padding: 16,
                    boxSizing: "border-box",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#1b1b1b",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                },
                children: [
                    (0, s.jsx)("h1", {
                        style: { fontSize: z.h1Size, margin: "0 0 10px 0" },
                        children: "WandPV-Set \u2013 blitzschnell konfigurieren!",
                    }),
                    (0, s.jsxs)("div", {
                        style: { display: "flex", gap: z.gap, flexWrap: "wrap" },
                        children: [
                            (0, s.jsxs)("div", {
                                style: { flex: 2, display: "flex", flexDirection: "column" },
                                children: [
                                    (0, s.jsxs)("div", {
                                        style: { marginBottom: 12 },
                                        children: [
                                            (0, s.jsx)("h2", {
                                                style: { fontSize: z.sectionTitleSize, marginBottom: 6 },
                                                children: "Projektvorschau",
                                            }),
                                            (0, s.jsx)("img", {
                                                src: at(),
                                                alt: "Preview",
                                                style: {
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    objectFit: "contain",
                                                    borderRadius: 10,
                                                    display: "block",
                                                    marginBottom: 8,
                                                },
                                            }),
                                        ],
                                    }),
                                    (0, s.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minHeight: 0,
                                            overflowY: "auto",
                                            paddingRight: 6,
                                            position: "sticky",
                                            top: e + 8,
                                            zIndex: 0,
                                        },
                                        children:
                                            ut.length > 0 &&
                                            (0, s.jsx)(se, {
                                                title: "Set-Komponenten",
                                                info: P,
                                                showInfo: !1,
                                                children: (0, s.jsx)("div", {
                                                    style: { display: "flex", flexWrap: "wrap", gap: 6 },
                                                    children: ut.map((_, V) =>
                                                        (0, s.jsxs)(
                                                            "div",
                                                            {
                                                                style: { textAlign: "center" },
                                                                children: [
                                                                    (0, s.jsx)("img", {
                                                                        src: _.img,
                                                                        alt: _.title,
                                                                        style: {
                                                                            width: 64,
                                                                            height: 46,
                                                                            objectFit: "contain",
                                                                            margin: 2,
                                                                        },
                                                                    }),
                                                                    (0, s.jsxs)("p", {
                                                                        style: { fontSize: z.smallText, marginTop: 4 },
                                                                        children: [_.title, " (x ", _.qty, ")"],
                                                                    }),
                                                                ],
                                                            },
                                                            `${_.title}-${V}`
                                                        )
                                                    ),
                                                }),
                                            }),
                                    }),
                                ],
                            }),
                            (0, s.jsxs)("div", {
                                style: { flex: 3, minWidth: 260 },
                                children: [
                                    (0, s.jsx)(se, {
                                        title: "1. Ausrichtung w\xE4hlen",
                                        info: tn,
                                        children: r.map((_) =>
                                            (0, s.jsx)(
                                                T,
                                                {
                                                    label: _.label,
                                                    img: _.img,
                                                    selected: u === _.key,
                                                    onClick: () => a(_.key),
                                                },
                                                _.key
                                            )
                                        ),
                                    }),
                                    (0, s.jsx)(se, {
                                        title: "2. Anzahl der PV-Module",
                                        info: er,
                                        showInfo: !1,
                                        children: (0, s.jsxs)("select", {
                                            value: c ?? "",
                                            onChange: (_) => m(_.target.value ? Number(_.target.value) : null),
                                            disabled: !u,
                                            style: {
                                                padding: "8px 10px",
                                                fontSize: z.bodyFont,
                                                borderRadius: 10,
                                                border: "1px solid #ccc",
                                                color: "#1b1b1b",
                                                background: "#fff",
                                            },
                                            children: [
                                                (0, s.jsx)("option", { value: "", children: "Anzahl w\xE4hlen" }),
                                                I.map((_) => (0, s.jsx)("option", { value: _, children: _ }, _)),
                                            ],
                                        }),
                                    }),
                                    // (0, s.jsxs)(se, {
                                    //     // title: "3. Inkl. PV-Module (optional)",
                                    //     info: wt,
                                    //     children: [
                                    //         // (0, s.jsx)(T, {
                                    //         //     label: "ohne PV-Module",
                                    //         //     selected: g === "without",
                                    //         //     onClick: () => f("without"),
                                    //         //     disabled: !c,
                                    //         // }),
                                    //         (0, s.jsx)(T, {
                                    //             label: "mit PV-Modulen",
                                    //             selected: g === "with",
                                    //             onClick: () => f("with"),
                                    //             disabled: !c,
                                    //         }),
                                    //     ],
                                    // }),
                            //         (0, s.jsxs)(se, {
                            //             title: "4. Inkl. Mikrowechselrichter (optional)",
                            //             info: tr,
                            //             children: [
                            //                 (0, s.jsx)(T, {
                            //                     label: "ohne Mikrowechselrichter",
                            //                     selected: v === "without",
                            //                     onClick: () => k("without"),
                            //                     disabled: !c,
                            //                 }),
                            //                 (0, s.jsx)(T, {
                            //                     label: "mit Mikrowechselrichter",
                            //                     selected: v === "with",
                            //                     onClick: () => k("with"),
                            //                     disabled: !c,
                            //                 }),
                            //             ],
                            //         }),
                         ],
                    }),
                            (0, s.jsxs)("div", {
                                style: { flex: 2, minWidth: 260 },
                                children: [
                                    (0, s.jsxs)(se, {
                                        title: "Bestell\xFCbersicht",
                                        info: E,
                                        showInfo: !1,
                                        children: [
                                            (0, s.jsx)(ee, {}),
                                            R
                                                ? (0, s.jsxs)("h2", {
                                                      style: { marginTop: 8, fontSize: z.sectionTitleSize },
                                                      children: ["Gesamtpreis: \u20AC", He.toFixed(2)],
                                                  })
                                                : (0, s.jsx)("p", {
                                                      style: {
                                                          marginTop: 8,
                                                          fontSize: z.listFont,
                                                          fontStyle: "italic",
                                                      },
                                                      children:
                                                          "Preise werden nur f\xFCr eingeloggte Kund:innen angezeigt.",
                                                  }),
                                        ],
                                    }),
                                    R
                                        ? (0, s.jsxs)(s.Fragment, {
                                              children: [
                                                  (0, s.jsx)("button", {
                                                      onClick: async () => {
                                                          try {
                                                              if (!(u && c))
                                                                  return alert(
                                                                      "Bitte Ausrichtung und Anzahl der PV-Module w\xE4hlen."
                                                                  );
                                                              let _ = vt();
                                                              if (!_.length) return alert("Keine Artikel gefunden.");
                                                              await yt(_),
                                                                  alert("Artikel wurden dem Warenkorb hinzugef\xFCgt.");
                                                                                          window.location.href = '/cart';

                                                          } catch (_) {
                                                              console.error(_),
                                                                  alert("Fehler beim Hinzuf\xFCgen zum Warenkorb.");
                                                          }
                                                      },
                                                      disabled: !(u && c),
                                                      style: {
                                                          marginTop: 6,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "none",
                                                          background: u && c ? "#111" : "#ccc",
                                                          color: "#fff",
                                                          fontSize: 16,
                                                          fontWeight: "bold",
                                                          cursor: u && c ? "pointer" : "not-allowed",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb hinzuf\xFCgen",
                                                  }),
                                                  (0, s.jsx)("button", {
                                                      onClick: kn,
                                                      style: {
                                                          marginTop: 6,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "2px solid #ccc",
                                                          background: "#f7f7f7",
                                                          color: "#111",
                                                          fontSize: 16,
                                                          fontWeight: 600,
                                                          cursor: "pointer",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb",
                                                  }),
                                              ],
                                          })
                                        : (0, s.jsx)("button", {
                                              onClick: d,
                                              style: {
                                                  marginTop: 6,
                                                  padding: "12px 16px",
                                                  borderRadius: 12,
                                                  border: "none",
                                                  background: "#111",
                                                  color: "#fff",
                                                  fontSize: 16,
                                                  fontWeight: "bold",
                                                  cursor: "pointer",
                                                  display: "block",
                                                  width: "100%",
                                              },
                                              children: "Anmelden oder Konto erstellen, um in den Warenkorb zu legen",
                                          }),
                                    (0, s.jsx)("button", {
                                        onClick: Jn,
                                        style: {
                                            marginTop: 6,
                                            padding: "10px 16px",
                                            borderRadius: 12,
                                            border: "2px solid #ccc",
                                            background: "#FFE24D",
                                            color: "#111",
                                            fontSize: z.bodyFont,
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            display: "block",
                                            width: "100%",
                                        },
                                        children: "Zur\xFCcksetzen & neu konfigurieren!",
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        });
    }
    function _h({ stickyTop: e = 0 }) {
        let t = {
                mats: {
                    id: "1234567891",
                    title: "Bautenschutzmatten 12 mm",
                    price: 3.56,
                    img: "https://wattstone.de/cdn/shop/files/bautenschutzmatten-zubehoer-wattstone-02_1160x_crop_center.webp?v=1755050880",
                    variantId: 56002804285824,
                },
                aluMats: {
                    id: "9876543210",
                    title: "Alukaschierte Bautenschutzmatten 12 mm",
                    price: 3.56,
                    img: "https://wattstone.de/cdn/shop/files/alu-bautenschutzmatten-zubehoer-wattstone-01_1160x_crop_center.webp?v=1731597701",
                    variantId: 56002768109952,
                },
                endClamp: {
                    id: "1234567892",
                    title: "Modulendklemme f\xFCr Rahmenh\xF6he 30 mm mit Torx-Schrauben",
                    price: 7.13,
                    img: "https://wattstone.de/cdn/shop/files/klemme8_1160x_crop_center.webp?v=1755050880",
                    variantId: 55985487577472,
                },
                middleClamp: {
                    id: "1234567893",
                    title: "Modulmittelklemme mit Erdungsdorn f\xFCr Rahmenh\xF6he 30 mm mit Torx-Schrauben",
                    price: 23.79,
                    img: "https://wattstone.de/cdn/shop/files/klemme9_1160x_crop_center.webp?v=1753672912",
                    variantId: 55865876578688,
                },
                verbindungsSet: {
                    id: "1234567894",
                    title: "Ost-West Verbindungsset V2",
                    price: 11.78,
                    img: "https://wattstone.de/cdn/shop/files/cable_clips-3_1160x_crop_center.png?v=1755050880",
                    variantId: 55788568215936,
                },
                verbindungsSetV1Anth: {
                    id: "ow-v1-anth",
                    title: "Ost-West-Verbindungsset V1 f\xFCr Wattstone 10\xB0 V1 (Anthrazit)",
                    price: 53.55,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/V1_verb.png?v=1755744159",
                    variantId: 55721387557248,
                },
                verbindungsSetV1Grau: {
                    id: "ow-v1-grau",
                    title: "Ost-West-Verbindungsset V1 f\xFCr Wattstone 10\xB0 V1 (Grau)",
                    price: 3.56,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/V1_verb-2.png?v=1755744158",
                    variantId: 55607514300800,
                },
                zubehorSet: {
                    id: "1234567895",
                    title: "Wattstone Zubeh\xF6r-Set",
                    price: 70.21,
                    img: "https://wattstone.de/cdn/shop/files/cable_clips-2_1160x_crop_center.png?v=1745485575",
                    variantId: 54067354698052,
                },
                windleitblech3: {
                    id: "1234567896",
                    title: "Windleitblech aus Magnelis\xAE Stahl korrosionsbest\xE4ndig, 3kg",
                    price: 39.27,
                    img: "https://wattstone.de/cdn/shop/files/windleitblech-fuer-wattstone-15-grad_1160x_crop_center.webp?v=1748607083",
                    variantId: 53940266795332,
                },
                windleitblech5: {
                    id: "1234567897",
                    title: "Windleitblech aus Magnelis\xAE Stahl korrosionsbest\xE4ndig, 5kg",
                    price: 1.89,
                    img: "https://wattstone.de/cdn/shop/files/wattstone-15-grad-windleitblech-03_1160x_crop_center.webp?v=1748607083",
                    variantId: 53938705367364,
                },
                easyLift: {
                    id: "1234567898",
                    title: "Easy-Lift-Set",
                    price: 2.84,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/easylift-2.png?v=1755498723",
                    variantId: 53938675777860,
                },
                inverter800: {
                    id: "1234567899",
                    title: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                    price: 51.17,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW.png?v=1755742176",
                    variantId: 53927276773700,
                },
                inverter2000: {
                    id: "1234567900",
                    title: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                    price: 12.50,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW_4.png?v=1755742176",
                    variantId: 53943368909124,
                },
                pvModule: {
                    id: "1234567901",
                    title: "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon Solarmodule 1762x1134x30 mm",
                    price: 82.11,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/trina_tsm_neg9r_28_alternergyw_1_1_1_1160x_crop_center_jpg.webp?v=1756034883",
                    variantId: 53940269580612,
                },
                aikoModule: {
                    id: "aiko465",
                    title: "465W Aiko A-MAH54Db Doppelglas Full Black Neostar 2S+ 1757\xD71134\xD730 mm",
                    price: 71.40,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/aiko_1160x_crop_center_png.webp?v=1756034882",
                    variantId: 53940270137668,
                },
                extensionPlate: {
                    id: "extensionPlate",
                    title: "Extension Plate aus Magnelis\xAE Stahl korrosionsbest\xE4ndig",
                    price: 65.45,
                    img: "https://wattstone.de/cdn/shop/files/extensionplatefront_1160x_crop_center.webp?v=1750469884",
                    variantId: 53940264960324,
                },
            },
            n = [
                {
                    name: "Wattstone 0\xB0",
                    price: 67.83,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0g.png?v=1755498029",
                            variantId: 53939109953860,
                        },
                        naturgrau: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0g-3.png?v=1755656348",
                            variantId: 53939109953860,
                        },
                    },
                },
                {
                    name: "Wattstone 6\xB0",
                    price: 58.31,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6g.png?v=1755498029",
                            variantId: 53927609041220,
                        },
                        naturgrau: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6g-2.png?v=1755656347",
                            variantId: 53927609041220,
                        },
                    },
                },
                {
                    name: "Wattstone 10\xB0 V1",
                    price: 71.40,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10gV1.png?v=1755498030",
                            variantId: 53940270137668,
                        },
                        naturgrau: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10gV1-2.png?v=1755656348",
                            variantId: 53940270137668,
                        },
                    },
                },
                {
                    name: "Wattstone 10\xB0 V2",
                    price: 71.40,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10gV2.png?v=1755498029",
                            variantId: 53940270137668,
                        },
                        naturgrau: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10gV2-2.png?v=1755656348",
                            variantId: 53940270137668,
                        },
                    },
                },
                {
                    name: "Wattstone 10\xB0 XL",
                    price: 11.78,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10gXL.png?v=1755498030",
                            variantId: 55788568215936,
                        },
                    },
                },
                {
                    name: "Wattstone 15\xB0",
                    price: 53.55,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15g.png?v=1755498030",
                            variantId: 55721387557248,
                        },
                        naturgrau: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15g-2.png?v=1755656347",
                            variantId: 55721387557248,
                        },
                    },
                },
                {
                    name: "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)",
                    price: 67.83,
                    colors: {
                        anthrazit: {
                            img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10g_V2_XL.png?v=1755656347",
                            variantId: 53939109953860,
                        },
                    },
                },
            ],
            r = [
                {
                    name: "S\xFCd",
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15_pair_with_winddeflector_1.png?v=1755479864",
                },
                {
                    name: "Ost-West",
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/wattstone_15_east-west_pair_connected-1.png?v=1755479863",
                },
            ],
            i = {
                "Wattstone 0\xB0": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0-s-1.png?v=1755693941",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0-ow-2.png?v=1755693934",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0-ow-2.png?v=1755693934",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0-ow-2.png?v=1755693934",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/0-ow-2.png?v=1755693934",
                    },
                },
                "Wattstone 6\xB0": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-s-2.png?v=1755693943",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-s-2.png?v=1755693943",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-s-4.png?v=1755693943",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-s-4.png?v=1755693943",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-ow-4.png?v=1755693942",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/6-ow-4.png?v=1755693942",
                    },
                },
                "Wattstone 10\xB0 V1": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1.png?v=1755693944",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-2.png?v=1755693943",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-3.png?v=1755693943",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-3.png?v=1755693943",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1.png?v=1755693944",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-ow-2.png?v=1755693943",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-ow-4.png?v=1755693944",
                    },
                },
                "Wattstone 10\xB0 V2": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-1.png?v=1755693944",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-2.png?v=1755693943",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-3.png?v=1755693943",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v1-s-3.png?v=1755693943",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v2-os-2.png?v=1755693941",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10v2-os-4.png?v=1755693940",
                    },
                },
                "Wattstone 10\xB0 XL": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-s-1.png?v=1755694782",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-s-2.png?v=1755694782",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-s-2.png?v=1755694782",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-s-2.png?v=1755694782",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-ow-2.png?v=1755694786",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/10xl-ow-4.png?v=1755694779",
                    },
                },
                "Wattstone 15\xB0": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-s-1.png?v=1755693940",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-s-2.png?v=1755693942",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-s-3.png?v=1755693943",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-s-3.png?v=1755693943",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_15_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-ow-2.png?v=1755693944",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_15_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/15-ow-4.png?v=1755693943",
                    },
                },
                "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)": {
                    Süd: {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/segel-s-2.png?v=1755693944",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/segel-s-2.png?v=1755693944",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_south_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/segel-s-2.png?v=1755693944",
                    },
                    "Ost-West": {
                        1: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_1.png?v=1",
                        2: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/segel-ow-4.png?v=1755693945",
                        3: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/preview_v2_ow_3.png?v=1",
                        4: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/segel-ow-4.png?v=1755693945",
                    },
                },
            },
            l = "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Bitumen_4pannel_Black_7.png?v=1755051337",
            [o, u] = (0, N.useState)(""),
            [a, c] = (0, N.useState)("anthrazit"),
            [m, g] = (0, N.useState)(""),
            [f, v] = (0, N.useState)(null),
            [k, x] = (0, N.useState)(""),
            [R, h] = (0, N.useState)("without"),
            [d, p] = (0, N.useState)("without"),
            [y, z] = (0, N.useState)("without"),
            [C, I] = (0, N.useState)("trina"),
            [T, O] = (0, N.useState)("vertical"),
            [D, J] = (0, N.useState)("without"),
            st = () => {
                try {
                    if (typeof window < "u") {
                        if (typeof window.__CUSTOMER_LOGGED_IN__ < "u") return !!window.__CUSTOMER_LOGGED_IN__;
                        let w = document.querySelector('meta[name="customer-logged-in"]');
                        if (w) return w.content === "true";
                        let L = document.querySelector("[data-customer-logged-in]");
                        if (L) return L.getAttribute("data-customer-logged-in") === "true";
                    }
                } catch {}
                return !1;
            },
            [Jt, Xn] = (0, N.useState)(st());
        (0, N.useEffect)(() => {
            Xn(st());
        }, []);
        let Yn = () => {
                let w = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
                window.location.href = `/account?return_url=${w}`;
            },
            [Q, en] = (0, N.useState)(!1);
        (0, N.useEffect)(() => {
            let w = () => en(window.innerWidth <= 768);
            return w(), window.addEventListener("resize", w), () => window.removeEventListener("resize", w);
        }, []);
        let b = (0, N.useMemo)(
                () => ({
                    gap: Q ? 10 : 16,
                    sectionPadding: Q ? 10 : 14,
                    sectionTitleSize: Q ? 14 : 16,
                    h1Size: Q ? 20 : 22,
                    bodyFont: Q ? 13 : 14,
                    smallText: Q ? 11 : 12,
                    buttonPadding: Q ? "8px 10px" : "10px 12px",
                    buttonFont: Q ? 13 : 14,
                    cardMinH: Q ? "78px" : "88px",
                    listFont: Q ? 13 : 14,
                    gridColsModelsMobile: 2,
                }),
                [Q]
            ),
            Z = ["Wattstone 6\xB0", "Wattstone 10\xB0 V1", "Wattstone 10\xB0 V2"].includes(o),
            He = [
                "Wattstone 10\xB0 XL",
                "Wattstone 15\xB0",
                "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)",
            ].includes(o),
            _e = !(
                ["Wattstone 10\xB0 V2", "Wattstone 10\xB0 XL", "Wattstone 15\xB0"].includes(o) &&
                m === "S\xFCd" &&
                f
            );
        (0, N.useEffect)(() => {
            _e && D !== "without" && J("without");
        }, [_e, D]);
        let vt = (w) => n.find((L) => L.name === w),
            yt = (w, L = a) => {
                var A, B;
                return ((B = (A = vt(w)) == null ? void 0 : A.colors) == null ? void 0 : B[L]) || null;
            },
            Nt = (w, L = a) => {
                var A;
                return (A = yt(w, L)) == null ? void 0 : A.img;
            },
            kn = (w, L) => {
                let A = i[w];
                if (A) {
                    let B = L || "S\xFCd",
                        te = [B, B === "S\xFCd" ? "Ost-West" : "S\xFCd"];
                    for (let ye of te) {
                        let qe = A[ye];
                        if (qe) {
                            let U = Object.keys(qe)
                                .map(Number)
                                .sort((ne, Zr) => ne - Zr);
                            if (U.length) return qe[U[0]];
                        }
                    }
                }
                return Nt(w) || l;
            },
            Jn = n.filter((w) =>
                a === "naturgrau"
                    ? !["Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)", "Wattstone 10\xB0 XL"].includes(w.name)
                    : !0
            );
        (0, N.useEffect)(() => {
            a === "naturgrau" &&
                (o === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)" || o === "Wattstone 10\xB0 XL") &&
                u("");
        }, [a, o]),
            (0, N.useEffect)(() => {
                o !== "Wattstone 0\xB0" && o !== "Wattstone 6\xB0" && O("vertical");
            }, [o]);
        let at = (w, L, A = 1) => {
                let B = [];
                for (let te = w; te <= L; te += A) B.push(te);
                return B;
            },
            tn = (w, L, A) =>
                !w || !L
                    ? []
                    : w === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)" ||
                        ((w === "Wattstone 0\xB0" || w === "Wattstone 6\xB0") && A === "horizontal")
                      ? L === "S\xFCd"
                          ? at(2, 100, 2)
                          : at(4, 100, 4)
                      : L === "S\xFCd"
                        ? at(1, 100, 1)
                        : at(2, 100, 2),
            er = tn(o, m, T);
        (0, N.useEffect)(() => {
            f && !er.includes(f) && v(null);
        }, [o, m, T]);
        let wt = !o || m !== "S\xFCd" || o === "Wattstone 0\xB0" || (o === "Wattstone 6\xB0" && T !== "horizontal");
        (0, N.useEffect)(() => {
            wt && R !== "without" && h("without");
        }, [wt, R]);
        let tr = (w) => {
                if (!w || w <= 0) return { n2000: 0, n800: 0 };
                let L = Math.floor(w / 4),
                    A = w % 4;
                return A === 0 ? { n2000: L, n800: 0 } : A <= 2 ? { n2000: L, n800: 1 } : { n2000: L + 1, n800: 0 };
            },
            P = (w, L, A, B) =>
                !w || !L || !B
                    ? 0
                    : w === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)" ||
                        ((w === "Wattstone 0\xB0" || w === "Wattstone 6\xB0") && A === "horizontal")
                      ? Math.floor(B / 2) + (L === "S\xFCd" ? 1 : 2)
                      : L === "S\xFCd"
                        ? B + 1
                        : B + 2,
            E = [],
            ee = !1;
        if (o && m && f) {
            let w = P(o, m, T, f);
            if (o === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)") {
                let U = yt("Wattstone 10\xB0 V2"),
                    ne = yt("Wattstone 10\xB0 XL");
                E.push({
                    id: "Wattstone 10\xB0 V2",
                    title: "Wattstone 10\xB0 V2",
                    price: vt("Wattstone 10\xB0 V2").price,
                    qty: w,
                    img: U?.img,
                    variantId: U?.variantId,
                }),
                    E.push({
                        id: "Wattstone 10\xB0 XL",
                        title: "Wattstone 10\xB0 XL",
                        price: vt("Wattstone 10\xB0 XL").price,
                        qty: w,
                        img: ne?.img,
                        variantId: ne?.variantId,
                    });
            } else {
                let U = vt(o),
                    ne = yt(o);
                E.push({ id: o, title: U.name, price: U.price, qty: w, img: ne?.img, variantId: ne?.variantId });
            }
            k === "flachdach" && f > 0
                ? E.push({ ...t.mats, qty: w * 2 })
                : k === "foliendach" && f > 0 && E.push({ ...t.aluMats, qty: w * 2 });
            let L = o === "Wattstone 0\xB0" || o === "Wattstone 6\xB0",
                A = o === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)",
                B = T === "horizontal";
            if (
                (A
                    ? m === "S\xFCd"
                        ? (E.push({ ...t.endClamp, qty: 8 }), f > 2 && E.push({ ...t.middleClamp, qty: (f - 2) * 2 }))
                        : (E.push({ ...t.endClamp, qty: 16 }), f > 4 && E.push({ ...t.middleClamp, qty: (f - 4) * 2 }))
                    : L && B
                      ? m === "S\xFCd"
                          ? (E.push({ ...t.endClamp, qty: 8 }), f > 2 && E.push({ ...t.middleClamp, qty: (f - 2) * 2 }))
                          : (E.push({ ...t.endClamp, qty: 16 }),
                            f > 4 && E.push({ ...t.middleClamp, qty: (f - 4) * 2 }))
                      : m === "S\xFCd"
                        ? (E.push({ ...t.endClamp, qty: 4 }), f > 1 && E.push({ ...t.middleClamp, qty: (f - 1) * 2 }))
                        : (E.push({ ...t.endClamp, qty: 8 }), f > 2 && E.push({ ...t.middleClamp, qty: (f - 2) * 2 })),
                m === "Ost-West" &&
                    [
                        "Wattstone 10\xB0 V2",
                        "Wattstone 10\xB0 XL",
                        "Wattstone 15\xB0",
                        "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)",
                    ].includes(o))
            ) {
                let U = Math.floor(w / 2),
                    ne = o === "Wattstone 10\xB0 V2 + Wattstone 10\xB0 XL (Segel)" ? Math.floor(f / 2) + 2 : 0;
                E.push({ ...t.verbindungsSet, qty: U + ne }), (ee = !0);
            }
            if (o === "Wattstone 10\xB0 V1" && m === "Ost-West") {
                let U = Math.floor(w / 2),
                    ne = a === "naturgrau" ? t.verbindungsSetV1Grau : t.verbindungsSetV1Anth;
                E.push({ ...ne, qty: U });
            }
            if (!wt && R === "with")
                if (A && m === "S\xFCd") {
                    let U = Math.floor(f / 2);
                    U > 0 && (E.push({ ...t.windleitblech5, qty: U }), E.push({ ...t.zubehorSet, qty: U }));
                } else if (o === "Wattstone 6\xB0" && m === "S\xFCd" && B) {
                    let U = Math.floor(f / 2);
                    U > 0 && (E.push({ ...t.windleitblech3, qty: U }), E.push({ ...t.zubehorSet, qty: U }));
                } else
                    Z
                        ? (E.push({ ...t.windleitblech3, qty: f }), E.push({ ...t.zubehorSet, qty: f }))
                        : He && (E.push({ ...t.windleitblech5, qty: f }), E.push({ ...t.zubehorSet, qty: f }));
            if (
                (!_e && D === "with" && E.push({ ...t.extensionPlate, qty: f * 2 }),
                E.push({ ...t.easyLift, qty: 1 }),
                d === "with")
            ) {
                let U = C === "aiko" ? t.aikoModule : t.pvModule;
                E.push({ ...U, qty: f });
            }
            let { n2000: te, n800: ye } = tr(f),
                qe = te + ye;
            y === "with" &&
                (te > 0 && E.push({ ...t.inverter2000, qty: te }), ye > 0 && E.push({ ...t.inverter800, qty: ye })),
                !ee && qe > 0 && E.push({ ...t.zubehorSet, qty: qe });
        }
        let X = E.reduce((w, L) => w + L.price * L.qty, 0);
        function fe(w) {
            var A, B;
            let L = new Map();
            for (let te of w) {
                let ye = Number(te.id),
                    qe = Number((B = (A = te.quantity) != null ? A : te.qty) != null ? B : 0);
                !ye || qe <= 0 || L.set(ye, (L.get(ye) || 0) + qe);
            }
            return Array.from(L.entries()).map(([te, ye]) => ({ id: te, quantity: ye }));
        }
        let _ = () => {
            var L, A;
            if (!(o && a && m && f && k)) return [];
            let w = [];
            for (let B of E) {
                let te =
                        (A = B.variantId) != null
                            ? A
                            : typeof B.id == "string"
                              ? (L = t[B.id]) == null
                                  ? void 0
                                  : L.variantId
                              : Number(B.id),
                    ye = Number(B.qty || 0);
                te && ye > 0 && w.push({ id: Number(te), quantity: ye });
            }
            return fe(w);
        };
        async function V(w) {
            if (!w || w.length === 0) throw new Error("No items to add");
            let L = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: w }),
                credentials: "same-origin",
            });
            if (!L.ok) {
                let A = await L.text();
                throw new Error(A || "Shopify cart add failed");
            }
            return L.json();
        }
        let ce = async () => {
                try {
                    if (!Jt) {
                        alert("Bitte anmelden oder ein Konto erstellen, um in den Warenkorb zu legen.");
                        return;
                    }
                    if (!(o && a && m && f && k))
                        return alert("Bitte Modell, Farbe, Ausrichtung, Anzahl PV-Module und Oberfl\xE4che w\xE4hlen.");
                    let w = _();
                    if (!w.length) return alert("Keine Artikel gefunden.");
                    await V(w), alert("Artikel wurden dem Warenkorb hinzugef\xFCgt.");
                        window.location.href = '/cart';

                } catch (w) {
                    console.error("Add to cart error", w),
                        alert("Fehler beim Hinzuf\xFCgen zum Warenkorb. Siehe Konsole.");
                }
            },
            ue = () => {
                window.location.href = "/cart";
            },
            xe = () => {
                u(""),
                    c("anthrazit"),
                    g(""),
                    O("vertical"),
                    v(null),
                    x(""),
                    h("without"),
                    p("without"),
                    z("without"),
                    I("trina"),
                    J("without");
            },
            ct = () => {
                var qe, U;
                if (!o) return l;
                if (!m) return kn(o);
                if (!f) {
                    let ne = tn(o, m, T),
                        Zr = ne?.[0];
                    if (Zr) {
                        let js = (U = (qe = i[o]) == null ? void 0 : qe[m]) == null ? void 0 : U[Zr];
                        if (js) return js;
                    }
                    return kn(o, m);
                }
                let w = Math.max(1, Math.min(4, Number(f))),
                    L = i[o],
                    A = L?.[m],
                    B = A?.[w];
                if (B) return B;
                let te = A?.[4];
                return te || Nt(o) || l;
            },
            me = ({ label: w, img: L, selected: A, disabled: B, onClick: te }) =>
                (0, s.jsxs)("button", {
                    onClick: te,
                    disabled: B,
                    style: {
                        margin: Q ? 6 : 8,
                        padding: b.buttonPadding,
                        fontSize: b.buttonFont,
                        borderRadius: 10,
                        cursor: B ? "not-allowed" : "pointer",
                        backgroundColor: B ? "#ddd" : A ? "#FFE24D" : "#f9f9f9",
                        color: B ? "#888" : "#1b1b1b",
                        border: A ? "2px solid #FFE24D" : "1px solid #ccc",
                        minWidth: Q ? "100px" : "120px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        lineHeight: 1.2,
                    },
                    title: typeof w == "string" ? w : void 0,
                    children: [
                        L &&
                            (0, s.jsx)("img", {
                                src: L,
                                alt: typeof w == "string" ? w : "option",
                                style: { width: "76px", height: "54px", objectFit: "contain", marginBottom: 6 },
                            }),
                        w,
                    ],
                }),
            Td = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Wattstone ist eine flachdachfreundliche PV-Aufst\xE4nderung, die Unterkonstruktion und Ballast in einem L-Stein vereint\u2014windkanalgepr\xFCft nach DIN-EN 1991-1-4:2021. In 0\xB0, 6\xB0, 10\xB0 oder 15\xB0 und aus C55/67-Hochleistungsbeton mit Doppelbewehrung gefertigt, montierbar auf Bitumen, PVC, EPDM, Beton, Kies & Gr\xFCnd\xE4chern\u2014ohne Dachhaut-Durchdringung. Die modulare, skalierbare Bauweise l\xE4sst sich nahtlos von kleinen Anlagen bis hin zu gro\xDFfl\xE4chigen Projekten erweitern.",
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS0_a843175a-0049-43cd-ba54-f58a5f46c08d.pdf?v=1741690253",
                            children: "Wattstone 0\xB0 Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS6_21.04.25.pdf?v=1745218350",
                            children: "Wattstone 6\xB0 Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS10_d91cf44c-974f-41ec-8876-2661f04d89a2.pdf?v=1741690255",
                            children: "Wattstone 10\xB0V1 Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS10V2_8964ffc4-9398-4479-ab4a-5d4514f5f95b.pdf?v=1741690255",
                            children: "Wattstone 10\xB0V2 Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS10XL_0db0fbdd-2ca7-4fee-942f-f9d0aed090e6.pdf?v=1741690257",
                            children: "Wattstone 10\xB0XL Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/WS15_67a52bc5-f706-455b-ba5a-46648bbfb2d7.pdf?v=1741690256",
                            children: "Wattstone 15\xB0 Datenblatt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Windkanal_Zertifikat.pdf?v=1744946584",
                            children: "Windkanal Zertifikat nach DIN-EN 1991-1-4:2021",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/unsere-projekte",
                            children: "Wattstone Projektportfolio",
                        }),
                    }),
                ],
            }),
            Id = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "W\xE4hle S\xFCd f\xFCr den h\xF6chsten Jahresertrag oder Ost\u2013West f\xFCr eine gleichm\xE4\xDFigere Tageskurve und eine h\xF6here Eigenverbrauchsquote. Was die Ausrichtung in der Praxis bedeutet:",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "S\xFCd-Ausrichtung:" }),
                            " Alle Modulreihen zeigen mit der aktiven Seite nach S\xFCden. Die Reihen verlaufen typischerweise Ost\u2013West, die Module sind einseitig geneigt (z. B. 6\u201315\xB0), und der Reihenabstand wird zur Vermeidung von Verschattung eingeplant.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Ost\u2013West-Ausrichtung:" }),
                            " Die Module werden r\xFCcken-an-r\xFCcken montiert \u2013 eine Seite zeigt nach Osten, die andere nach Westen (eine Doppelreihe pro \u201ESpur\u201C). Meist mit kompakterem Layout und geringerem Reihenabstandf\xFCr eine gleichm\xE4\xDFigere Erzeugung \xFCber den Tag.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Sud-Verbindungsset.pdf?v=1745289355",
                            children: "Wattstone S\xFCd-Verbindungsset",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Ost-West-Verbindungsset_V2-2.pdf?v=1755155647",
                            children: "Ost-West-Verbindungsset V2 f\xFCr WS 10\xB0V2, 10\xB0XL & 15\xB0",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Ost-West-Verbinder_WS10.pdf?v=1741694130",
                            children: "Ost-West-Verbindungsset V1 f\xFCr WS 10\xB0V1",
                        }),
                    }),
                ],
            }),
            Nd = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Alle Wattstone Bl\xF6cke verf\xFCgen \xFCber integrierte Gewindeh\xFClsen, die eine sichere, direkte Modulmontage erm\xF6glichen \u2013 ganz ohne Zusatzschienen. Die Module werden mit End- und Mittelklemmen (Edelstahl) am Block befestigt; die Schrauben greifen direkt in die H\xFClsen. So entsteht eine stabile, korrosionsbest\xE4ndige Verbindung mit definiertem Klemmdruck. Kompatibel mit g\xE4ngigen Rahmenh\xF6hen (z. B. 30\u201335 mm), in Portrait oder Landscape, bei 0\xB0, 6\xB0, 10\xB0 oder 15\xB0 Neigung.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Modulklemmen.pdf?v=1745289354",
                            children: "Wattstone Modulendklemmen f\xFCr RH 30mm mit Torx-Schrauben",
                        }),
                    }),
                ],
            }),
            Ld = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Bautenschutzmatten fungieren als sch\xFCtzende Unterlage unter jedem Wattstone-Block \u2013 sie verteilen Lasten, erh\xF6hen die Rutschfestigkeit und sch\xFCtzen empfindliche Dachabdichtungen (z. B. Bitumen, PVC, EPDM) vor Druckstellen und Besch\xE4digungen. Zudem gelten sie als anerkannte Schutzlage nach DIN 18195, Teil 10.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Bautenschutzmatte (12 mm):" }),
                            " Allround-Pads f\xFCr Flachd\xE4cher: verteilen Kr\xE4fte gleichm\xE4\xDFig und helfen, Oberfl\xE4chensch\xE4den zu vermeiden; empfohlen unter allen Wattstone-Produkten.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Alukaschierte Bautenschutzmatte (12 mm):" }),
                            " Wie die Standardmatte, zus\xE4tzlich mit Aluminium-Kaschierung \u2013 ideal auf EPDM-D\xE4chern, um unerw\xFCnschte Wechselwirkungen (z. B. durch Weichmacher) zu vermeiden; bietet die gleiche Lastverteilungs- und Schutzwirkung.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Kurzempfehlung:" }),
                            " Standardmatte f\xFCr Bitumen/PVC/Beton; alukaschierte Matte auf EPDM-Bahnen f\xFCr langfristige Materialvertr\xE4glichkeit.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Bautenschutzmatten_12_WS.pdf?v=1741694129",
                            children: "Bautenschutzmatte (12 mm)",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Alukaschierte_Bautenschutzmatten_12_WS.pdf?v=1741694129",
                            children: "Alukaschierte Bautenschutzmatte (12 mm)",
                        }),
                    }),
                ],
            }),
            Wd = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Das Windleitblech dient dazu, den Wind um die PV-Module herumzuleiten. Dies reduziert die Windlast auf die Module und die gesamte Konstruktion, was besonders bei starken Sturmb\xF6en und Orkanen von Vorteil ist. Durch diese Ma\xDFnahme wird das Risiko von Sch\xE4den durch hohe Windgeschwindigkeiten erheblich verringert und die Stabilit\xE4t Ihrer Anlage erh\xF6ht. Vorteile des Windleitblechs:",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Verbesserte Sicherheit:" }),
                            " Schutz vor Windsch\xE4den durch effektive Windableitung.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Erh\xF6hte Stabilit\xE4t:" }),
                            " Reduzierung der Windlast auf die PV-Module und die Unterkonstruktion.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Langlebigkeit:" }),
                            " L\xE4ngerer Erhalt der Strukturintegrit\xE4t Ihrer PV-Anlage auch unter extremen Wetterbedingungen.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Windleitblech_aus_Magnelis_Stahl_ca._5_kg_V3_-_20.06.25.pdf?v=1750471628",
                            children: "Technische Zeichnung Windleitblech f\xFCr WS 10\xB0XL & 15\xB0",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Windleitblech_aus_Magnelis_Stahl_ca._3_kg_V3_-_20.06.25.pdf?v=1750471628",
                            children:
                                "Technische Zeichnung Windleitblech f\xFCr WS 6\xB0 horizontal, 10\xB0(V1 & V2) & 15\xB0",
                        }),
                    }),
                ],
            }),
            Vd = (0, s.jsx)("div", {
                children: (0, s.jsx)("p", {
                    children:
                        "Wattstone Extension Plate 210x50x3mm aus Magnelis Stahl korrosionsbest\xE4ndig - Adapterplatte zur flexiblen Anbringung von PV-Module an der langen Modulseite. Insbesondere f\xFCr l\xE4ngere PV-Module +1800mm geeignet. Fixierung durch Schraubverbindung auf Wattstone zum Klemmen von PV-Modulen mit Modulendklemmen.",
                }),
            }),
            Rd = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "F\xFCgen Sie optional PV-Module hinzu (Trina 460 W oder Aiko 465 W). Die Menge folgt Ihrer Modulanzahl.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/22-Vertex_S_plus_NEG9R.28_240411_Datasheet_Vertex_S__NEG9R.28_DE_2024_A_S1_web.pdf?v=1742091602",
                            children:
                                "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon Solarmodule 1762x1134x30 mm",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Neostar-2S_Plus_188-AIKO-A-MAH54Db-440-470W_1757x1134x30mm_DS_DE_2405_V1_5-Kopie.pdf?v=1749610088",
                            children:
                                "465W Aiko A-MAH54Db-Doppelglas Full Black Neostar 2S+ 1757x1134x30 mm Solarpanel Solarmodul Photovoltaik",
                        }),
                    }),
                ],
            }),
            Dd = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Automatische Planung: bis 2 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS800" }),
                            ", 3\u20134 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS2000(800)" }),
                            ". Optional mitbestellen.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS600_MX1000_2-in-1.pdf?v=1742004341",
                            children: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS1600_MX2250_4-in-1.pdf?v=1742007720",
                            children: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                        }),
                    }),
                ],
            }),
            Od = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Alle aktuell berechneten Komponenten Ihres Sets, inkl. Klemmen, Verbindern, Unterlagen und Zubeh\xF6r.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/faq#komponenten",
                            children: "Komponenten-Details",
                        }),
                    }),
                ],
            }),
            Ad = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "\xDCberpr\xFCfen Sie Ihre Auswahl. Mit einem Klick legen Sie ",
                            (0, s.jsx)("strong", { children: "alles" }),
                            " in den Warenkorb. Preise nur sichtbar, wenn Sie eingeloggt sind.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/kontakt",
                            children: "Hilfe & Kontakt",
                        }),
                    }),
                ],
            });
        return (0, s.jsx)("div", {
            style: {
                fontFamily: "Arial, sans-serif",
                width: "100%",
                maxWidth: 1200,
                margin: "0 auto",
                fontSize: b.bodyFont,
            },
            children: (0, s.jsxs)("div", {
                id: "canvas",
                style: {
                    width: "100%",
                    padding: 16,
                    boxSizing: "border-box",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#1b1b1b",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                },
                children: [
                    (0, s.jsx)("h1", {
                        style: { fontSize: b.h1Size, margin: "0 0 10px 0" },
                        children: "Wattstone-Set \u2013 blitzschnell konfigurieren!",
                    }),
                    (0, s.jsxs)("div", {
                        style: { display: "flex", gap: b.gap, flexWrap: "wrap" },
                        children: [
                            (0, s.jsxs)("div", {
                                style: { flex: 2, display: "flex", flexDirection: "column" },
                                children: [
                                    (0, s.jsxs)("div", {
                                        style: { marginBottom: 12 },
                                        children: [
                                            (0, s.jsx)("h2", {
                                                style: { fontSize: b.sectionTitleSize, marginBottom: 6 },
                                                children: "Projektvorschau",
                                            }),
                                            (0, s.jsx)("img", {
                                                src: ct(),
                                                alt: "Preview",
                                                style: {
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    objectFit: "contain",
                                                    borderRadius: 10,
                                                    display: "block",
                                                    marginBottom: 8,
                                                },
                                            }),
                                            (0, s.jsx)("img", {
                                                src: o ? Nt(o) : Nt("Wattstone 15\xB0") || l,
                                                alt: "Ausgew\xE4hltes Modell",
                                                style: {
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    objectFit: "contain",
                                                    borderRadius: 10,
                                                },
                                            }),
                                        ],
                                    }),
                                    (0, s.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minHeight: 0,
                                            overflowY: "auto",
                                            paddingRight: 6,
                                            position: "sticky",
                                            top: e + 8,
                                            zIndex: 0,
                                        },
                                        children:
                                            E.length > 0 &&
                                            (0, s.jsx)(se, {
                                                title: "Set-Komponenten",
                                                info: Od,
                                                showInfo: !1,
                                                children: (0, s.jsx)("div", {
                                                    style: { display: "flex", flexWrap: "wrap", gap: 6 },
                                                    children: E.map((w, L) => {
                                                        var A;
                                                        return (0, s.jsxs)(
                                                            "div",
                                                            {
                                                                style: { textAlign: "center" },
                                                                children: [
                                                                    (0, s.jsx)("img", {
                                                                        src: w.img,
                                                                        alt: w.title,
                                                                        style: {
                                                                            width: 64,
                                                                            height: 46,
                                                                            objectFit: "contain",
                                                                            margin: 2,
                                                                        },
                                                                    }),
                                                                    (0, s.jsxs)("p", {
                                                                        style: { fontSize: b.smallText, marginTop: 4 },
                                                                        children: [
                                                                            w.title,
                                                                            " ( x ",
                                                                            (A = w?.qty) != null ? A : 0,
                                                                            " )",
                                                                        ],
                                                                    }),
                                                                ],
                                                            },
                                                            L
                                                        );
                                                    }),
                                                }),
                                            }),
                                    }),
                                ],
                            }),
                            (0, s.jsxs)("div", {
                                style: { flex: 3, minWidth: 260 },
                                children: [
                                    (0, s.jsx)(se, {
                                        title: "1. Wattstone-Modell",
                                        info: Td,
                                        children: (0, s.jsxs)("div", {
                                            style: { width: "100%", marginTop: 4, marginBottom: 6 },
                                            children: [
                                                (0, s.jsx)("div", {
                                                    style: { fontWeight: 600, marginBottom: 6, fontSize: b.bodyFont },
                                                    children: "Farbe ausw\xE4hlen",
                                                }),
                                                (0, s.jsxs)("div", {
                                                    style: { display: "flex", gap: 18, marginBottom: 8 },
                                                    children: [
                                                        (0, s.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                            },
                                                            children: [
                                                                (0, s.jsx)("button", {
                                                                    onClick: () => c("anthrazit"),
                                                                    style: {
                                                                        width: 26,
                                                                        height: 26,
                                                                        borderRadius: "50%",
                                                                        border:
                                                                            a === "anthrazit"
                                                                                ? "2px solid #FFE24D"
                                                                                : "1px solid #ccc",
                                                                        background: "#2b2b2b",
                                                                        cursor: "pointer",
                                                                    },
                                                                    title: "Anthrazit",
                                                                }),
                                                                (0, s.jsx)("span", {
                                                                    style: { fontSize: b.smallText, marginTop: 6 },
                                                                    children: "Anthrazit",
                                                                }),
                                                            ],
                                                        }),
                                                        (0, s.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                            },
                                                            children: [
                                                                (0, s.jsx)("button", {
                                                                    onClick: () => c("naturgrau"),
                                                                    style: {
                                                                        width: 26,
                                                                        height: 26,
                                                                        borderRadius: "50%",
                                                                        border:
                                                                            a === "naturgrau"
                                                                                ? "2px solid #FFE24D"
                                                                                : "1px solid #ccc",
                                                                        background: "#cfcfcf",
                                                                        cursor: "pointer",
                                                                    },
                                                                    title: "Naturgrau",
                                                                }),
                                                                (0, s.jsx)("span", {
                                                                    style: { fontSize: b.smallText, marginTop: 6 },
                                                                    children: "Naturgrau",
                                                                }),
                                                            ],
                                                        }),
                                                    ],
                                                }),
                                                (0, s.jsx)("div", {
                                                    style: {
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(4, 1fr)",
                                                        gap: 8,
                                                    },
                                                    children: Jn.map((w) =>
                                                        (0, s.jsxs)(
                                                            "button",
                                                            {
                                                                onClick: () => u(w.name),
                                                                style: {
                                                                    padding: "5px",
                                                                    fontSize: b.smallText,
                                                                    color: "#1b1b1b",
                                                                    borderRadius: 10,
                                                                    background: o === w.name ? "#FFE24D" : "#f9f9f9",
                                                                    border:
                                                                        o === w.name
                                                                            ? "2px solid #FFE24D"
                                                                            : "1px solid #ccc",
                                                                    cursor: "pointer",
                                                                    display: "grid",
                                                                    gridTemplateRows: "auto 1fr",
                                                                    alignItems: "center",
                                                                    justifyItems: "center",
                                                                    minHeight: b.cardMinH,
                                                                },
                                                                title: w.name,
                                                                children: [
                                                                    (0, s.jsx)("img", {
                                                                        src: Nt(w.name),
                                                                        alt: w.name,
                                                                        style: {
                                                                            width: 80,
                                                                            height: 56,
                                                                            objectFit: "contain",
                                                                            marginBottom: 6,
                                                                        },
                                                                    }),
                                                                    (0, s.jsx)("span", {
                                                                        style: { textAlign: "center" },
                                                                        children: w.name,
                                                                    }),
                                                                ],
                                                            },
                                                            w.name
                                                        )
                                                    ),
                                                }),
                                            ],
                                        }),
                                    }),
                                    (0, s.jsxs)(se, {
                                        title: "2. Ausrichtung",
                                        info: Id,
                                        children: [
                                            r.map((w) =>
                                                (0, s.jsx)(
                                                    me,
                                                    {
                                                        label: w.name,
                                                        img: w.img,
                                                        selected: m === w.name,
                                                        onClick: () => g(w.name),
                                                        disabled: !o,
                                                    },
                                                    w.name
                                                )
                                            ),
                                            (o === "Wattstone 0\xB0" || o === "Wattstone 6\xB0") &&
                                                (0, s.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 8,
                                                        marginTop: 8,
                                                    },
                                                    children: [
                                                        (0, s.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600,
                                                                fontSize: b.bodyFont,
                                                                marginRight: 6,
                                                            },
                                                            children: "Ausrichtung der PV-Module:",
                                                        }),
                                                        (0, s.jsx)(me, {
                                                            label: "Vertikal",
                                                            selected: T === "vertical",
                                                            onClick: () => O("vertical"),
                                                            disabled: !o,
                                                        }),
                                                        (0, s.jsx)(me, {
                                                            label: "Horizontal",
                                                            selected: T === "horizontal",
                                                            onClick: () => O("horizontal"),
                                                            disabled: !o,
                                                        }),
                                                    ],
                                                }),
                                        ],
                                    }),
                                    (0, s.jsx)(se, {
                                        title: "3. Anzahl der PV-Module",
                                        info: Nd,
                                        children: (0, s.jsxs)("select", {
                                            value: f ?? "",
                                            onChange: (w) => v(w.target.value ? Number(w.target.value) : null),
                                            disabled: !m || !o,
                                            style: {
                                                padding: "8px 10px",
                                                fontSize: b.bodyFont,
                                                borderRadius: 10,
                                                border: "1px solid #ccc",
                                                color: "#1b1b1b",
                                                background: "#fff",
                                            },
                                            children: [
                                                (0, s.jsx)("option", { value: "", children: "Anzahl w\xE4hlen" }),
                                                tn(o, m, T).map((w) =>
                                                    (0, s.jsx)("option", { value: w, children: w }, w)
                                                ),
                                            ],
                                        }),
                                    }),
                                    (0, s.jsxs)(se, {
                                        title: "4. Oberfl\xE4che",
                                        info: Ld,
                                        children: [
                                            (0, s.jsx)(me, {
                                                label: "Flachd\xE4cher wie Bitumen, Beton, Holz oder Asphalt",
                                                selected: k === "flachdach",
                                                onClick: () => x("flachdach"),
                                                disabled: !o,
                                            }),
                                            (0, s.jsx)(me, {
                                                label: "Foliend\xE4cher wie EPDM oder PVC",
                                                selected: k === "foliendach",
                                                onClick: () => x("foliendach"),
                                                disabled: !o,
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            (0, s.jsxs)("div", {
                                style: { flex: 2, minWidth: 260 },
                                children: [
                                    (0, s.jsxs)(se, {
                                        title: "5. Inkl. Windleitbleche (empfohlen)",
                                        info: Wd,
                                        children: [
                                            (0, s.jsx)(me, {
                                                label: "ohne Windleitbleche",
                                                selected: R === "without",
                                                onClick: () => h("without"),
                                                disabled: wt,
                                            }),
                                            (0, s.jsx)(me, {
                                                label: "mit Windleitblechen",
                                                selected: R === "with",
                                                onClick: () => h("with"),
                                                disabled: wt,
                                            }),
                                        ],
                                    }),
                                    (0, s.jsxs)(se, {
                                        title: "6. Extension Plate (f\xFCr 500 W Module horizontal)",
                                        info: Vd,
                                        children: [
                                            (0, s.jsx)(me, {
                                                label: "ohne Extension Plate",
                                                selected: D === "without",
                                                onClick: () => J("without"),
                                                disabled: _e,
                                            }),
                                            (0, s.jsx)(me, {
                                                label: "mit Extension Plate",
                                                selected: D === "with",
                                                onClick: () => J("with"),
                                                disabled: _e,
                                            }),
                                        ],
                                    }),
                                    // (0, s.jsxs)(se, {
                                    //     title: "7. Inkl. PV-Module (optional)",
                                    //     info: Rd,
                                    //     children: [
                                    //         (0, s.jsx)(me, {
                                    //             label: "ohne PV-Module",
                                    //             selected: d === "without",
                                    //             onClick: () => p("without"),
                                    //             disabled: !f,
                                    //         }),
                                    //         (0, s.jsx)(me, {
                                    //             label: "mit PV-Modulen",
                                    //             selected: d === "with",
                                    //             onClick: () => p("with"),
                                    //             disabled: !f,
                                    //         }),
                                    //         (0, s.jsxs)("div", {
                                    //             style: { width: "100%", marginTop: 6 },
                                    //             children: [
                                    //                 (0, s.jsx)("div", {
                                    //                     style: {
                                    //                         fontWeight: 600,
                                    //                         marginBottom: 4,
                                    //                         fontSize: b.smallText,
                                    //                     },
                                    //                     children: "PV-Modell w\xE4hlen",
                                    //                 }),
                                    //                 (0, s.jsxs)("div", {
                                    //                     style: { display: "flex", flexWrap: "wrap" },
                                    //                     children: [
                                    //                         (0, s.jsx)(me, {
                                    //                             label: "Trina 460W",
                                    //                             img: t.pvModule.img,
                                    //                             selected: C === "trina",
                                    //                             disabled: !f || d !== "with",
                                    //                             onClick: () => I("trina"),
                                    //                         }),
                                    //                         (0, s.jsx)(me, {
                                    //                             label: "Aiko 465W",
                                    //                             img: t.aikoModule.img,
                                    //                             selected: C === "aiko",
                                    //                             disabled: !f || d !== "with",
                                    //                             onClick: () => I("aiko"),
                                    //                         }),
                                    //                     ],
                                    //                 }),
                                    //             ],
                                    //         }),
                                    //     ],
                                    // }),
                                    // (0, s.jsxs)(se, {
                                    //     title: "8. Inkl. Mikrowechselrichter (optional)",
                                    //     info: Dd,
                                    //     children: [
                                    //         (0, s.jsx)(me, {
                                    //             label: "ohne Mikrowechselrichter",
                                    //             selected: y === "without",
                                    //             onClick: () => z("without"),
                                    //             disabled: !f,
                                    //         }),
                                    //         (0, s.jsx)(me, {
                                    //             label: "mit Mikrowechselrichter",
                                    //             selected: y === "with",
                                    //             onClick: () => z("with"),
                                    //             disabled: !f,
                                    //         }),
                                    //     ],
                                    // }),
                                    (0, s.jsx)(se, {
                                        title: "Bestell\xFCbersicht",
                                        info: Ad,
                                        showInfo: !1,
                                        children:
                                            E.length === 0
                                                ? (0, s.jsx)("p", {
                                                      style: { fontSize: b.listFont },
                                                      children: "Bitte alle Auswahloptionen ausf\xFCllen.",
                                                  })
                                                : (0, s.jsxs)(s.Fragment, {
                                                      children: [
                                                          (0, s.jsx)("ul", {
                                                              style: {
                                                                  fontSize: b.listFont,
                                                                  margin: 0,
                                                                  paddingLeft: 18,
                                                              },
                                                              children: E.map((w, L) =>
                                                                  (0, s.jsxs)(
                                                                      "li",
                                                                      {
                                                                          children: [
                                                                              w.title,
                                                                              " \u2014 ",
                                                                              w.qty,
                                                                              " St\xFCck",
                                                                          ],
                                                                      },
                                                                      L
                                                                  )
                                                              ),
                                                          }),
                                                          Jt
                                                              ? (0, s.jsxs)("h2", {
                                                                    style: {
                                                                        marginTop: 10,
                                                                        fontSize: b.sectionTitleSize,
                                                                    },
                                                                    children: ["Gesamtpreis: \u20AC", X.toFixed(2)],
                                                                })
                                                              : (0, s.jsx)("p", {
                                                                    style: {
                                                                        marginTop: 10,
                                                                        fontSize: b.listFont,
                                                                        fontStyle: "italic",
                                                                    },
                                                                    children:
                                                                        "Preise werden nur f\xFCr eingeloggte Kund:innen angezeigt.",
                                                                }),
                                                      ],
                                                  }),
                                    }),
                                    Jt
                                        ? (0, s.jsxs)(s.Fragment, {
                                              children: [
                                                  (0, s.jsx)("button", {
                                                      onClick: ce,
                                                      disabled: !(o && a && m && f && k),
                                                      style: {
                                                          marginTop: 8,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "none",
                                                          background: o && a && m && f && k ? "#111" : "#ccc",
                                                          color: "#fff",
                                                          fontSize: 16,
                                                          fontWeight: "bold",
                                                          cursor: o && a && m && f && k ? "pointer" : "not-allowed",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb hinzuf\xFCgen",
                                                  }),
                                                  (0, s.jsx)("button", {
                                                      onClick: ue,
                                                      style: {
                                                          marginTop: 8,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "2px solid #ccc",
                                                          background: "#f7f7f7",
                                                          color: "#111",
                                                          fontSize: 16,
                                                          fontWeight: 600,
                                                          cursor: "pointer",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb",
                                                  }),
                                              ],
                                          })
                                        : (0, s.jsx)("button", {
                                              onClick: Yn,
                                              style: {
                                                  marginTop: 8,
                                                  padding: "12px 16px",
                                                  borderRadius: 12,
                                                  border: "none",
                                                  background: "#111",
                                                  color: "#fff",
                                                  fontSize: 16,
                                                  fontWeight: "bold",
                                                  cursor: "pointer",
                                                  display: "block",
                                                  width: "100%",
                                              },
                                              children: "Anmelden oder Konto erstellen, um in den Warenkorb zu legen",
                                          }),
                                    (0, s.jsx)("button", {
                                        onClick: xe,
                                        style: {
                                            marginTop: 8,
                                            padding: "10px 16px",
                                            borderRadius: 12,
                                            border: "2px solid #ccc",
                                            background: "#FFE24D",
                                            color: "#111",
                                            fontSize: b.bodyFont,
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            display: "block",
                                            width: "100%",
                                        },
                                        children: "Zur\xFCcksetzen & neu konfigurieren!",
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        });
    }
    function xh({ stickyTop: e = 0 }) {
        let t = {
                zaunPV_flat: {
                    id: "zaunPV_flat",
                    title: "ZaunPV Komplettset M2B f\xFCr 1 PV-Modul (Flach)",
                    price: 51.17,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Frame_1009.png?v=1756092851",
                    variantId: 53927276773700,
                },
                zaunPV_angled: {
                    id: "zaunPV_angled",
                    title: "ZaunPV Komplettset Angewinkelt M3B f\xFCr 1 PV-Modul",
                    price: 71.40,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Frame_1008.png?v=1756092852",
                    variantId: 53940270137668,
                },
                inverter800: {
                    id: "inverter800",
                    title: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                    price: 82.11,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW.png?v=1755742176",
                    variantId: 53940269580612,
                },
                inverter2000: {
                    id: "inverter2000",
                    title: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                    price: 65.45,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/MW_4.png?v=1755742176",
                    variantId: 53940264960324,
                },
                pvTrina440: {
                    id: "pvTrina435",
                    title: "435W Trina Solar Vertex S+TSM-NEG9RC.27 BIFAZIAL TRANSPARENT DOPPELGLAS N-Typ i-TOPCon 1762\xD71134\xD730 mm",
                    price: 58.31,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/pvmodul-solarmodul-solarpanel-trina-vertexs-plus-435wp-zaunpv-vorder-und-rueckseite_0bcb623e-ad97-4d54-b064-cfd9cc71136c_1160x_crop_center_webp.png?v=1756088921",
                    variantId: 53927609041220,
                },
                pvTrina450: {
                    id: "pvTrina460",
                    title: "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon 1762x1134x30 mm",
                    price: 308.21,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/trina_tsm_neg9r_28_alternergyw_1_1_1_1160x_crop_center_jpg.webp?v=1756034883",
                    variantId: 53940264337732,
                },
                pvAiko465: {
                    id: "pvAiko465",
                    title: "465W Aiko A-MAH54Db Doppelglas Full Black Neostar 2S+ 1757\xD71134\xD730 mm",
                    price: 12.50,
                    img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/aiko_1160x_crop_center_png.webp?v=1756034882",
                    variantId: 53943368909124,
                },
            },
            n = {
                flach: [
                    {
                        key: "t_halter",
                        title: "T-Halter",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/avsg.png?v=1756088383",
                    },
                    {
                        key: "tl_halter",
                        title: "TL-Halter",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/afca.png?v=1756088383",
                    },
                    {
                        key: "konterblech",
                        title: "Konterblech Halter",
                        qty: 5,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/ae.png?v=1756088383",
                    },
                    {
                        key: "schrauben",
                        title: "Schrauben & Muttern",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_296-2.png?v=1756088383",
                    },
                    {
                        key: "winkelschluessel",
                        title: "Winkelschl\xFCssel",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/srts.png?v=1756088383",
                    },
                    {
                        key: "maulschluessel",
                        title: "Maulschl\xFCssel",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Screenshot_2025-03-21_at_09.35.21_1.png?v=1756088383",
                    },
                    {
                        key: "kabelclips",
                        title: "Kabel Clips",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/clip_21.png?v=1756000696",
                    },
                ],
                angewinkelt: [
                    {
                        key: "distanz",
                        title: "Distanzst\xFCcke",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Untitled_design_10.png?v=1756088383",
                    },
                    {
                        key: "u_halter",
                        title: "U-Halter",
                        qty: 2,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Untitled_design_9.png?v=1756088384",
                    },
                    {
                        key: "konterblech",
                        title: "Konterblech Halter",
                        qty: 5,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/ae.png?v=1756088383",
                    },
                    {
                        key: "schrauben",
                        title: "Schrauben & Muttern",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Group_296-2.png?v=1756088383",
                    },
                    {
                        key: "winkelschluessel",
                        title: "Winkelschl\xFCssel",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/srts.png?v=1756088383",
                    },
                    {
                        key: "maulschluessel",
                        title: "Maulschl\xFCssel",
                        qty: 1,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Screenshot_2025-03-21_at_09.35.21_1.png?v=1756088383",
                    },
                    {
                        key: "kabelclips",
                        title: "Kabel Clips",
                        qty: 4,
                        img: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/clip_21.png?v=1756000696",
                    },
                ],
            },
            r = [
                { key: "flach", label: "Flach", productKey: "zaunPV_flat", img: t.zaunPV_flat.img },
                { key: "angewinkelt", label: "Angewinkelt", productKey: "zaunPV_angled", img: t.zaunPV_angled.img },
            ],
            i = "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/20221125.png?v=1756090450",
            l = {
                flach: {
                    one: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/1-9.png?v=1756089685",
                    many: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/20221122.png?v=1756089686",
                },
                angewinkelt: {
                    one: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/20221123.png?v=1756089686",
                    many: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/20221124.png?v=1756089685",
                },
            },
            [o, u] = (0, N.useState)(null),
            [a, c] = (0, N.useState)(null),
            [m, g] = (0, N.useState)("without"),
            [f, v] = (0, N.useState)(null),
            [k, x] = (0, N.useState)("without"),
            R = () => {
                try {
                    if (typeof window < "u") {
                        if (typeof window.__CUSTOMER_LOGGED_IN__ < "u") return !!window.__CUSTOMER_LOGGED_IN__;
                        let P = document.querySelector('meta[name="customer-logged-in"]');
                        if (P) return P.content === "true";
                        let E = document.querySelector("[data-customer-logged-in]");
                        if (E) return E.getAttribute("data-customer-logged-in") === "true";
                    }
                } catch {}
                return !1;
            },
            [h, d] = (0, N.useState)(R());
        (0, N.useEffect)(() => {
            d(R());
        }, []);
        let p = () => {
                let P = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
                window.location.href = `/account?return_url=${P}`;
            },
            [y, z] = (0, N.useState)(!1);
        (0, N.useEffect)(() => {
            let P = () => z(window.innerWidth <= 768);
            return P(), window.addEventListener("resize", P), () => window.removeEventListener("resize", P);
        }, []);
        let C = (0, N.useMemo)(
                () => ({
                    gap: y ? 10 : 16,
                    sectionPadding: y ? 10 : 14,
                    sectionTitleSize: y ? 14 : 16,
                    h1Size: y ? 20 : 22,
                    bodyFont: y ? 13 : 14,
                    smallText: y ? 11 : 12,
                    buttonPadding: y ? "8px 10px" : "10px 12px",
                    buttonFont: y ? 13 : 14,
                    cardMinH: y ? 78 : 88,
                    listFont: y ? 13 : 14,
                }),
                [y]
            ),
            T = ((P, E, ee = 1) => {
                let X = [];
                for (let fe = P; fe <= E; fe += ee) X.push(fe);
                return X;
            })(1, 100, 1),
            O = ({ label: P, img: E, selected: ee, disabled: X, onClick: fe }) =>
                (0, s.jsxs)("button", {
                    type: "button",
                    onClick: fe,
                    disabled: X,
                    style: {
                        margin: y ? 6 : 8,
                        padding: C.buttonPadding,
                        fontSize: C.buttonFont,
                        borderRadius: 10,
                        cursor: X ? "not-allowed" : "pointer",
                        backgroundColor: X ? "#ddd" : ee ? "#FFE24D" : "#f9f9f9",
                        color: X ? "#888" : "#1b1b1b",
                        border: ee ? "2px solid #FFE24D" : "1px solid #ccc",
                        minWidth: y ? "110px" : "140px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        lineHeight: 1.2,
                    },
                    title: typeof P == "string" ? P : void 0,
                    children: [
                        E &&
                            (0, s.jsx)("img", {
                                src: E,
                                alt: typeof P == "string" ? P : "option",
                                style: { width: 76, height: 54, objectFit: "contain", marginBottom: 6 },
                            }),
                        P,
                    ],
                }),
            D = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "ZaunPV verwandelt vorhandene Doppelstabmattenz\xE4une in effiziente Stromerzeuger: PV-Module werden direkt am Zaun montiert, so nutzt ihr ungenutzte Fl\xE4che, spart Platz und bleibt flexibel in der Gestaltung. Die Komplettsets sind auf Minuteninstallation ausgelegt (inkl. passender Komponenten und sogar Werkzeug), mit diebstahlsicherer Fixierung und wahlweise vertikaler oder horizontaler Modulanordnung \u2013 modular erweiterbar vom Einzelmodul bis zur langen Zaunstrecke.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Flach (parallel zum Zaun):" }),
                            " schlanke, platzsparende Optik; Module liegen ohne Neigung am Zaun an \u2013 ideal, wenn maximale Kompaktheit und klare Linien entscheidend sind.",
                            (0, s.jsx)("br", {}),
                            (0, s.jsx)("strong", { children: "Angewinkelt (mit Neigung):" }),
                            " optimierte Einstrahlung durch einen definierten Neigungswinkel; sinnvoll, wenn je nach Standort ein h\xF6herer Energieertrag \xFCber die Tages- und Jahreszeiten erzielt werden soll.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/ZaunPV_Montagepaket_mit_TL-Haltern-2.pdf?v=1741692200",
                            children: "Montageanleitung f\xFCr ZaunPV-Set Flach mit TL-Haltern",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/ZaunPV_Montagepaket_Agewinkelt-2.pdf?v=1741692200",
                            children: "Montageanleitung f\xFCr ZaunPV-Set Agewinkelt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Ubersichtsskizze_Solarmodul_horizontale_Einbaulage_1_OB_ZaunPV.pdf?v=1746765881",
                            children: "Einbau-Skizze: PV-Modul flach horizontal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Ubersichtsskizze_Solarmodul_vertikale_Einbaulage_1_OB_ZaunPV.pdf?v=1746765881",
                            children: "Einbau-Skizze: PV-Modul flach vertikal",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/uebersichtsskizze-solarmodul-schraege-einbaulage-ob-zaunpv-web.pdf?v=1713769464",
                            children: "Einbau-Skizze: PV-Modul angewinkelt",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/projekte-zaunpv",
                            children: "ZaunPV Projektportfolio",
                        }),
                    }),
                ],
            }),
            J = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Geben Sie die Anzahl der Module an (1\u2013100). Der Konfigurator skaliert die Kleinteile automatisch mit.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/faq#zaunpv",
                            children: "ZaunPV \u2013 FAQ",
                        }),
                    }),
                ],
            }),
            st = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Sie k\xF6nnen die passenden ",
                            (0, s.jsx)("strong", { children: "PV-Module" }),
                            " direkt mitbestellen. Mengen werden automatisch an Ihre Auswahl angepasst.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/VertexS_NEG9RC.27_DE_2023.pdf?v=1742557825",
                            children:
                                "435W Trina Solar Vertex S+TSM-NEG9RC.27 BIFAZIAL TRANSPARENT DOPPELGLAS N-Typ i-TOPCon 1762\xD71134\xD730 mm",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/22-Vertex_S_plus_NEG9R.28_240411_Datasheet_Vertex_S__NEG9R.28_DE_2024_A_S1_web.pdf?v=1742091602",
                            children: "460W Trina Vertex S+TSM-NEG9R.28 Glas Glas N-Typ i-TOPCon 1762x1134x30 mm",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/Neostar-2S_Plus_188-AIKO-A-MAH54Db-440-470W_1757x1134x30mm_DS_DE_2405_V1_5-Kopie.pdf?v=1749610088",
                            children: "465W Aiko A-MAH54Db-Doppelglas Full Black Neostar 2S+ 1757x1134x30 mm",
                        }),
                    }),
                ],
            }),
            Jt = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsxs)("p", {
                        children: [
                            "Automatische Planung: bis 2 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS800" }),
                            ", 3\u20134 Module \u2192 ",
                            (0, s.jsx)("strong", { children: "MS2000(800)" }),
                            ". Optional mitbestellen.",
                        ],
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS600_MX1000_2-in-1.pdf?v=1742004341",
                            children: "Mikrowechselrichter TSUN TSOL-MS800 Balkon",
                        }),
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://cdn.shopify.com/s/files/1/0755/9351/5332/files/DTS_DE_241112_Microinverter_G3_MS1600_MX2250_4-in-1.pdf?v=1742007720",
                            children: "Mikrowechselrichter TSUN TSOL-MS2000(800) (2C)",
                        }),
                    }),
                ],
            }),
            Xn = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "St\xFCckliste f\xFCr Ihr ZaunPV-Set (Halter, Schrauben, Werkzeuge, Clips). Mengen passen sich der Modulzahl an.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, {
                            href: "https://wattstone.de/pages/faq#zaunpv",
                            children: "Details & Montage",
                        }),
                    }),
                ],
            }),
            Yn = (0, s.jsxs)("div", {
                children: [
                    (0, s.jsx)("p", {
                        children:
                            "Alles korrekt? Dann legen Sie das komplette Set in den Warenkorb. Preise sehen Sie nach dem Login.",
                    }),
                    (0, s.jsx)("p", {
                        style: { marginBottom: 0 },
                        children: (0, s.jsx)(W, { href: "https://wattstone.de/pages/kontakt", children: "Kontakt" }),
                    }),
                ],
            }),
            Q = o && a ? Number(a) : 0,
            en = o ? n[o] : null,
            Z = a
                ? ((P) => {
                      if (!P || P <= 0) return { n2000: 0, n800: 0 };
                      let E = Math.floor(P / 4),
                          ee = P % 4;
                      return ee === 0
                          ? { n2000: E, n800: 0 }
                          : ee <= 2
                            ? { n2000: E, n800: 1 }
                            : { n2000: E + 1, n800: 0 };
                  })(Number(a))
                : { n2000: 0, n800: 0 },
            He = [];
        if (o && a) {
            let P = r.find((ee) => ee.key === o),
                E = t[P.productKey];
            Q > 0 && He.push({ ...E, qty: Q, components: en || [] }),
                m === "with" &&
                    a &&
                    (f === "aiko"
                        ? He.push({ ...t.pvAiko465, qty: Number(a) })
                        : f === "trina440"
                          ? He.push({ ...t.pvTrina440, qty: Number(a) })
                          : f === "trina450" && He.push({ ...t.pvTrina450, qty: Number(a) })),
                k === "with" &&
                    (Z.n2000 > 0 && He.push({ ...t.inverter2000, qty: Z.n2000 }),
                    Z.n800 > 0 && He.push({ ...t.inverter800, qty: Z.n800 }));
        }
        let ut = He.reduce((P, E) => P + (Number(E.price) || 0) * (Number(E.qty) || 0), 0),
            _e = [];
        en && Q > 0 && en.forEach((P) => _e.push({ title: P.title, qty: P.qty * Q, img: P.img })),
            m === "with" &&
                a &&
                (f === "aiko"
                    ? _e.push({ title: t.pvAiko465.title, qty: Number(a), img: t.pvAiko465.img })
                    : f === "trina440"
                      ? _e.push({ title: t.pvTrina440.title, qty: Number(a), img: t.pvTrina440.img })
                      : f === "trina450" &&
                        _e.push({ title: t.pvTrina450.title, qty: Number(a), img: t.pvTrina450.img })),
            k === "with" &&
                (Z.n2000 > 0 && _e.push({ title: t.inverter2000.title, qty: Z.n2000, img: t.inverter2000.img }),
                Z.n800 > 0 && _e.push({ title: t.inverter800.title, qty: Z.n800, img: t.inverter800.img }));
        function vt(P) {
            var ee, X;
            let E = new Map();
            for (let fe of P) {
                let _ = Number(fe.id),
                    V = Number((X = (ee = fe.quantity) != null ? ee : fe.qty) != null ? X : 0);
                !_ || V <= 0 || E.set(_, (E.get(_) || 0) + V);
            }
            return Array.from(E.entries()).map(([fe, _]) => ({ id: fe, quantity: _ }));
        }
        let yt = () => {
            var E, ee;
            if (!(o && a)) return [];
            let P = [];
            for (let X of He) {
                let fe =
                        (ee = X.variantId) != null
                            ? ee
                            : typeof X.id == "string"
                              ? (E = t[X.id]) == null
                                  ? void 0
                                  : E.variantId
                              : Number(X.id),
                    _ = Number(X.qty || 0);
                fe && _ > 0 && P.push({ id: Number(fe), quantity: _ });
            }
            return vt(P);
        };
        async function Nt(P) {
            if (!P || P.length === 0) throw new Error("No items to add");
            let E = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: P }),
                credentials: "same-origin",
            });
            if (!E.ok) throw new Error(await E.text());
            return E.json();
        }
        let kn = async () => {
                try {
                    if (!h) return alert("Bitte anmelden oder ein Konto erstellen, um in den Warenkorb zu legen.");
                    if (!(o && a)) return alert("Bitte Modell und Anzahl der PV-Module w\xE4hlen.");
                    if (m === "with" && !f) return alert("Bitte ein PV-Modulmodell ausw\xE4hlen (Trina oder Aiko).");
                    let P = yt();
                    if (!P.length) return alert("Keine Artikel gefunden.");
                    await Nt(P), alert("Artikel wurden dem Warenkorb hinzugef\xFCgt.");
                    window.location.href = '/cart';

                } catch (P) {
                    console.error("Add to cart error", P),
                        alert("Fehler beim Hinzuf\xFCgen zum Warenkorb. Siehe Konsole.");
                }
            },
            Jn = () => (window.location.href = "/cart"),
            at = () => {
                u(null), c(null), g("without"), v(null), x("without");
            },
            tn = () => {
                var X;
                if (!o) return i;
                let E = (a ?? 1) >= 2 ? "many" : "one";
                return ((X = l[o]) == null ? void 0 : X[E]) || i;
            },
            er = () => {
                if (!(o && a))
                    return (0, s.jsx)("p", {
                        style: { fontSize: C.listFont },
                        children: "Bitte Modell und Anzahl w\xE4hlen.",
                    });
                let P = r.find((E) => E.key === o);
                return (0, s.jsxs)("div", {
                    style: { width: "100%" },
                    children: [
                        (0, s.jsxs)("div", {
                            style: { marginBottom: 8 },
                            children: [
                                (0, s.jsx)("div", { style: { fontWeight: 700, marginBottom: 6 }, children: P.label }),
                                (0, s.jsx)("ul", {
                                    style: { fontSize: C.listFont, margin: 0, paddingLeft: 18 },
                                    children: (en || []).map((E) =>
                                        (0, s.jsxs)(
                                            "li",
                                            { children: [E.title, " \u2014 ", E.qty * Q, " St\xFCck"] },
                                            E.key
                                        )
                                    ),
                                }),
                            ],
                        }),
                        (0, s.jsxs)("ul", {
                            style: { fontSize: C.listFont, margin: 0, paddingLeft: 18 },
                            children: [
                                m === "with" &&
                                    f === "aiko" &&
                                    (0, s.jsxs)("li", { children: [t.pvAiko465.title, " \u2014 ", a, " St\xFCck"] }),
                                m === "with" &&
                                    f === "trina440" &&
                                    (0, s.jsxs)("li", { children: [t.pvTrina440.title, " \u2014 ", a, " St\xFCck"] }),
                                m === "with" &&
                                    f === "trina450" &&
                                    (0, s.jsxs)("li", { children: [t.pvTrina450.title, " \u2014 ", a, " St\xFCck"] }),
                                m === "with" &&
                                    !f &&
                                    (0, s.jsx)("li", {
                                        children:
                                            "Bitte PV-Modulmodell ausw\xE4hlen (Trina 440W, Trina 450W oder Aiko 465W).",
                                    }),
                                k === "with" &&
                                    (Z.n2000 > 0 || Z.n800 > 0) &&
                                    (0, s.jsxs)(s.Fragment, {
                                        children: [
                                            Z.n2000 > 0 &&
                                                (0, s.jsxs)("li", {
                                                    children: [t.inverter2000.title, " \u2014 ", Z.n2000, " St\xFCck"],
                                                }),
                                            Z.n800 > 0 &&
                                                (0, s.jsxs)("li", {
                                                    children: [t.inverter800.title, " \u2014 ", Z.n800, " St\xFCck"],
                                                }),
                                        ],
                                    }),
                            ],
                        }),
                    ],
                });
            },
            wt = () =>
                _e.length
                    ? (0, s.jsx)(se, {
                          title: "Set-Komponenten",
                          info: Xn,
                          showInfo: !1,
                          children: (0, s.jsx)("div", {
                              style: { display: "flex", flexWrap: "wrap", gap: 6 },
                              children: _e.map((P, E) =>
                                  (0, s.jsxs)(
                                      "div",
                                      {
                                          style: { textAlign: "center" },
                                          children: [
                                              P.img
                                                  ? (0, s.jsx)("img", {
                                                        src: P.img,
                                                        alt: P.title,
                                                        style: {
                                                            width: 64,
                                                            height: 46,
                                                            objectFit: "contain",
                                                            margin: 2,
                                                        },
                                                    })
                                                  : (0, s.jsx)("div", {
                                                        style: {
                                                            width: 64,
                                                            height: 46,
                                                            margin: 2,
                                                            borderRadius: 8,
                                                            border: "1px dashed #ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: 10,
                                                            color: "#666",
                                                        },
                                                        children: P.title,
                                                    }),
                                              (0, s.jsxs)("p", {
                                                  style: { fontSize: C.smallText, marginTop: 4 },
                                                  children: [P.title, " (x ", P.qty, ")"],
                                              }),
                                          ],
                                      },
                                      `${P.title}-${E}`
                                  )
                              ),
                          }),
                      })
                    : null,
            tr = () => {
                let P = m !== "with";
                return (0, s.jsxs)(s.Fragment, {
                    children: [
                        (0, s.jsx)(O, {
                            label: "ohne PV-Module",
                            selected: m === "without",
                            onClick: () => g("without"),
                            disabled: !1,
                        }),
                        (0, s.jsx)(O, {
                            label: "mit PV-Modulen",
                            selected: m === "with",
                            onClick: () => g("with"),
                            disabled: !1,
                        }),
                        (0, s.jsxs)("div", {
                            style: { width: "100%", marginTop: 6 },
                            children: [
                                (0, s.jsx)("div", {
                                    style: { fontWeight: 600, marginBottom: 6 },
                                    children: "PV-Modell w\xE4hlen",
                                }),
                                (0, s.jsxs)("div", {
                                    style: { display: "flex", flexWrap: "wrap" },
                                    children: [
                                        (0, s.jsx)(O, {
                                            label: "Trina 435W Bifazial Transparent Glas-Glas",
                                            img: t.pvTrina440.img,
                                            selected: f === "trina435",
                                            onClick: () => v("trina435"),
                                            disabled: P,
                                        }),
                                        (0, s.jsx)(O, {
                                            label: "Trina 460W Glas-Glas",
                                            img: t.pvTrina450.img,
                                            selected: f === "trina460",
                                            onClick: () => v("trina460"),
                                            disabled: P,
                                        }),
                                        (0, s.jsx)(O, {
                                            label: "Aiko 465W Doppelglas Full Black",
                                            img: t.pvAiko465.img,
                                            selected: f === "aiko",
                                            onClick: () => v("aiko"),
                                            disabled: P,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                });
            };
        return (0, s.jsx)("div", {
            style: {
                fontFamily: "Arial, sans-serif",
                width: "100%",
                maxWidth: 1200,
                margin: "0 auto",
                fontSize: C.bodyFont,
            },
            children: (0, s.jsxs)("div", {
                id: "canvas",
                style: {
                    width: "100%",
                    padding: 16,
                    boxSizing: "border-box",
                    borderRadius: 12,
                    background: "#fff",
                    color: "#1b1b1b",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                },
                children: [
                    (0, s.jsx)("h1", {
                        style: { fontSize: C.h1Size, margin: "0 0 10px 0" },
                        children: "ZaunPV-Set \u2013 blitzschnell konfigurieren!",
                    }),
                    (0, s.jsxs)("div", {
                        style: { display: "flex", gap: C.gap, flexWrap: "wrap" },
                        children: [
                            (0, s.jsxs)("div", {
                                style: { flex: 2, display: "flex", flexDirection: "column" },
                                children: [
                                    (0, s.jsxs)("div", {
                                        style: { marginBottom: 12 },
                                        children: [
                                            (0, s.jsx)("h2", {
                                                style: { fontSize: C.sectionTitleSize, marginBottom: 6 },
                                                children: "Projektvorschau",
                                            }),
                                            (0, s.jsx)("img", {
                                                src: tn(),
                                                alt: "Preview",
                                                style: {
                                                    width: "100%",
                                                    maxWidth: 320,
                                                    objectFit: "contain",
                                                    borderRadius: 10,
                                                    display: "block",
                                                    marginBottom: 8,
                                                },
                                            }),
                                        ],
                                    }),
                                    (0, s.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minHeight: 0,
                                            overflowY: "auto",
                                            paddingRight: 6,
                                            position: "sticky",
                                            top: e + 8,
                                            zIndex: 0,
                                        },
                                        children: (0, s.jsx)(wt, {}),
                                    }),
                                ],
                            }),
                            (0, s.jsxs)("div", {
                                style: { flex: 3, minWidth: 260 },
                                children: [
                                    (0, s.jsx)(se, {
                                        title: "1. Modell w\xE4hlen",
                                        info: D,
                                        children: r.map((P) =>
                                            (0, s.jsx)(
                                                O,
                                                {
                                                    label: P.label,
                                                    img: P.img,
                                                    selected: o === P.key,
                                                    onClick: () => u(P.key),
                                                },
                                                P.key
                                            )
                                        ),
                                    }),
                                    (0, s.jsx)(se, {
                                        title: "2. Anzahl der PV-Module",
                                        info: J,
                                        showInfo: !1,
                                        children: (0, s.jsxs)("select", {
                                            value: a ?? "",
                                            onChange: (P) => c(P.target.value ? Number(P.target.value) : null),
                                            disabled: !o,
                                            style: {
                                                padding: "8px 10px",
                                                fontSize: C.bodyFont,
                                                borderRadius: 10,
                                                border: "1px solid #ccc",
                                                color: "#1b1b1b",
                                                background: "#fff",
                                            },
                                            children: [
                                                (0, s.jsx)("option", { value: "", children: "Anzahl w\xE4hlen" }),
                                                T.map((P) => (0, s.jsx)("option", { value: P, children: P }, P)),
                                            ],
                                        }),
                                    }),
                                    // (0, s.jsx)(se, {
                                    //     title: "3. PV-Module hinzuf\xFCgen (optional)",
                                    //     info: st,
                                    //     children: (0, s.jsx)(tr, {}),
                                    // }),
                                    // (0, s.jsxs)(se, {
                                    //     title: "4. Mikrowechselrichter (optional)",
                                    //     info: Jt,
                                    //     children: [
                                    //         (0, s.jsx)(O, {
                                    //             label: "ohne Mikrowechselrichter",
                                    //             selected: k === "without",
                                    //             onClick: () => x("without"),
                                    //             disabled: !a,
                                    //         }),
                                    //         (0, s.jsx)(O, {
                                    //             label: "mit Mikrowechselrichter",
                                    //             selected: k === "with",
                                    //             onClick: () => x("with"),
                                    //             disabled: !a,
                                    //         }),
                                    //     ],
                                    // }),
                                ],
                            }),
                            (0, s.jsxs)("div", {
                                style: { flex: 2, minWidth: 260 },
                                children: [
                                    (0, s.jsxs)(se, {
                                        title: "Bestell\xFCbersicht",
                                        info: Yn,
                                        showInfo: !1,
                                        children: [
                                            (0, s.jsx)(er, {}),
                                            h
                                                ? (0, s.jsxs)("h2", {
                                                      style: { marginTop: 8, fontSize: C.sectionTitleSize },
                                                      children: ["Gesamtpreis: \u20AC", ut.toFixed(2)],
                                                  })
                                                : (0, s.jsx)("p", {
                                                      style: {
                                                          marginTop: 8,
                                                          fontSize: C.listFont,
                                                          fontStyle: "italic",
                                                      },
                                                      children:
                                                          "Preise werden nur f\xFCr eingeloggte Kund:innen angezeigt.",
                                                  }),
                                        ],
                                    }),
                                    h
                                        ? (0, s.jsxs)(s.Fragment, {
                                              children: [
                                                  (0, s.jsx)("button", {
                                                      onClick: kn,
                                                      disabled: !(o && a),
                                                      style: {
                                                          marginTop: 6,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "none",
                                                          background: o && a ? "#111" : "#ccc",
                                                          color: "#fff",
                                                          fontSize: 16,
                                                          fontWeight: "bold",
                                                          cursor: o && a ? "pointer" : "not-allowed",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb hinzuf\xFCgen",
                                                  }),
                                                  (0, s.jsx)("button", {
                                                      onClick: Jn,
                                                      style: {
                                                          marginTop: 6,
                                                          padding: "12px 16px",
                                                          borderRadius: 12,
                                                          border: "2px solid #ccc",
                                                          background: "#f7f7f7",
                                                          color: "#111",
                                                          fontSize: 16,
                                                          fontWeight: 600,
                                                          cursor: "pointer",
                                                          display: "block",
                                                          width: "100%",
                                                      },
                                                      children: "Zum Warenkorb",
                                                  }),
                                              ],
                                          })
                                        : (0, s.jsx)("button", {
                                              onClick: p,
                                              style: {
                                                  marginTop: 6,
                                                  padding: "12px 16px",
                                                  borderRadius: 12,
                                                  border: "none",
                                                  background: "#111",
                                                  color: "#fff",
                                                  fontSize: 16,
                                                  fontWeight: "bold",
                                                  cursor: "pointer",
                                                  display: "block",
                                                  width: "100%",
                                              },
                                              children: "Anmelden oder Konto erstellen, um in den Warenkorb zu legen",
                                          }),
                                    (0, s.jsx)("button", {
                                        onClick: at,
                                        style: {
                                            marginTop: 6,
                                            padding: "10px 16px",
                                            borderRadius: 12,
                                            border: "2px solid #ccc",
                                            background: "#FFE24D",
                                            color: "#111",
                                            fontSize: C.bodyFont,
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            display: "block",
                                            width: "100%",
                                        },
                                        children: "Zur\xFCcksetzen & neu konfigurieren!",
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        });
    }
    function Bs({ initialTab: e } = {}) {
        let [t, n] = (0, N.useState)(() => vh(e)),
            r = yh(),
            i = wh(),
            l = (0, N.useRef)(null);
        if (l.current == null)
            try {
                let v = new URLSearchParams(window.location.search);
                l.current = v.has("configTab") ? "configTab" : (v.has("tab"), "tab");
            } catch {
                l.current = "tab";
            }
        let o = l.current,
            u = (0, N.useRef)(null),
            [a, c] = (0, N.useState)(56);
        (0, N.useEffect)(() => {
            let v = () => {
                var R;
                return c(((R = u.current) == null ? void 0 : R.offsetHeight) || 56);
            };
            v();
            let k = new ResizeObserver(v);
            u.current && k.observe(u.current), window.addEventListener("resize", v);
            let x = setTimeout(v, 250);
            return () => {
                k.disconnect(), window.removeEventListener("resize", v), clearTimeout(x);
            };
        }, []);
        let m = r + a;
        (0, N.useEffect)(() => {
            try {
                let v = new URL(window.location.href),
                    k = o || "tab";
                if (wn(v.searchParams.get(k)) !== t) {
                    v.searchParams.set(k, t);
                    let R = k === "tab" ? "configTab" : "tab";
                    v.searchParams.delete(R), window.history.replaceState({}, "", v.toString());
                }
            } catch {}
        }, [t, o]),
            (0, N.useEffect)(() => {
                let v = () => {
                    try {
                        let k = new URLSearchParams(window.location.search),
                            x = o || "tab",
                            R = wn(k.get(x)) || wn(k.get(x === "tab" ? "configTab" : "tab"));
                        R && R !== t && n(R);
                    } catch {}
                };
                return (
                    window.addEventListener("popstate", v),
                    window.addEventListener("hashchange", v),
                    () => {
                        window.removeEventListener("popstate", v), window.removeEventListener("hashchange", v);
                    }
                );
            }, [t, o]);
        let g = ({ id: v, label: k }) => {
                let x = t === v;
                return (0, s.jsx)("button", {
                    type: "button",
                    onClick: () => n(v),
                    style: {
                        padding: "10px 16px",
                        borderRadius: 10,
                        border: x ? "2px solid #111" : "1px solid #ddd",
                        background: x ? "#FFE24D" : "#f9f9f9",
                        fontWeight: 700,
                        cursor: "pointer",
                        minWidth: 120,
                    },
                    "aria-pressed": x,
                    children: k,
                });
            },
            f = i > 0 ? Math.max(1, i - 1) : 1;
        return (0, s.jsxs)("div", {
            style: { width: "100%", boxSizing: "border-box", position: "relative", zIndex: 0 },
            children: [
                (0, s.jsx)("div", {
                    ref: u,
                    style: {
                        position: "sticky",
                        top: r,
                        zIndex: f,
                        background: "#fff",
                        borderBottom: "1px solid #eee",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                    },
                    children: (0, s.jsxs)("div", {
                        style: {
                            maxWidth: 1200,
                            margin: "0 auto",
                            padding: "10px 12px",
                            display: "flex",
                            gap: 8,
                            justifyContent: "center",
                        },
                        children: [
                            (0, s.jsx)(g, { id: "wattstone", label: "Wattstone" }),
                            (0, s.jsx)(g, { id: "wandpv", label: "WandPV" }),
                            (0, s.jsx)(g, { id: "zaunpv", label: "ZaunPV" }),
                        ],
                    }),
                }),
                (0, s.jsxs)("div", {
                    style: { padding: "12px", background: "#f5f5f7" },
                    children: [
                        t === "wattstone" && (0, s.jsx)(_h, { stickyTop: m }),
                        t === "wandpv" && (0, s.jsx)(Sh, { stickyTop: m }),
                        t === "zaunpv" && (0, s.jsx)(xh, { stickyTop: m }),
                    ],
                }),
            ],
        });
    }
    var Md = nn(Qr(), 1);
    function zh(e, t = {}) {
        if (!e) throw new Error("mount(el) requires a DOM element");
        let n = (0, Cd.createRoot)(e);
        return n.render((0, Md.jsx)(Bs, { initialTab: t.initialTab || "wattstone" })), { unmount: () => n.unmount() };
    }
    return qd(Eh);
})(); /*! Bundled license information:

react/cjs/react.production.min.js:
  (**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

scheduler/cjs/scheduler.production.min.js:
  (**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-dom/cjs/react-dom.production.min.js:
  (**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react/cjs/react-jsx-runtime.production.min.js:
  (**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=/s/files/1/0646/1407/2579/files/wattstone-configurator.umd.js.map?v=1759897973
